webpackJsonp([15,13],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _assign = __webpack_require__(51);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(30);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(343);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueRouter = __webpack_require__(402);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(47);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueI18n = __webpack_require__(341);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	__webpack_require__(291);
	
	var _elementUi = __webpack_require__(45);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	__webpack_require__(290);
	
	var _vueLazyload = __webpack_require__(342);
	
	var _vueLazyload2 = _interopRequireDefault(_vueLazyload);
	
	var _en = __webpack_require__(277);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _zhCN = __webpack_require__(102);
	
	var _zhCN2 = _interopRequireDefault(_zhCN);
	
	var _th = __webpack_require__(278);
	
	var _th2 = _interopRequireDefault(_th);
	
	var _zhTW = __webpack_require__(280);
	
	var _zhTW2 = _interopRequireDefault(_zhTW);
	
	var _vi = __webpack_require__(279);
	
	var _vi2 = _interopRequireDefault(_vi);
	
	var _all = __webpack_require__(182);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _routes = __webpack_require__(190);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _store = __webpack_require__(191);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueI18n2.default);
	_vue2.default.use(_elementUi2.default);
	_vue2.default.use(_vueLazyload2.default);
	
	var cuLang = localStorage.getItem('cuLang');
	var locLang = navigator.language;
	if (!cuLang) {
	    if (locLang === 'zh-CN' || locLang === 'en-US' || locLang === 'th-TH' || locLang === 'zh-TW' || locLang === 'vi-VN') {
	        _vue2.default.config.lang = locLang;
	    } else {
	        _vue2.default.config.lang = 'en-US';
	    }
	} else {
	    _vue2.default.config.lang = cuLang;
	}
	var zhCnLocales = {};
	var enUsLocales = {};
	var thThLocales = {};
	var zhTwLocales = {};
	var viTwLocales = {};
	(0, _keys2.default)(_all2.default).forEach(function (langKey) {
	    zhCnLocales[langKey] = _all2.default[langKey]['zh-CN'];
	    enUsLocales[langKey] = _all2.default[langKey]['en-US'];
	    thThLocales[langKey] = _all2.default[langKey]['th-TH'];
	    zhTwLocales[langKey] = _all2.default[langKey]['zh-TW'];
	    viTwLocales[langKey] = _all2.default[langKey]['vi-VN'];
	});
	
	_vue2.default.locale('zh-CN', (0, _assign2.default)(zhCnLocales, _zhCN2.default));
	_vue2.default.locale('en-US', (0, _assign2.default)(enUsLocales, _en2.default));
	_vue2.default.locale('th-TH', (0, _assign2.default)(thThLocales, _th2.default));
	_vue2.default.locale('zh-TW', (0, _assign2.default)(zhTwLocales, _zhTW2.default));
	_vue2.default.locale('vi-VN', (0, _assign2.default)(viTwLocales, _vi2.default));
	
	var router = new _vueRouter2.default({
	    mode: 'history',
	    routes: _routes2.default,
	    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
	        return { x: 0, y: 0 };
	    }
	});
	
	router.beforeEach(function (_ref, from, next) {
	    var meta = _ref.meta,
	        path = _ref.path;
	
	    _store2.default.commit('setLoginPath', '');
	    var _meta$auth = meta.auth,
	        auth = _meta$auth === undefined ? true : _meta$auth;
	
	    var isLogin = Boolean(_store2.default.state.user.accessToken);
	    if (auth && !isLogin) {
	        _store2.default.commit('setLoginPath', path);
	        return _store2.default.commit('controlLoginPopup', true);
	    }
	    next();
	});
	
	_vue2.default.http.options.root = ("/api");
	
	_vue2.default.use(_vueLazyload2.default, {
	    preLoad: 1.3,
	    loading: 'static/img/partial/loading.svg',
	    attempt: 1
	});
	
	var vm = new _vue2.default({
	    el: '#app',
	    template: '<App/>',
	    components: { App: _App2.default },
	    router: router,
	    store: _store2.default
	});

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var USER_LOGIN = exports.USER_LOGIN = 'USER_LOGIN';
	var USER_LOGOUT = exports.USER_LOGOUT = 'USER_LOGOUT';
	var USER_REGISTER = exports.USER_REGISTER = 'USER_REGISTER';
	
	var GET_RECORDS = exports.GET_RECORDS = 'GET_RECORDS';
	var SET_RECORDS = exports.SET_RECORDS = 'SET_RECORDS';
	
	var GET_APP_LIST = exports.GET_APP_LIST = 'GET_APP_LIST';
	var SET_APP_LIST = exports.SET_APP_LIST = 'SET_APP_LIST';
	var GET_GOODS_LIST = exports.GET_GOODS_LIST = 'GET_GOODS_LIST';
	var SET_GOODS_LIST = exports.SET_GOODS_LIST = 'SET_GOODS_LIST';
	var GET_USER_PLAYED_GAME = exports.GET_USER_PLAYED_GAME = 'GET_USER_PLAYED_GAME';
	var SET_USER_PLAYED_GAME = exports.SET_USER_PLAYED_GAME = 'SET_USER_PLAYED_GAME';
	var GET_SERVER_LIST = exports.GET_SERVER_LIST = 'GET_SERVER_LIST';
	var SET_SERVER_LIST = exports.SET_SERVER_LIST = 'SET_SERVER_LIST';
	var GET_ROLE_INFO = exports.GET_ROLE_INFO = 'GET_ROLE_INFO';
	var EG_BUY_GOODS = exports.EG_BUY_GOODS = 'EG_BUY_GOODS';

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(84);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enjoyUrl = 'https://egplatform.enjoygame.com:7093/';
	
	var isTest = false;
	exports.default = {
	    enjoyUrl: enjoyUrl,
	    isTest: isTest,
	    methods: {
	        setStorageItem: function setStorageItem(key, value) {
	            if (value instanceof Object) {
	                value = (0, _stringify2.default)(value);
	            }
	            localStorage.setItem(key, value);
	            var timeStamp = Date.parse(new Date()) / 1000;
	            var jsonObj = { 'time': timeStamp, 'ttl': 600 };
	            localStorage.setItem(key + '_time', (0, _stringify2.default)(jsonObj));
	        },
	        getStorageItem: function getStorageItem(key) {
	            var str = localStorage.getItem(key + '_time');
	            if (str) {
	                var obj = JSON.parse(str);
	                var curTime = Date.parse(new Date()) / 1000;
	                if (Math.abs(curTime - obj.time) >= obj.ttl) {
	                    localStorage.removeItem(key + '_time');
	                    localStorage.removeItem(key);
	                    return false;
	                } else {
	                    return localStorage.getItem(key);
	                }
	            }
	            localStorage.removeItem(key + '_time');
	            localStorage.removeItem(key);
	            return false;
	        }
	    }
	};

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(47);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _blueimpMd = __webpack_require__(17);
	
	var _blueimpMd2 = _interopRequireDefault(_blueimpMd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	exports.default = {
	    login: function login(user, success_callback, fail_callback) {
	        _vue2.default.http.post('user/login', {
	            account: user.account,
	            password: user.password
	        }).then(function (response) {
	            var apiResult = response.data;
	            var apiCode = parseInt(apiResult.code);
	            if (apiCode === 0) {
	                success_callback(apiResult.result.loginData);
	                window.location.reload();
	            } else {
	                fail_callback(apiCode);
	            }
	        }, function () {
	            fail_callback(-1);
	        });
	    },
	    register: function register(user, success_callback, fail_callback) {
	        _vue2.default.http.post('user/create', {
	            account: user.account,
	            password: user.password
	        }).then(function (response) {
	            var apiResult = response.data;
	            var apiCode = parseInt(apiResult.code);
	            if (apiCode === 0) {
	                success_callback(apiResult.result.loginData);
	                window.location.reload();
	            } else {
	                fail_callback(apiCode);
	            }
	        }, function () {
	            fail_callback(-1);
	        });
	    },
	    getEg: function getEg(uid, callback) {
	        _vue2.default.http.get('store/get_eg?uid=' + uid).then(function (response) {
	            var apiResult = response.data;
	            var apiCode = apiResult.code;
	            if (apiCode == 0) {
	                callback(apiResult.result);
	            }
	        });
	    }
	};

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Header = __webpack_require__(360);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(359);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'app',
	    components: {
	        ViewHeader: _Header2.default, ViewFooter: _Footer2.default
	    },
	    mounted: function mounted() {}
	};

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _global = __webpack_require__(22);
	
	var _global2 = _interopRequireDefault(_global);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cuLang = void 0;
	if (localStorage.getItem('cuLang')) {
	    cuLang = localStorage.getItem('cuLang');
	} else {
	    cuLang = navigator.language;
	    localStorage.setItem('cuLang', cuLang);
	}
	var locLang = 'English';
	if (cuLang === 'zh-CN') {
	    locLang = '简体中文';
	} else if (cuLang === 'th-TH') {
	    locLang = 'ภาษาไทย';
	} else if (cuLang === 'zh-TW') {
	    locLang = '繁體中文';
	} else if (cuLang === 'vi-VN') {
	    locLang = 'Tiếng việt';
	}
	exports.default = {
	    data: function data() {
	        return {
	            options: [{
	                value: 'zh-CN',
	                label: '简体中文'
	            }, {
	                value: 'en-US',
	                label: 'English'
	            }, {
	                value: 'th-TH',
	                label: 'ภาษาไทย'
	            }, {
	                value: 'zh-TW',
	                label: '繁體中文'
	            }, {
	                value: 'vi-VN',
	                label: 'Tiếng việt'
	            }],
	            value4: locLang,
	            global: _global2.default
	        };
	    },
	
	    computed: {
	        currentLang: function currentLang() {
	            return _vue2.default.config.lang;
	        }
	    },
	    methods: {
	        changeLang: function changeLang(lang) {
	            _vue2.default.config.lang = lang;
	
	            localStorage.setItem('cuLang', lang);
	        },
	        clearCache: function clearCache() {
	            localStorage.removeItem('carouselData');
	            localStorage.removeItem('carouselData_time');
	
	            localStorage.removeItem('nearNewsData');
	            localStorage.removeItem('nearNewsData_time');
	
	            localStorage.removeItem('hotGameData');
	            localStorage.removeItem('hotGameData_time');
	
	            localStorage.removeItem('gameCenterData');
	            localStorage.removeItem('gameCenterData_time');
	
	            localStorage.removeItem('newsData');
	            localStorage.removeItem('newsData_time');
	        }
	    }
	};

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(47);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _blueimpMd = __webpack_require__(17);
	
	var _blueimpMd2 = _interopRequireDefault(_blueimpMd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	function getBrowser() {
	    var ua = navigator.userAgent,
	        tem = void 0,
	        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
	    if (/trident/i.test(M[1])) {
	        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
	        return { name: 'IE', version: tem[1] || '' };
	    }
	    if (M[1] === 'Chrome') {
	        tem = ua.match(/\bOPR|Edge\/(\d+)/);
	        if (tem != null) {
	            return { name: 'Opera', version: tem[1] };
	        }
	    }
	    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
	    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
	        M.splice(1, 1, tem[1]);
	    }
	    return {
	        name: M[0],
	        version: M[1]
	    };
	}
	
	exports.default = {
	    getAppList: function getAppList(success_callback, fail_callback) {
	        _vue2.default.http.get('store/get_app').then(function (response) {
	            var apiResult = response.data;
	            var apiCode = parseInt(apiResult.code);
	            if (apiCode === 0) {
	                success_callback(apiResult.result.appList);
	            } else {
	                fail_callback(apiCode);
	            }
	        }, function () {
	            fail_callback(-1);
	        });
	    },
	    getGoodsList: function getGoodsList(appId, success_callback, fail_callback) {
	        _vue2.default.http.get('store/get_app_goods?app_id=' + appId).then(function (response) {
	            var apiResult = response.data;
	            var apiCode = apiResult.code;
	            if (apiCode == 0) {
	                var goods = {
	                    appId: appId,
	                    goodsList: apiResult.result.goodsList
	                };
	                success_callback(goods);
	            } else {
	                fail_callback(apiCode);
	            }
	        }, function () {
	            fail_callback(-1);
	        });
	    },
	    getPlayedGames: function getPlayedGames(params, success_callback, fail_callback) {
	        _vue2.default.http.get('store/get_played_app?uid=' + params.uid + '&token=' + params.accessToken).then(function (response) {
	            var apiResult = response.data;
	            var apiCode = apiResult.code;
	            if (apiCode == 0) {
	                success_callback(apiResult.result.appList);
	            } else {
	                fail_callback(apiCode);
	            }
	        }, function () {
	            fail_callback(-1);
	        });
	    },
	    getServerList: function getServerList(params, success_callback, fail_callback) {
	        _vue2.default.http.get('store/get_server?uid=' + params.uid + '&app_id=' + params.appId + '&area_id=' + params.areaId).then(function (response) {
	            var apiResult = response.data;
	            var apiCode = apiResult.code;
	            if (apiCode == 0) {
	                success_callback(apiResult.result.server_list);
	            } else {
	                fail_callback(apiCode);
	            }
	        }, function () {
	            fail_callback(-1);
	        });
	    },
	    getRoleInfo: function getRoleInfo(params, success_callback, fail_callback) {
	        _vue2.default.http.get('store/get_role?uid=' + params.uid + '&app_id=' + params.appId + '&area_id=' + params.areaId + '&server_id=' + params.serverId + '&cp_uid=' + params.cpUid + '&token=' + params.token).then(function (response) {
	            var apiResult = response.data;
	            var apiCode = apiResult.code;
	            if (apiCode == 0) {
	                success_callback(apiResult.result.role_infos);
	            } else {
	                fail_callback(apiCode);
	            }
	        }, function () {
	            fail_callback(-1);
	        });
	    },
	    egBuyGoods: function egBuyGoods(params, success_callback, fail_callback) {
	        params.browserName = getBrowser().name;
	        params.browserVersion = getBrowser().version;
	        params.password = (0, _blueimpMd2.default)(params.password);
	
	        _vue2.default.http.post('store/pay', params).then(function (response) {
	            success_callback(response.data);
	        }, function () {
	            fail_callback(-1);
	        });
	    }
	};

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(47);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	exports.default = {
	    getRecords: function getRecords(params, success_callback, fail_callback) {
	        var query = '?uid=' + params.uid + '&page=' + params.page + '&order_status=' + params.recordsStatus + '&start_date=' + params.startDate + '&end_date=' + params.endDate;
	        var apiUrl = '';
	        var records = params;
	        if (params.recordsType == 'consume') {
	            apiUrl = 'store/records' + query;
	            records.recordsType = 'consume';
	        } else {
	            apiUrl = 'recharge/records' + query;
	            records.recordsType = 'recharge';
	        }
	
	        _vue2.default.http.get(apiUrl).then(function (response) {
	            var apiResult = response.data;
	            var apiCode = parseInt(apiResult.code);
	            if (apiCode === 0) {
	                var recordsData = [];
	                if (params.recordsType == 'consume') {
	                    recordsData = apiResult.result.consumeOrderList;
	                } else {
	                    recordsData = apiResult.result.rechargeOrderList;
	                }
	                records.data = recordsData;
	                success_callback(records);
	            } else {
	                fail_callback(apiCode);
	            }
	        }, function () {
	            fail_callback(-1);
	        });
	    }
	};

/***/ }),

/***/ 181:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  aboutEg: {
	    'zh-CN': '关于Enjoy Game',
	    'zh-TW': '關於Enjoy Game',
	    'en-US': 'About EnjoyGame',
	    'th-TH': 'เกี่ยวกับ Enjoy Game',
	    'vi-VN': 'About EnjoyGame'
	  },
	  aboutEgP1: {
	    'zh-CN': 'Enjoy Game成立于2015年，核心成员均有八年以上行业经验，公司致力于将中国精品手机游戏发行到海外全球市场，以专业谋求更快速发展，以实力打造更优质精品，形成了独有的行业品牌和口碑。',
	    'zh-TW': 'Enjoy Game 遊戲成立於2015年，核心成員均有八年以上行業經驗，公司致力於將中國精品手機遊戲發行到海外全球市場，以專業謀求更快速發展，以實力打造更優質精品，形成了獨有的行業品牌和口碑。',
	    'en-US': 'Enjoy Game was established in 2015. The core members have more than 8 years of professional experience. The company is committed to distribute Chinese boutique mobile games to overseas markets. With several boutique products distributed, we already own a unique brand and reputation. And we are seeking for faster development with our professional ability!',
	    'th-TH': 'ค่าย Enjoy Game ก่อตั้งขึ้นในปี 2015 พนักงานหลักต่างก็มีประสบการณ์มากกว่า 8 ปี เป็นบริษัทที่ให้บริการเกมส์มือถือทั่วโลก เราใส่ใจในคุณภาพของเกมส์เป็นที่สุด จึงกลายเป็นหนึ่งในบริษัทเกมส์ที่มีชื่อเสียง',
	    'vi-VN': 'Enjoy Game was established in 2015. The core members have more than 8 years of professional experience. The company is committed to distribute Chinese boutique mobile games to overseas markets. With several boutique products distributed, we already own a unique brand and reputation. And we are seeking for faster development with our professional ability!'
	  },
	  aboutEgP2: {
	    'zh-CN': '2015年到2016年上半年,Enjoy Game主攻港澳台、东南亚市场,2016年Q2开始开拓全球多语言市场, 均取得显著成功, 所发行的《天堂战记 Lineage War》《梦幻神域》等游戏,多次被谷歌苹果推荐,均 最高取得下载TOP1-3,畅销TOP1-5 的成绩。',
	    'zh-TW': '2015年到2016年上半年，Enjoy Game主攻港澳台、東南亞市場，2016年Q2開始開拓全球多語言市場，均取得顯著成功，所發行的《Paradise War》《Sword of Fantasy》等遊戲，多次被谷歌蘋果推薦，均 最高取得下載TOP1-3，暢銷TOP1-5 的成績。',
	    'en-US': 'From 2015 to the first six months of 2016, EnjoyGame aimed specially at the markets of Hong Kong, Macao and Southeast Asia. Now, we have begun to develop the global multi-lingual market and have achieved remarkable success. Our games "Paradise War" and "Sword of Fantasy" have been featured repeatedly by Google Play and App Store, with Top Download rank 1-3, and Top Grossing rank1-5.',
	    'th-TH': 'From 2015 to the first six months of 2016, EnjoyGame aimed specially at the markets of Hong Kong, Macao and Southeast Asia. Now, we have begun to develop the global multi-lingual market and have achieved remarkable success. Our games "Paradise War" and "Sword of Fantasy" have been featured repeatedly by Google Play and App Store, with Top Download rank 1-3, and Top Grossing rank1-5.',
	    'vi-VN': 'From 2015 to the first six months of 2016, EnjoyGame aimed specially at the markets of Hong Kong, Macao and Southeast Asia. Now, we have begun to develop the global multi-lingual market and have achieved remarkable success. Our games "Paradise War" and "Sword of Fantasy" have been featured repeatedly by Google Play and App Store, with Top Download rank 1-3, and Top Grossing rank1-5.'
	  },
	  brandAdvantage: {
	    'zh-CN': '品牌优势',
	    'zh-TW': '品牌優勢',
	    'en-US': 'Our Advantages',
	    'th-TH': 'Our Advantages',
	    'vi-VN': 'Our Advantages'
	  },
	  operationTitle: {
	    'zh-CN': '卓越的运营能力',
	    'zh-TW': '卓越的運營能力',
	    'en-US': 'Excellent operation capacity',
	    'th-TH': 'Excellent operation capacity',
	    'vi-VN': 'Excellent operation capacity'
	  },
	  operationItem1: {
	    'zh-CN': '产品识别能力',
	    'zh-TW': '產品識別能力',
	    'en-US': 'Product identification capability',
	    'th-TH': 'Product identification capability',
	    'vi-VN': 'Product identification capability'
	  },
	  operationItem2: {
	    'zh-CN': '产品调优能力',
	    'zh-TW': '產品調優能力',
	    'en-US': 'Product optimization capability',
	    'th-TH': 'Product optimization capability',
	    'vi-VN': 'Product optimization capability'
	  },
	  operationItem3: {
	    'zh-CN': '持续运营能力',
	    'zh-TW': '持續運營能力',
	    'en-US': 'Continuous operation capacity',
	    'th-TH': 'Continuous operation capacity',
	    'vi-VN': 'Continuous operation capacity'
	  },
	  saleTitle: {
	    'zh-CN': '领先的营销能力',
	    'zh-TW': '領先的營銷能力',
	    'en-US': 'Leading marketing capability',
	    'th-TH': 'Leading marketing capability',
	    'vi-VN': 'Leading marketing capability'
	  },
	  saleItem1: {
	    'zh-CN': '全球采量能力',
	    'zh-TW': '全球採量能力',
	    'en-US': 'Attracting global players capacity',
	    'th-TH': 'Attracting global players capacity',
	    'vi-VN': 'Attracting global players capacity'
	  },
	  saleItem2: {
	    'zh-CN': '持续优化能力',
	    'zh-TW': '持續優化能力',
	    'en-US': 'Continuous optimization capability',
	    'th-TH': 'Continuous optimization capability',
	    'vi-VN': 'Continuous optimization capability'
	  },
	  saleItem3: {
	    'zh-CN': '全面包装能力',
	    'zh-TW': '全面包裝能力',
	    'en-US': 'Global package capacity',
	    'th-TH': 'Global package capacity',
	    'vi-VN': 'Global package capacity'
	  },
	  techTitle: {
	    'zh-CN': '强大的技术支持',
	    'zh-TW': '強大的技術支持',
	    'en-US': 'Powerful technical support',
	    'th-TH': 'Powerful technical support',
	    'vi-VN': 'Powerful technical support'
	  },
	  techItem1: {
	    'zh-CN': '快速的对接流程',
	    'zh-TW': '快速的對接流程',
	    'en-US': 'Fast docking process',
	    'th-TH': 'Fast docking process',
	    'vi-VN': 'Fast docking process'
	  },
	  techItem2: {
	    'zh-CN': '强大的数据分析能力',
	    'zh-TW': '強大的數據分析能力',
	    'en-US': 'Powerful data analysis capability',
	    'th-TH': 'Powerful data analysis capability',
	    'vi-VN': 'Powerful data analysis capability'
	  },
	  techItem3: {
	    'zh-CN': '高度定制化的数据采集能力',
	    'zh-TW': '高度定制化的數據採集能力',
	    'en-US': 'Highly customizable data acquisition capability',
	    'th-TH': 'Highly customizable data acquisition capability',
	    'vi-VN': 'Highly customizable data acquisition capability'
	  },
	  history: {
	    'zh-CN': '发展历程',
	    'zh-TW': '發展歷程',
	    'en-US': 'Development',
	    'th-TH': 'กระบวนการพัฒนา',
	    'vi-VN': 'Development'
	  },
	  history201801: {
	    'zh-CN': '《诺文尼亚》繁体版知名CV杉山纪章、柿原徹也强势助力献声，上线当周风靡台港澳地区，数十几媒体联袂推荐。',
	    'zh-TW': '2018/01《諾文尼亞》繁體版知名CV杉山紀章，柿原徹也強勢助力獻聲，上線當周風靡台港澳地區，數十幾媒體聯袂推薦。',
	    'en-US': 'Novenia-The famous CVs Sugiyama Noriaki and Kakihara Tetsuya of traditional version dedicate their beautiful voices. Once online, it went popular within one week in Taiwan, Hong Kong and Macao and was recommended by dozens of media.',
	    'th-TH': '《Novenia》ฉบับจีนตัวเต็มพากย์โดย CVที่มีชื่อสียง Sugiyama NoriakiและKakihara Tetsuya ในสัปดาห์ที่เปิดOBTนั้น ก็ได้รับความนิยมในฮ่องกง มาเก๊าและไต้หวัน และได้รับคำแนะนำจากสื่อหลายสิบแห่ง',
	    'vi-VN': 'Novenia-The famous CVs Sugiyama Noriaki and Kakihara Tetsuya of traditional version dedicate their beautiful voices. Once online, it went popular within one week in Taiwan, Hong Kong and Macao and was recommended by dozens of media.'
	  },
	  history201711: {
	    'zh-CN': '《Luna  M》港澳台地区重磅上线，荣获双端商店推荐，韩国端游IP正版授权，100%极致还原Luna经典，玩家好评如潮。',
	    'zh-TW': '《Luna M》港澳台地區重磅上線，榮獲雙端商店推薦，韓國端遊IP正版授權，100％極致還原Luna經典，玩家好評如潮。',
	    'en-US': 'Luna M-Launched in Taiwan, Hong Kong and Macao, it was featured by both Google Play Store and App Store. With the authentic IP of the original Korean console game, it restored 100% the classical Luna and won great reputation from players.',
	    'th-TH': '《Luna  M》เปิดOBTในฮ่องกง มาเก๊าและไต้หวัน  ได้รับคำแนะนำจากApplestoreและGoogleplay เกมนี้ได้รับอนุญาตอย่างเป็นทางการจากLUNA Online และได้รักษาความคลาสสิคของตัวเกมไว้อย่างครบถ้วน ได้รับความนิยมจากผู้เล่นเป็นอย่างมาก',
	    'vi-VN': 'Luna M-Launched in Taiwan, Hong Kong and Macao, it was featured by both Google Play Store and App Store. With the authentic IP of the original Korean console game, it restored 100% the classical Luna and won great reputation from players.'
	  },
	  history201709: {
	    'zh-CN': '《Dynasty Legends-ไทย》泰国火热上线，Boy_pakorn、Punpun_sutatta现场热力助阵，Arisara Karbdecho倾情代言！',
	    'zh-TW': '《Dynasty Legends-ไทย》泰國火熱上線，Boy_pakorn，Punpun_sutatta現場熱力助陣，Arisara Karbdecho傾情代言！',
	    'en-US': 'Dynasty Legends-ไทย-Hot online in Thailand! Boy Pakorn and Punpun Sutatta gave their strong support on the live show. And Arisara Karbdecho acted as the endorser!',
	    'th-TH': '《Dynasty Legends-ไทย》เปิดOBTในประเทศไทย Boy_pakorn、Punpun_sutattaมาช่วยพลังใจให้ และมีArisara Karbdechoมาเป็นพรีเซนเตอร์ด้วย',
	    'vi-VN': 'Dynasty Legends-ไทย-Hot online in Thailand! Boy Pakorn and Punpun Sutatta gave their strong support on the live show. And Arisara Karbdecho acted as the endorser!'
	  },
	  history201708: {
	    'zh-CN': '《극무쌍》韩国，核心战斗割草的极致体验得到了玩家大力的称赞。',
	    'zh-TW': '《극무쌍》韓國，核心戰鬥割草的極致體驗得到了玩家大力的稱讚。',
	    'en-US': '극무쌍-Online in Korea, its ultimate combat experience won great praises from players.',
	    'th-TH': '《극무쌍》วิธีการเล่นต่อสู้ได้รับความชื่นชมจากผู้เล่นของประเทศเกาหลีใต้',
	    'vi-VN': '극무쌍-Online in Korea, its ultimate combat experience won great praises from players.'
	  },
	  history201707: {
	    'zh-CN': '《Dynasty Legends》东南亚英文版燃情来袭，真3D三国动作手游！',
	    'zh-TW': '《Dynasty Legends》東南亞英文版燃情來襲，真3D三國動作手游！',
	    'en-US': 'Dynasty Legends-Southeast Asia English version struck. Real 3D action game of the Three Kingdoms!',
	    'th-TH': '《Dynasty Legends》ฉบับอังกฤษเปิดOBTในเอเชียตะวันออกเฉียงใต้ เป็นเกมแอ็กชันสามก๊ก 3D',
	    'vi-VN': 'Dynasty Legends-Southeast Asia English version struck. Real 3D action game of the Three Kingdoms!'
	  },
	  history201705: {
	    'zh-CN': '《崩坏3rd》繁体版与米哈游联合发行台港澳地区，点燃ACG动作之魂，为世界上所有的美好而战！',
	    'zh-TW': '《崩壞3rd》繁體版與米哈遊聯合發行台港澳地區，點燃ACG動作之魂，為世界上所有的美好而戰！',
	    'en-US': ' Honkai Impact 3 -Traditional version. Cooperated with miHoYo, we distributed it in Taiwan, Hong Kong and Macao. Ignite the soul of ACG action, fight for all the goodness in the world!',
	    'th-TH': '《Honkai Impact》ฉบับจีนตัวเต็มเปิดOBTร่วมมือกับบริษัท miHoYoอยู่ในฮ่องกง มาเก๊าและไต้หวัน เกมACG ต่อสู้เพื่อความสวยงามของโลก！',
	    'vi-VN': ' Honkai Impact 3 -Traditional version. Cooperated with miHoYo, we distributed it in Taiwan, Hong Kong and Macao. Ignite the soul of ACG action, fight for all the goodness in the world!'
	  },
	  history201703: {
	    'zh-CN': '《极无双》一周内跻身台港双榜畅销前十，双端商店连续两周推荐，深受动作类玩家喜爱。',
	    'zh-TW': '《極無雙》一周內躋身台港雙榜暢銷前十，雙端商店連續兩週推薦，深受動作類玩家喜愛。',
	    'en-US': 'Dynasty Legends-Classed in the top ten in Grossing Chart within one week. Featured for two weeks by both Google Play Store and App Store. Action players’ favorite!',
	    'th-TH': '《Dynasty Legends》หลังจากเปิดOBTหนึ่งสัปดาห์ ฉบับจีนตัวเต็มเข้าชิงรายการที่ขายดีที่สุดของฮ่องกงและไต้หวัน ได้รับคำแนะนำจากApplestoreและGoogleplayต่อเนื่องสองอาทิตย์ ได้รับความนิยมจากผู้เล่นเป็นอย่างมาก',
	    'vi-VN': 'Dynasty Legends-Classed in the top ten in Grossing Chart within one week. Featured for two weeks by both Google Play Store and App Store. Action players’ favorite!'
	  },
	  history201702: {
	    'zh-CN': '《巴哈姆特之魂》台湾IOS强势登榜，总榜下载前五，畅销十五！',
	    'zh-TW': '《巴哈姆特之魂》台灣IOS強勢登榜，總榜下載前五，暢銷十五！',
	    'en-US': '《巴哈姆特之魂》台湾IOS强势登榜，总榜下载前五，畅销十五！',
	    'th-TH': '《巴哈姆特之魂》台湾IOS强势登榜，总榜下载前五，畅销十五！',
	    'vi-VN': '《巴哈姆特之魂》台湾IOS强势登榜，总榜下载前五，畅销十五！'
	  },
	  history201612: {
	    'zh-CN': '《Paradise War》获“谷歌最具竞争力游戏”奖项',
	    'zh-TW': '《Paradise War》獲“谷歌最具競爭力遊戲”獎項',
	    'en-US': '《Paradise War》获“谷歌最具竞争力游戏”奖项',
	    'th-TH': '《Paradise War》获“谷歌最具竞争力游戏”奖项',
	    'vi-VN': '《Paradise War》获“谷歌最具竞争力游戏”奖项'
	  },
	  history201610: {
	    'zh-CN': '《エレメンタル ファンタジー》日本双榜下载前十，畅销前百',
	    'zh-TW': '《エレメンタル ファンタジー》日本雙榜下載前十，暢銷前百',
	    'en-US': '《エレメンタル ファンタジー》日本双榜下载前十，畅销前百',
	    'th-TH': '《エレメンタル ファンタジー》日本双榜下载前十，畅销前百',
	    'vi-VN': '《エレメンタル ファンタジー》日本双榜下载前十，畅销前百'
	  },
	  history201605: {
	    'zh-CN': '《Paradise War》上线全球，亚洲、欧洲多国下载畅销稳居前十',
	    'zh-TW': '《Paradise War》上線全球，亞洲、歐洲多國下載暢銷穩居前十',
	    'en-US': '《Paradise War》上线全球，亚洲、欧洲多国下载畅销稳居前十',
	    'th-TH': '《Paradise War》上线全球，亚洲、欧洲多国下载畅销稳居前十',
	    'vi-VN': '《Paradise War》上线全球，亚洲、欧洲多国下载畅销稳居前十'
	  },
	  history201603: {
	    'zh-CN': '月流水破千万',
	    'zh-TW': '月流水破千萬',
	    'en-US': '月流水破千万',
	    'th-TH': '月流水破千万',
	    'vi-VN': '月流水破千万'
	  },
	  history201602: {
	    'zh-CN': '《天域战记》台湾IOS创佳绩，下载畅销双榜前三！',
	    'zh-TW': '《天域戰記》台灣IOS創佳績，下載暢銷雙榜前三！',
	    'en-US': '《天域战记》台湾IOS创佳绩，下载畅销双榜前三！',
	    'th-TH': '《天域战记》台湾IOS创佳绩，下载畅销双榜前三！',
	    'vi-VN': '《天域战记》台湾IOS创佳绩，下载畅销双榜前三！'
	  },
	  history201601: {
	    'zh-CN': '《天域战记》台湾地区谷歌商店总榜下载第一，畅销第八！',
	    'zh-TW': '《天域戰記》台灣地區谷歌商店總榜下載第一，暢銷第八！',
	    'en-US': '《天域战记》台湾地区谷歌商店总榜下载第一，畅销第八！',
	    'th-TH': '《天域战记》台湾地区谷歌商店总榜下载第一，畅销第八！',
	    'vi-VN': '《天域战记》台湾地区谷歌商店总榜下载第一，畅销第八！'
	  },
	  history201511: {
	    'zh-CN': '《梦幻神域》上线东南亚，月流水破百万',
	    'zh-TW': '《夢幻神域》上線東南亞，月流水破百萬',
	    'en-US': '《梦幻神域》上线东南亚，月流水破百万',
	    'th-TH': '《梦幻神域》上线东南亚，月流水破百万',
	    'vi-VN': '《梦幻神域》上线东南亚，月流水破百万'
	  },
	  history201502: {
	    'zh-CN': 'EnjoyGame成立',
	    'zh-TW': 'EnjoyGame成立',
	    'en-US': 'EnjoyGame成立',
	    'th-TH': 'EnjoyGame成立',
	    'vi-VN': 'EnjoyGame成立'
	  },
	  haveGoodGame: {
	    'zh-CN': '有好的游戏产品？',
	    'zh-TW': '有好的遊戲產品？',
	    'en-US': 'Have good game products?',
	    'th-TH': 'Have good game products?',
	    'vi-VN': 'Have good game products?'
	  },
	  gotToSubmit: {
	    'zh-CN': '前往提交',
	    'zh-TW': '前往提交',
	    'en-US': 'Go to submit',
	    'th-TH': 'Go to submit',
	    'vi-VN': 'Go to submit'
	  }
	};

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(36);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _nav = __webpack_require__(186);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	var _home = __webpack_require__(185);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _store = __webpack_require__(189);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _business = __webpack_require__(183);
	
	var _business2 = _interopRequireDefault(_business);
	
	var _news = __webpack_require__(187);
	
	var _news2 = _interopRequireDefault(_news);
	
	var _games = __webpack_require__(184);
	
	var _games2 = _interopRequireDefault(_games);
	
	var _about = __webpack_require__(181);
	
	var _about2 = _interopRequireDefault(_about);
	
	var _notice = __webpack_require__(188);
	
	var _notice2 = _interopRequireDefault(_notice);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = (0, _extends3.default)({}, _nav2.default, _home2.default, _store2.default, _business2.default, _news2.default, _games2.default, _about2.default, _notice2.default);

/***/ }),

/***/ 183:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  content: {
	    'zh-CN': '作为专业的移动手机游戏发行公司，EnjoyGame<br />致力于将中国精品手机游戏输出和发行到海外市场。目前发<br />行范围覆盖港澳台、东南亚、亚太、欧美等上百个国家和地区。其发<br />行的《天域战记》、《幻想之刃》、《暗黑联盟》等多款产品在海外地区广受<br />欢迎，多次获得谷歌和苹果的推荐，在各榜单上均有优异表现。目前Enjoygame在持<br />续招贤纳士，并积极寻求与更多优秀的国内外产品和机构的合作。',
	    'zh-TW': '作為專業的移動手機遊戲發行公司，EnjoyGame<br />致力於將中國精品手機遊戲輸出和發行到海外市場。目前發<br />行範圍覆蓋港澳台、東南亞、亞太、歐美等上百個國家和地區。其發<br />行的《天域戰記》、《幻想之刃》、《暗黑聯盟》等多款產品在海外地區廣受<br />歡迎，多次獲得谷歌和蘋果的推薦，在各榜單上均有友誼表現。目前EnjoyGame在持<br />續招賢納士，并積極尋求與更多優秀的國內外產品和機構的合作。',
	    'en-US': 'As a professional mobile games distribution <br /> company, EnjoyGame is committed to output and distribute<br /> Chinese excellent mobile games to overseas markets.  The current<br /> distribution covers Hong Kong, Macao, Southeast Asia, Asia-Pacific, Europe and<br /> the United States, etc. more than 100 countries and regions. Our games-"Paradise War", <br />"Sword of Fantasy", "League Dark" and other products are popular overseas. And they are repeatedly<br /> featured by Google Play and App Store. Currently EnjoyGame is still looking for more excellent elites, <br />domestic and foreign products and institutions for cooperation.',
	    'th-TH': 'As a professional mobile games distribution <br /> company, EnjoyGame is committed to output and distribute<br /> Chinese excellent mobile games to overseas markets.  The current<br /> distribution covers Hong Kong, Macao, Southeast Asia, Asia-Pacific, Europe and<br /> the United States, etc. more than 100 countries and regions. Our games-"Paradise War", <br />"Sword of Fantasy", "League Dark" and other products are popular overseas. And they are repeatedly<br /> featured by Google Play and App Store. Currently EnjoyGame is still looking for more excellent elites, <br />domestic and foreign products and institutions for cooperation.'
	  },
	  cooperation: {
	    'zh-CN': '商务合作',
	    'zh-TW': '商務合作',
	    'en-US': 'Business Cooperation',
	    'th-TH': 'Business Cooperation'
	  },
	  hr: {
	    'zh-CN': '求职需求',
	    'zh-TW': '求職需求',
	    'en-US': 'Job Opportunities',
	    'th-TH': 'Job Opportunities'
	  },
	  cs: {
	    'zh-CN': '客服需求',
	    'zh-TW': '客服需求',
	    'en-US': 'Customer Service',
	    'th-TH': 'Customer Service'
	  },
	  haveGoodProduction: {
	    'zh-CN': '有好的游戏产品？',
	    'zh-TW': '有好的遊戲產品？',
	    'en-US': 'Have good production?',
	    'th-TH': 'Have good production?'
	  },
	  goToSubmit: {
	    'zh-CN': '前往提交',
	    'zh-TW': '前往提交',
	    'en-US': 'Submit',
	    'th-TH': 'Submit'
	  }
	};

/***/ }),

/***/ 184:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  ttzj: {
	    'zh-CN': '天域战记',
	    'zh-TW': '天域戰記',
	    'en-US': 'Paradise War',
	    'th-TH': 'Paradise War'
	  },
	  mhsy: {
	    'zh-CN': '梦幻神域',
	    'zh-TW': '夢幻神域',
	    'en-US': 'Sword of Fantasy',
	    'th-TH': 'Sword of Fantasy'
	  },
	  bhmtzh: {
	    'zh-CN': '巴赫姆特之魂',
	    'zh-TW': '巴哈姆特之魂',
	    'en-US': 'Dragon Hunter',
	    'th-TH': 'Dragon Hunter'
	  },
	  jws: {
	    'zh-CN': '極無雙',
	    'zh-TW': '極無雙',
	    'en-US': 'Dynasty Legends',
	    'th-TH': 'Dynasty Legends'
	  },
	  luna: {
	    'zh-CN': 'lunaM',
	    'zh-TW': 'LunaM',
	    'en-US': 'lunaM',
	    'th-TH': 'lunaM'
	  },
	  download: {
	    'zh-CN': 'Apk下载',
	    'zh-TW': 'APK下載',
	    'en-US': 'Apk Download',
	    'th-TH': 'Apk Download'
	  }
	};

/***/ }),

/***/ 185:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  checkDetail: {
	    'zh-CN': '查看详情',
	    'zh-TW': '查看詳情',
	    'en-US': 'Check Detail',
	    'th-TH': 'Check Detail',
	    'vi-VN': 'Check Detail'
	  },
	  novenTitle1: {
	    'zh-CN': '銳意革新 拒絕相似！',
	    'zh-TW': '銳意革新 拒絕相似！',
	    'en-US': '銳意革新 拒絕相似！',
	    'th-TH': '銳意革新 拒絕相似！',
	    'vi-VN': '銳意革新 拒絕相似！'
	  },
	  novenTitle2: {
	    'zh-CN': '《諾文尼亞》RPG與連珠的完美結合！',
	    'zh-TW': '《諾文尼亞》RPG與連珠的完美結合！',
	    'en-US': '《諾文尼亞》RPG與連珠的完美結合！',
	    'th-TH': '《諾文尼亞》RPG與連珠的完美結合！',
	    'vi-VN': '《諾文尼亞》RPG與連珠的完美結合！'
	  },
	  novenContent: {
	    'zh-CN': '2018開年鉅作，日式RPG奇幻冒險與連珠消除完美結合的【諾文尼亞】來啦！多位超一線聲優傾情助陣！宏大世界觀顛覆想象！多重連珠爽快Combo！快來一起體驗獨特連珠RPG的爽快戰鬥吧！',
	    'zh-TW': '2018開年鉅作，日式RPG奇幻冒險與連珠消除完美結合的【諾文尼亞】來啦！多位超一線聲優傾情助陣！宏大世界觀顛覆想象！多重連珠爽快Combo！快來一起體驗獨特連珠RPG的爽快戰鬥吧！',
	    'en-US': '2018開年鉅作，日式RPG奇幻冒險與連珠消除完美結合的【諾文尼亞】來啦！多位超一線聲優傾情助陣！宏大世界觀顛覆想象！多重連珠爽快Combo！快來一起體驗獨特連珠RPG的爽快戰鬥吧！',
	    'th-TH': '2018開年鉅作，日式RPG奇幻冒險與連珠消除完美結合的【諾文尼亞】來啦！多位超一線聲優傾情助陣！宏大世界觀顛覆想象！多重連珠爽快Combo！快來一起體驗獨特連珠RPG的爽快戰鬥吧！',
	    'vi-VN': '2018開年鉅作，日式RPG奇幻冒險與連珠消除完美結合的【諾文尼亞】來啦！多位超一線聲優傾情助陣！宏大世界觀顛覆想象！多重連珠爽快Combo！快來一起體驗獨特連珠RPG的爽快戰鬥吧！'
	  },
	  bhmtTitle1: {
	    'zh-CN': 'MMORPG鉅作《巴哈姆特之魂》',
	    'zh-TW': 'MMORPG鉅作《巴哈姆特之魂》',
	    'en-US': 'MMORPG鉅作《巴哈姆特之魂》',
	    'th-TH': 'MMORPG鉅作《巴哈姆特之魂》',
	    'vi-VN': 'MMORPG鉅作《巴哈姆特之魂》'
	  },
	  bhmtTitle2: {
	    'zh-CN': '火爆空降雙端榜單前列',
	    'zh-TW': '火爆空降雙端榜單前列',
	    'en-US': '火爆空降雙端榜單前列',
	    'th-TH': '火爆空降雙端榜單前列',
	    'vi-VN': '火爆空降雙端榜單前列'
	  },
	  jwsTitle1: {
	    'zh-CN': '熱血最強ARPG《極無雙》',
	    'zh-TW': '熱血最強ARPG《極無雙》',
	    'en-US': '熱血最強ARPG《極無雙》',
	    'th-TH': '熱血最強ARPG《極無雙》',
	    'vi-VN': '熱血最強ARPG《極無雙》'
	  },
	  jwsTitle2: {
	    'zh-CN': '暢爽無雙完美復刻',
	    'zh-TW': '暢爽無雙完美復刻',
	    'en-US': '暢爽無雙完美復刻',
	    'th-TH': '暢爽無雙完美復刻',
	    'vi-VN': '暢爽無雙完美復刻'
	  },
	  jwsContent: {
	    'zh-CN': '致敬經典，暢爽掌中無雙體驗！採用最新引擎打造的《極無雙》將為你還原熱血的三國戰場。宏大的場景，華麗的技能。用最輕鬆地操作打出最華麗的Combo，萬人同屏，千人連斬！',
	    'zh-TW': '致敬經典，暢爽掌中無雙體驗！採用最新引擎打造的《極無雙》將為你還原熱血的三國戰場。宏大的場景，華麗的技能。用最輕鬆地操作打出最華麗的Combo，萬人同屏，千人連斬！',
	    'en-US': '致敬經典，暢爽掌中無雙體驗！採用最新引擎打造的《極無雙》將為你還原熱血的三國戰場。宏大的場景，華麗的技能。用最輕鬆地操作打出最華麗的Combo，萬人同屏，千人連斬！',
	    'th-TH': '致敬經典，暢爽掌中無雙體驗！採用最新引擎打造的《極無雙》將為你還原熱血的三國戰場。宏大的場景，華麗的技能。用最輕鬆地操作打出最華麗的Combo，萬人同屏，千人連斬！',
	    'vi-VN': '致敬經典，暢爽掌中無雙體驗！採用最新引擎打造的《極無雙》將為你還原熱血的三國戰場。宏大的場景，華麗的技能。用最輕鬆地操作打出最華麗的Combo，萬人同屏，千人連斬！'
	  },
	  bhmtContent: {
	    'zh-CN': '全球首款人龍合體魔幻變身3D MMORPG震撼來襲上古龍神巴哈姆特滅世降臨 世界處於崩壞邊緣龍裔們！化身為龍守護世界！',
	    'zh-TW': '全球首款人龍合體魔幻變身3D MMORPG震撼來襲上古龍神巴哈姆特滅世降臨 世界處於崩壞邊緣龍裔們！化身為龍守護世界！',
	    'en-US': "全球首款人龍合體魔幻變身3D MMORPG震撼來襲上古龍神巴哈姆特滅世降臨 世界處於崩壞邊緣龍裔們！化身為龍守護世界！",
	    'th-TH': '全球首款人龍合體魔幻變身3D MMORPG震撼來襲上古龍神巴哈姆特滅世降臨 世界處於崩壞邊緣龍裔們！化身為龍守護世界！',
	    'vi-VN': '全球首款人龍合體魔幻變身3D MMORPG震撼來襲上古龍神巴哈姆特滅世降臨 世界處於崩壞邊緣龍裔們！化身為龍守護世界！'
	  },
	  appTitle1: {
	    'zh-CN': '《天域战记》全新銅像玩法',
	    'zh-TW': '《天域战记》全新銅像玩法',
	    'en-US': '《天域战记》全新銅像玩法',
	    'th-TH': '《天域战记》全新銅像玩法',
	    'vi-VN': '《天域战记》全新銅像玩法'
	  },
	  appDesc1: {
	    'zh-CN': '挑戰克隆傭兵，提升戰力！',
	    'zh-TW': '挑戰克隆傭兵，提升戰力！',
	    'en-US': '挑戰克隆傭兵，提升戰力！',
	    'th-TH': '挑戰克隆傭兵，提升戰力！',
	    'vi-VN': '挑戰克隆傭兵，提升戰力！'
	  },
	  appTitle2: {
	    'zh-CN': '《巴哈姆特之魂》震撼上线',
	    'zh-TW': '《巴哈姆特之魂》震撼上线',
	    'en-US': '《巴哈姆特之魂》震撼上线',
	    'th-TH': '《巴哈姆特之魂》震撼上线',
	    'vi-VN': '《巴哈姆特之魂》震撼上线'
	  },
	  appDesc2: {
	    'zh-CN': '即時PK、天梯排位，你能否傲視群雄？',
	    'zh-TW': '即時PK、天梯排位，你能否傲視群雄？',
	    'en-US': '即時PK、天梯排位，你能否傲視群雄？',
	    'th-TH': '即時PK、天梯排位，你能否傲視群雄？',
	    'vi-VN': '即時PK、天梯排位，你能否傲視群雄？'
	  },
	  lunaTitle1: {
	    'zh-CN': 'Q 版MMORPG神作復活！',
	    'zh-TW': 'Q 版MMORPG神作復活！',
	    'en-US': 'Q 版MMORPG神作復活！',
	    'th-TH': 'Q 版MMORPG神作復活！',
	    'vi-VN': 'Q 版MMORPG神作復活！'
	  },
	  lunaTitle2: {
	    'zh-CN': '《Luna M（首部曲）》萌動歸來！',
	    'zh-TW': '《Luna M（首部曲）》萌動歸來！',
	    'en-US': '《Luna M（首部曲）》萌動歸來！',
	    'th-TH': '《Luna M（首部曲）》萌動歸來！',
	    'vi-VN': '《Luna M（首部曲）》萌動歸來！'
	  },
	  lunaContent: {
	    'zh-CN': '時隔十年，經典线上游戏《LUNA ONLINE》正統續作歸來！《Luna M（首部曲）》完美復刻原作玩法，將經典LUNA帶進手機！次時代引擎打造，畫質全面升級，讓你更萌更可愛！新增多種強大社交功能，交友、結婚、合作、競爭，讓你終結孤單！《Luna M》可愛再升級！啾咪~',
	    'zh-TW': '時隔十年，經典线上游戏《LUNA ONLINE》正統續作歸來！《Luna M（首部曲）》完美復刻原作玩法，將經典LUNA帶進手機！次時代引擎打造，畫質全面升級，讓你更萌更可愛！新增多種強大社交功能，交友、結婚、合作、競爭，讓你終結孤單！《Luna M》可愛再升級！啾咪~',
	    'en-US': '時隔十年，經典线上游戏《LUNA ONLINE》正統續作歸來！《Luna M（首部曲）》完美復刻原作玩法，將經典LUNA帶進手機！次時代引擎打造，畫質全面升級，讓你更萌更可愛！新增多種強大社交功能，交友、結婚、合作、競爭，讓你終結孤單！《Luna M》可愛再升級！啾咪~',
	    'th-TH': '時隔十年，經典线上游戏《LUNA ONLINE》正統續作歸來！《Luna M（首部曲）》完美復刻原作玩法，將經典LUNA帶進手機！次時代引擎打造，畫質全面升級，讓你更萌更可愛！新增多種強大社交功能，交友、結婚、合作、競爭，讓你終結孤單！《Luna M》可愛再升級！啾咪~',
	    'vi-VN': '時隔十年，經典线上游戏《LUNA ONLINE》正統續作歸來！《Luna M（首部曲）》完美復刻原作玩法，將經典LUNA帶進手機！次時代引擎打造，畫質全面升級，讓你更萌更可愛！新增多種強大社交功能，交友、結婚、合作、競爭，讓你終結孤單！《Luna M》可愛再升級！啾咪~'
	  },
	  getLiked: {
	    'zh-CN': ' 人点赞',
	    'zh-TW': ' 人点赞',
	    'en-US': ' 人点赞',
	    'th-TH': ' 人点赞',
	    'vi-VN': ' 人点赞'
	  },
	  recentNews: {
	    'zh-CN': '最新资讯',
	    'zh-TW': '最新資訊',
	    'en-US': 'Latest News',
	    'th-TH': 'Latest News',
	    'vi-VN': 'Latest News'
	  },
	  aboutCompany: {
	    'zh-CN': '公司介绍',
	    'zh-TW': '公司介紹',
	    'en-US': 'About Company',
	    'th-TH': 'About Company',
	    'vi-VN': 'About Company'
	  },
	  boutique: {
	    'zh-CN': '精品',
	    'zh-TW': '精品',
	    'en-US': 'With competitive products',
	    'th-TH': 'With competitive products',
	    'vi-VN': 'With competitive products'
	  },
	  boutiqueDesc: {
	    'zh-CN': '所发游戏多次被谷歌／ios推荐',
	    'zh-TW': '所發遊戲多次被谷歌/ios推薦',
	    'en-US': 'Our games have been featured repeatedly by Google Play and App Store',
	    'th-TH': 'Our games have been featured repeatedly by Google Play and App Store',
	    'vi-VN': 'Our games have been featured repeatedly by Google Play and App Store'
	  },
	  professional: {
	    'zh-CN': '专业',
	    'zh-TW': '專業',
	    'en-US': 'Professional',
	    'th-TH': 'Professional',
	    'vi-VN': 'Professional'
	  },
	  professionalDesc: {
	    'zh-CN': '零运营事故',
	    'zh-TW': '零運營事故',
	    'en-US': 'No operational accident',
	    'th-TH': 'No operational accident',
	    'vi-VN': 'No operational accident'
	  },
	  fast: {
	    'zh-CN': '快速',
	    'zh-TW': '快速',
	    'en-US': 'With high-speed',
	    'th-TH': 'With high-speed',
	    'vi-VN': 'With high-speed'
	  },
	  fastDesc: {
	    'zh-CN': '半年内上线全球',
	    'zh-TW': '半年內上線全球',
	    'en-US': 'Launch one game worldwide within six months',
	    'th-TH': 'Launch one game worldwide within six months',
	    'vi-VN': 'Launch one game worldwide within six months'
	  },
	  hotGames: {
	    'zh-CN': '热门游戏',
	    'zh-TW': '熱門遊戲',
	    'en-US': 'Hot Games',
	    'th-TH': 'Hot Games',
	    'vi-VN': 'Hot Games'
	  },
	  partner: {
	    'zh-CN': '合作伙伴',
	    'zh-TW': '合作夥伴',
	    'en-US': 'Partner',
	    'th-TH': 'Partner',
	    'vi-VN': 'Partner'
	  },
	  gameType: {
	    'zh-CN': '游戏类型',
	    'zh-TW': '遊戲類型',
	    'en-US': 'Type',
	    'th-TH': 'Type',
	    'vi-VN': 'Type'
	  },
	  gameRating: {
	    'zh-CN': '游戏评分',
	    'zh-TW': '遊戲評分',
	    'en-US': 'Rating',
	    'th-TH': 'Rating',
	    'vi-VN': 'Rating'
	  },
	  goToSite: {
	    'zh-CN': '进入官网',
	    'zh-TW': '進入官網',
	    'en-US': 'Official Site',
	    'th-TH': 'Official Site',
	    'vi-VN': 'Official Site'
	  },
	  changeGames: {
	    'zh-CN': '换一批',
	    'zh-TW': '換一批',
	    'en-US': 'Change Games',
	    'th-TH': 'Change Games',
	    'vi-VN': 'Change Games'
	  },
	  typeNews: {
	    'zh-CN': '新闻',
	    'zh-TW': '新聞',
	    'en-US': 'News',
	    'th-TH': 'News',
	    'vi-VN': 'News'
	  }
	};

/***/ }),

/***/ 186:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    eg: {
	        'zh-CN': '英卓游戏',
	        'zh-TW': '英卓遊戲',
	        'en-US': 'Enjoy Game',
	        'th-TH': 'Enjoy Game',
	        'vi-VN': 'Enjoy Game'
	    },
	    eg_mengguo: {
	        'zh-CN': '萌果游戏',
	        'zh-TW': '萌果遊戲',
	        'en-US': 'Enjoy Game',
	        'th-TH': 'Enjoy Game',
	        'vi-VN': 'Enjoy Game'
	    },
	    home: {
	        'zh-CN': '首页',
	        'zh-TW': '首頁',
	        'en-US': 'Home',
	        'th-TH': 'หน้าหลัก',
	        'vi-VN': 'Trang chủ'
	    },
	    about: {
	        'zh-CN': '关于我们',
	        'zh-TW': '關於我們',
	        'en-US': 'About Us',
	        'th-TH': 'เกี่ยวกับเรา',
	        'vi-VN': 'Giới thiệu'
	    },
	    center: {
	        'zh-CN': '游戏中心',
	        'zh-TW': '遊戲中心',
	        'en-US': 'Game Center',
	        'th-TH': 'ศูนย์เกม',
	        'vi-VN': 'Trung tâm game'
	    },
	    store: {
	        'zh-CN': '在线商城',
	        'zh-TW': '在線商城',
	        'en-US': 'Online Shop',
	        'th-TH': 'ร้านค้าออนไลน์',
	        'vi-VN': 'Shop online'
	    },
	    business: {
	        'zh-CN': '商务合作',
	        'zh-TW': '商務合作',
	        'en-US': 'Business',
	        'th-TH': 'ธุรกิจ',
	        'vi-VN': 'Thương mại'
	    },
	    news: {
	        'zh-CN': '新闻资讯',
	        'zh-TW': '新聞資訊',
	        'en-US': 'News',
	        'th-TH': 'ข่าว',
	        'vi-VN': 'Thông tin'
	    },
	    recommendGame: {
	        'zh-CN': '推荐游戏',
	        'zh-TW': '推薦遊戲',
	        'en-US': 'Recommended Games',
	        'th-TH': 'Recommended Games',
	        'vi-VN': 'Recommended Games'
	    },
	    cooperation: {
	        'zh-CN': '商务合作：',
	        'zh-TW': '商務合作：',
	        'en-US': 'Cooperation: ',
	        'th-TH': 'Cooperation',
	        'vi-VN': 'Cooperation'
	    },
	    hr: {
	        'zh-CN': '求职需求：',
	        'zh-TW': '求職需求：',
	        'en-US': 'HR: ',
	        'th-TH': 'HR: ',
	        'vi-VN': 'HR: '
	    },
	    cs: {
	        'zh-CN': '客服需求：',
	        'zh-TW': '客服需求：',
	        'en-US': 'CS: ',
	        'th-TH': 'CS: ',
	        'vi-VN': 'CS: '
	    },
	    aboutCompany: {
	        'zh-CN': '作为专业的移动手机游戏发行公司，EnjoyGame致力于将中国精品手机游戏输出和发行到海外市场。目前发行范围覆盖港澳台、东南亚、亚太、欧美等上百个国家和地区。其发行的《天域战记》、《幻想之刃》、《暗黑联盟》等多款产品在海外地区广受欢迎，多次获得谷歌和苹果的推荐，在各榜单上均有优异表现。目前Enjoygame在持续招贤纳士，并积极寻求与更多优秀的国内外产品和机构的合作。',
	        'zh-TW': '作為專業的移動手機遊戲發行公司，EnjoyGame致力於將中國精品手機遊戲輸出和發行到海外市場。目前發行範圍覆蓋港澳台、東南亞、亞太、歐美等上百個國家和地區。其發行的《天域戰記》、《幻想之刃》、《暗黑聯盟》等多款產品在海外地區廣受歡迎，多次獲得谷歌和蘋果的推薦，在各榜單上均有友誼表現。目前EnjoyGame在持續招賢納士，并積極尋求與更多優秀的國內外產品和機構的合作。',
	        'en-US': 'EnjoyGame is a preeminent mobile game publisher, which aims at delivering the most outstanding mobile games in overseas markets. EnjoyGame publishes in many countries and regions, including Taiwan, South East Asia, Oceanic, North and South America and Europe. Paradise War, Sword of Fantasy, Dark League and more games have already been brought to international markets and received great reputation. Not only got great place on both AppStore and GooglePlay rankings, they also got multiple recommendations by AppStore and GooglePlay. EnjoyGame is recruiting now talented and passionate employees right now. We also hungered for more corporation with excellent developers and other partners globally. ',
	        'th-TH': 'EnjoyGame is a preeminent mobile game publisher, which aims at delivering the most outstanding mobile games in overseas markets. EnjoyGame publishes in many countries and regions, including Taiwan, South East Asia, Oceanic, North and South America and Europe. Paradise War, Sword of Fantasy, Dark League and more games have already been brought to international markets and received great reputation. Not only got great place on both AppStore and GooglePlay rankings, they also got multiple recommendations by AppStore and GooglePlay. EnjoyGame is recruiting now talented and passionate employees right now. We also hungered for more corporation with excellent developers and other partners globally. ',
	        'vi-VN': 'EnjoyGame is a preeminent mobile game publisher, which aims at delivering the most outstanding mobile games in overseas markets. EnjoyGame publishes in many countries and regions, including Taiwan, South East Asia, Oceanic, North and South America and Europe. Paradise War, Sword of Fantasy, Dark League and more games have already been brought to international markets and received great reputation. Not only got great place on both AppStore and GooglePlay rankings, they also got multiple recommendations by AppStore and GooglePlay. EnjoyGame is recruiting now talented and passionate employees right now. We also hungered for more corporation with excellent developers and other partners globally. '
	    },
	    login: {
	        'zh-CN': '登录',
	        'zh-TW': '登錄',
	        'en-US': 'Login',
	        'th-TH': 'Login',
	        'vi-VN': 'Login'
	    },
	    account: {
	        'zh-CN': '账号',
	        'zh-TW': '賬號',
	        'en-US': 'Account',
	        'th-TH': 'Account',
	        'vi-VN': 'Account'
	    },
	    accountNotEmpty: {
	        'zh-CN': '账号不能为空',
	        'zh-TW': '賬號不能為空',
	        'en-US': 'Account is needed',
	        'th-TH': 'Account is needed',
	        'vi-VN': 'Account is needed'
	    },
	    password: {
	        'zh-CN': '密码',
	        'zh-TW': '密碼',
	        'en-US': 'Password',
	        'th-TH': 'Password',
	        'vi-VN': 'Password'
	    },
	    passwordNotEmpty: {
	        'zh-CN': '密码不能为空',
	        'zh-TW': '密碼不能為空',
	        'en-US': 'Password is needed',
	        'th-TH': 'Password is needed',
	        'vi-VN': 'Password is needed'
	    },
	    captcha: {
	        'zh-CN': '验证码',
	        'zh-TW': '驗證碼',
	        'en-US': 'Captcha',
	        'th-TH': 'Captcha',
	        'vi-VN': 'Captcha'
	    },
	    captchaNotEmpty: {
	        'zh-CN': '验证码不能为空',
	        'zh-TW': '驗證碼不能為空',
	        'en-US': 'Captcha is needed',
	        'th-TH': 'Captcha is needed',
	        'vi-VN': 'Captcha is needed'
	    },
	    captchaError: {
	        'zh-CN': '验证码错误',
	        'zh-TW': '驗證碼錯誤',
	        'en-US': 'Captcha error',
	        'th-TH': 'Captcha error',
	        'vi-VN': 'Captcha error'
	    },
	    passwordError: {
	        'zh-CN': '密码错误',
	        'zh-TW': '密碼錯誤',
	        'en-US': 'Password error',
	        'th-TH': 'Password error',
	        'vi-VN': 'Password error'
	    },
	    userNotExits: {
	        'zh-CN': '用户名不存在',
	        'zh-TW': '用戶名不存在',
	        'en-US': 'User not exists',
	        'th-TH': 'User not exists',
	        'vi-VN': 'User not exists'
	    },
	    loginFail: {
	        'zh-CN': '登录失败',
	        'zh-TW': '登錄失敗',
	        'en-US': 'Login Failed',
	        'th-TH': 'Login Failed',
	        'vi-VN': 'Login Failed'
	    },
	    loginFailErrorCode: {
	        'zh-CN': '登录失败，错误码为：',
	        'zh-TW': '登錄失敗，錯誤碼為：',
	        'en-US': 'Login failed, error code: ',
	        'th-TH': 'Login failed, error code: ',
	        'vi-VN': 'Login failed, error code: '
	    },
	    registerFail: {
	        'zh-CN': '注册失败',
	        'zh-TW': '註冊失敗',
	        'en-US': 'Registration Failed',
	        'th-TH': 'Registration Failed',
	        'vi-VN': 'Registration Failed'
	    },
	    registerFailErrorCode: {
	        'zh-CN': '注册失败，错误码为：',
	        'zh-TW': '註冊失敗，錯誤碼為：',
	        'en-US': 'Registration failed，error code:',
	        'th-TH': 'Registration failed，error code:',
	        'vi-VN': 'Registration failed，error code:'
	    }
	};

/***/ }),

/***/ 187:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    close: {
	        'zh-CN': '关闭',
	        'zh-TW': '關閉',
	        'en-US': 'close',
	        'th-TH': 'close'
	    },
	    prevPage: {
	        'zh-CN': '上一页',
	        'zh-TW': '上一頁',
	        'en-US': 'Preview',
	        'th-TH': 'Preview'
	    },
	    nextPage: {
	        'zh-CN': '下一页',
	        'zh-TW': '下一頁',
	        'en-US': 'Next',
	        'th-TH': 'Next'
	    },
	    returnList: {
	        'zh-CN': '返回列表',
	        'zh-TW': '返回列表',
	        'en-US': 'Back to List',
	        'th-TH': 'Back to List',
	        'vi-VN': 'Back to List'
	    }
	};

/***/ }),

/***/ 188:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	        notice: {
	                'zh-CN': '公告',
	                'zh-TW': '公告',
	                'en-US': 'Notice',
	                'th-TH': 'Notice',
	                'vi-VN': 'Notice'
	        },
	        refund: {
	                'zh-CN': '退款协议',
	                'zh-TW': '退款协议',
	                'en-US': 'Refund Agreement',
	                'th-TH': 'Refund Agreement',
	                'vi-VN': 'Refund Agreement'
	        },
	        noticeContent: {
	                'zh-CN': '<h3>\u9000\u6B3E\u534F\u8BAE</h3>\n\n              <h4>EG\u79EF\u5206\u7684\u4F7F\u7528\u89C4\u5B9A\uFF1A </h4>\n              <p>1.\u7528\u6237\u4F7F\u7528\u79EF\u5206\u53C2\u52A0\u62BD\u5956\u3001\u5151\u6362\u3001\u6362\u8D2D\u7684\uFF0CEnjoy Game\u5BF9\u4E8E\u6240\u6D88\u8017\u79EF\u5206\u4E0D\u63D0\u4F9B\u64CD\u4F5C\u4FEE\u6539\u3001\u9000\u8FD8\u79EF\u5206\u670D\u52A1\uFF1B</p>\n\n              <p>2.Enjoy Game\u6709\u6743\u5355\u65B9\u5BF9\u5176\u63D0\u4F9B\u7684\u79EF\u5206\u53CA\u79EF\u5206\u5546\u54C1\u3001\u4E88\u4EE5\u5B9A\u4EF7\uFF0C\u5E76\u6709\u6743\u6839\u636E\u81EA\u8EAB\u8FD0\u8425\u9700\u8981\u4E88\u4EE5\u53D8\u66F4\uFF0CEnjoy Game\u65E0\u9700\u5BF9\u6B64\u884C\u4E3A\u627F\u62C5\u6CD5\u5F8B\u8D23\u4EFB\uFF1B</p>\n\n              <p>3.\u79EF\u5206\u7684\u83B7\u5F97\u9014\u5F84\u3001\u65B9\u5F0F\u3001\u6570\u91CF\u3001\u4F7F\u7528\u65B9\u6CD5\u3001\u6709\u6548\u671F\u9650\u7B49\u6240\u6709\u5185\u5BB9\u4EE5Enjoy Game\u5E73\u53F0\u516C\u5E03\u3001\u5B9E\u9645\u5C55\u793A\u6216Enjoy Game\u8BF4\u660E\u4E3A\u51C6\uFF1B</p>\n\n              <p>4.\u79EF\u5206\u65E0\u6CD5\u5151\u6362\u6210\u73B0\u91D1\u3002</p>\n\n              <div class="space"></div>\n\n              <h4>EG\u79EF\u5206\u5546\u54C1\u5546\u54C1\u7684\u7BA1\u7406\u89C4\u5B9A\uFF1A</h4>\n              <p>1.\u5982\u65E0\u7279\u6B8A\u8BF4\u660E\uFF0C\u7528\u6237\u4F7F\u7528\u79EF\u5206\u670D\u52A1\u83B7\u5F97\u7684\u4E2D\u5956\u5956\u54C1\u3001\u5151\u6362\u793C\u7269\u3001\u6362\u8D2D\u7269\u54C1\uFF0C\u5747\u4E3A\u865A\u62DF\u4EA7\u54C1\u800C\u975E\u5B9E\u7269\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u79EF\u5206\u5546\u54C1\u201D\uFF09\uFF0C\u5177\u4F53\u4F7F\u7528\u65B9\u6CD5\u3001\u671F\u9650\u3001\u8303\u56F4\u4EE5\u76F8\u5173\u79EF\u5206\u5546\u54C1\u5728Enjoy Game\u9875\u9762\u9644\u5E26\u7684\u8BF4\u660E\u4E3A\u51C6\uFF1B</p>\n\n              <p>2.\u79EF\u5206\u5546\u54C1\u4F1A\u56E0\u7528\u6237\u8981\u6C42\u3001Enjoy Game\u81EA\u8EAB\u7BA1\u5236\u3001\u5E02\u573A\u63A5\u53D7\u7A0B\u5EA6\u7B49\u56E0\u7D20\u968F\u65F6\u8C03\u6574\uFF0C\u5177\u4F53\u4FE1\u606F\u8BF7\u4EE5Enjoy Game\u5151\u62BD\u5956\u3001\u5151\u6362\u3001\u6362\u8D2D\u9875\u9762\u4E3A\u51C6\uFF1B</p>\n\n              <p>3.\u79EF\u5206\u670D\u52A1\u662FEnjoy Game\u7ED9\u4E88\u7528\u6237\u7684\u514D\u8D39\u56DE\u9988\uFF0C\u5355\u7EAF\u7684\u62BD\u5956\u5956\u54C1\u3001\u5151\u6362\u793C\u7269\u670D\u52A1\u5747\u4E0D\u63D0\u4F9B\u53D1\u7968\u3002\u5BF9\u4E8E\u201C\u79EF\u5206\u52A0\u73B0\u91D1\u201D\u65B9\u5F0F\u6362\u8D2D\u7684\u793C\u7269\uFF0CEnjoy Game\u4EC5\u5BF9\u73B0\u91D1\u90E8\u5206\u63D0\u4F9B\u53D1\u7968\u670D\u52A1\uFF0C\u8BF7\u6362\u8D2D\u7528\u6237\u63D0\u4F9B\u51C6\u786E\u7684\u53D1\u7968\u4FE1\u606F\u53CA\u63A5\u6536\u5730\u5740\uFF0C\u6240\u9700\u90AE\u8D39\u7531\u6362\u8D2D\u7528\u6237\u81EA\u884C\u627F\u62C5\uFF0CEnjoy Game\u4F9D\u6362\u8D2D\u7528\u6237\u63D0\u4F9B\u7684\u63A5\u6536\u4FE1\u606F\u53D1\u51FA\u53D1\u7968\u5373\u89C6\u4E3AEnjoy Game\u5DF2\u59A5\u5584\u5C65\u884C\u63D0\u4F9B\u53D1\u7968\u670D\u52A1\uFF1B</p>\n\n              <p>4.\u57FA\u4E8E\u865A\u62DF\u5546\u54C1\u7684\u6027\u8D28\u548C\u7279\u5F81\uFF0CEnjoy Game\u4E0D\u63D0\u4F9B\u79EF\u5206\u865A\u62DF\u5546\u54C1\u7684\u9000\u8D27\u3001\u6362\u8D27\u670D\u52A1\u3002\u5BF9\u4E8E\u79EF\u5206\u5B9E\u4F53\u5546\u54C1\u548C\u793E\u533A\u5E01\u5B9E\u4F53\u5546\u54C1\uFF0C\u56E0\u6362\u8D2D\u7528\u6237\u539F\u56E0\u9020\u6210\u5546\u54C1\u51FA\u73B0\u7455\u75B5\u3001\u635F\u574F\u7684\uFF0CEnjoy Game\u4E0D\u4E88\u8D1F\u8D23\uFF1B</p>\n\n              <p>5.\u9664\u975E\u53D6\u5F97Enjoy Game\u7684\u4E66\u9762\u6388\u6743\uFF0C\u7528\u6237\u4E0D\u5F97\u5C06\u79EF\u5206\u670D\u52A1\u7528\u4E8E\u5546\u4E1A\u9886\u57DF\uFF0C\u5982\u4E70\u5356\u3001\u7F6E\u6362\u3001\u62B5\u62BC\u7B49\u3002\u4EFB\u4F55\u7528\u6237\u5747\u5E94\u901A\u8FC7\u6B63\u89C4\u6E20\u9053\u53D6\u5F97\u79EF\u5206\u670D\u52A1\uFF0C\u4E00\u5207\u901A\u8FC7\u975E\u5B98\u65B9\u516C\u5E03\u6E20\u9053\u53D6\u5F97\u7684\u79EF\u5206\u53CA\u5176\u884D\u751F\u670D\u52A1\u5747\u4E0D\u5BF9Enjoy Game\u53D1\u751F\u6CD5\u5F8B\u6548\u529B\uFF0CEnjoy Game\u6709\u6743\u5355\u65B9\u6536\u56DE\u76F8\u5173\u79EF\u5206\u5E76\u7EC8\u6B62\u76F8\u5E94\u670D\u52A1\uFF0C\u4E25\u91CD\u8005Enjoy Game\u6709\u6743\u5BF9\u8BE5\u7528\u6237\u505A\u5C01\u53F7\u5904\u7406\uFF1B</p>\n\n              <p>6.\u5982\u65E0\u7279\u6B8A\u7EA6\u5B9A\uFF0C\u7528\u6237\u901A\u8FC7\u6B63\u89C4\u6E20\u9053\u83B7\u5F97\u7684\u79EF\u5206\u5747\u4E0D\u4EE5\u4EFB\u4F55\u73B0\u91D1\u65B9\u5F0F\u9000\u8FD8\uFF0C\u4EC5\u80FD\u901A\u8FC7\u4EAB\u7528\u79EF\u5206\u670D\u52A1\u8FDB\u884C\u7B49\u503C\u6D88\u8017\u3002\u7528\u6237\u6D88\u8017\u5176\u6240\u83B7\u5F97\u7684\u5168\u90E8\u79EF\u5206\uFF0C\u4E14\u4E0D\u5C06\u7EE7\u7EED\u4F7F\u7528\u79EF\u5206\u670D\u52A1\u7684\uFF0C\u5219\u670D\u52A1\u7EC8\u6B62\uFF1B</p>\n\n              <div class="space"></div>\n\n              <h4>Enjoy Game\u5E73\u53F0\u53CA\u65D7\u4E0B\u5E94\u7528\u7684\u4F7F\u7528\u89C4\u5B9A\uFF1A</h4>\n              <p>1.Enjoy Game\u4F5C\u4E3A\u624B\u673A\u6E38\u620F\u4E3A\u4E3B\u7684\u5E94\u7528\u5E73\u53F0\uFF0C\u63D0\u4F9B\u7528\u6237\u641C\u5BFB\u3001\u514D\u8D39\u6216\u6536\u8D39\u4F7F\u7528\u65D7\u4E0B\u5E94\u7528\u7684\u670D\u52A1\u3002Enjoy Game\u4F5C\u4E3A\u670D\u52A1\u63D0\u4F9B\u65B9\uFF0C\u7528\u6237\u5728\u6B64\u540C\u610F\u514D\u9664\u5728\u4F7F\u7528Enjoy Game\u65D7\u4E0B\u5E94\u7528\u65F6\u906D\u53D7\u7684\u4E00\u5207\u76F4\u63A5\u6216\u95F4\u63A5\u635F\u5BB3\u7684\u6CD5\u5F8B\u8D54\u507F\u8D23\u4EFB\uFF1B</p>\n\n              <p>2.Enjoy Game\u5728\u63D0\u4F9B\u5E94\u7528\u670D\u52A1\u65F6\uFF0C\u53EF\u80FD\u4F1A\u5BF9\u90E8\u5206\u5E94\u7528\u5185\u5BB9\u5411\u7528\u6237\u6536\u53D6\u4E00\u5B9A\u7684\u8D39\u7528\uFF0C\u7528\u6237\u53EF\u81EA\u7531\u9009\u62E9\u662F\u5426\u4ED8\u8D39\uFF0C\u5177\u4F53\u8D39\u7528\u652F\u4ED8\u65B9\u5F0F\u5305\u62EC\u4F46\u4E0D\u9650\u4E8EGoogle Play\u7535\u5B50\u94B1\u5305\u3001Itunes \u5145\u503C\u3001EG\u70B9\u6570\u5145\u503C\u7B49\u771F\u5B9E\u8D27\u5E01\u6216\u5176\u4ED6\u865A\u62DF\u8D27\u5E01\u3002\u5728\u6B64\u60C5\u51B5\u4E0B\uFF0CEnjoy Game\u4F1A\u5728\u76F8\u5173\u9875\u9762\u4E0A\u505A\u660E\u786E\u7684\u63D0\u793A\u3002\u5982\u7528\u6237\u4E0D\u540C\u610F\u652F\u4ED8\u8BE5\u7B14\u8D39\u7528\uFF0C\u5219\u4E0D\u80FD\u4F7F\u7528\u76F8\u5173\u7684\u6536\u8D39\u5E94\u7528\u5185\u5BB9\u670D\u52A1\uFF1B</p>\n\n              <p>3.\u5BF9\u4E8EEnjoy Game\u63D0\u4F9B\u7ED9\u7528\u6237\u7684\u5E94\u7528\u670D\u52A1\uFF0CEnjoy Game\u6709\u6743\u51B3\u5B9A\u6240\u63D0\u4F9B\u7684\u670D\u52A1\u7684\u8D44\u8D39\u6807\u51C6\u548C\u6536\u8D39\u65B9\u5F0F\uFF0C\u7528\u6237\u7406\u89E3\u5E76\u540C\u610F\uFF0CEnjoy Game\u53EF\u80FD\u4F1A\u5C31\u4E0D\u540C\u7684\u670D\u52A1\u5236\u5B9A\u4E0D\u540C\u7684\u8D44\u8D39\u6807\u51C6\u548C\u6536\u8D39\u65B9\u5F0F\uFF0C\u4E5F\u53EF\u80FD\u6309\u7167\u6240\u63D0\u4F9B\u670D\u52A1\u7684\u4E0D\u540C\u9636\u6BB5\u786E\u5B9A\u4E0D\u540C\u7684\u8D44\u8D39\u6807\u51C6\u548C\u6536\u8D39\u65B9\u5F0F\u3002Enjoy Game\u4F1A\u5C06\u6709\u5173\u670D\u52A1\u7684\u8D44\u8D39\u6807\u51C6\u3001\u6536\u8D39\u65B9\u5F0F\u3001\u8D2D\u4E70\u65B9\u5F0F\u6216\u6709\u5173\u8D44\u8D39\u653F\u7B56\u7684\u5176\u4ED6\u4FE1\u606F\u516C\u5F00\u5C55\u793A\uFF1B</p>\n\n              <p>4.Enjoy Game\u63D0\u4F9B\u7684\u5E94\u7528\u53CA\u670D\u52A1\u6240\u6709\u6743\u6216\u5176\u4ED6\u6743\u5229\u5747\u4E3AEnjoy Game\u6216\u5176\u6743\u5229\u4EBA\u6240\u6709\uFF0C\u53D7\u56FD\u9645\u6CD5\u5F8B\u4FDD\u62A4\u3002\u7528\u6237\u9664\u975E\u4E8B\u5148\u83B7\u5F97Enjoy Game\u6216\u5176\u4ED6\u76F8\u5173\u6743\u5229\u4EBA\u7684\u4E66\u9762\u5408\u6CD5\u6388\u6743\uFF0C\u7528\u6237\u4E0D\u5F97\u64C5\u81EA\u7ECF\u8425\u548C\u5185\u5BB9Enjoy Game\u63D0\u4F9B\u7684\u5E94\u7528\u53CA\u670D\u52A1\u6709\u5173\u7684\u6D3E\u751F\u4EA7\u54C1\u6216\u884D\u751F\u54C1\u3002</p>\n\n              <div class="space"></div>\n\n              <h4>\u50A8\u503C\u670D\u52A1\uFF08\u542B\u81EA\u52A8\u7EED\u8D39\u670D\u52A1\uFF09\u7684\u4F7F\u7528\u89C4\u5B9A\uFF1A</h4>\n              <p>1.Enjoy Game\u7684\u50A8\u503C\u529F\u80FD\u4E3A\u4E0D\u540C\u7C7B\u578B\u7684\u7528\u6237\u63D0\u4F9B\u4E86\u4E30\u5BCC\u7684\u5E94\u7528\u53CA\u670D\u52A1\uFF0C\u5177\u4F53\u4EE5\u5E94\u7528\u6216\u5E73\u53F0\u8BF4\u660E\u6216Enjoy Game\u5B9E\u9645\u63D0\u4F9B\u4E3A\u51C6\uFF1B</p>\n\n              <p>2.\u7528\u6237\u4E86\u89E3\u5E76\u540C\u610F\uFF0CEnjoy Game\u7684\u50A8\u503C\u529F\u80FD\u63D0\u4F9B\u7F51\u7EDC\u5546\u54C1\u548C\u865A\u62DF\u5546\u54C1\uFF0C\u91C7\u7528\u5148\u6536\u8D39\u540E\u670D\u52A1\u7684\u65B9\u5F0F\uFF0C\u6536\u8D39\u6309\u7167\u7528\u6237\u6240\u8D2D\u4E70\u7684\u7F51\u7EDC\u5546\u54C1\u4EF7\u683C\uFF0C\u4ED8\u8D39\u540E\u4E0D\u53EF\u8F6C\u8BA9\u6216\u9000\u6B3E\uFF08\u5982\u56E0Enjoy Game\u63D0\u4F9B\u7684\u5546\u54C1\u5B58\u5728\u91CD\u5927\u7455\u75B5\u5BFC\u81F4\u60A8\u5B8C\u5168\u65E0\u6CD5\u4F7F\u7528\u7B49\u9664\u5916\uFF09\uFF1B</p>\n\n              <p>3. Enjoy Game\u7684\u90E8\u5206\u5E94\u7528\u5185\u5BB9\u4E3A\u6536\u8D39\u670D\u52A1\uFF0C\u4F7F\u7528\u8BE5\u670D\u52A1\u524D\u9700\u8981\u652F\u4ED8\u76F8\u5E94\u7684\u670D\u52A1\u8D39\u7528\uFF0C\u60A8\u53EF\u901A\u8FC7Enjoy Game\u5B9E\u9645\u63D0\u4F9B\u7684\u4ED8\u8D39\u65B9\u5F0F\u5B8C\u6210\u652F\u4ED8\uFF0C\u5982\u94F6\u884C\u5361\u652F\u4ED8\u3001\u7B2C\u4E09\u65B9\u652F\u4ED8\u7B49\u3002\u9664\u6B64\u4E4B\u5916\uFF0C\u60A8\u4E5F\u53EF\u4EE5\u901A\u8FC7\u5176\u4ED6Enjoy Game\u8BA4\u53EF\u7684\u9014\u5F84\u8FDB\u884C\u4ED8\u8D39\u3002\u6536\u8D39\u670D\u52A1\uFF08\u5305\u62EC\u81EA\u52A8\u7EED\u8D39\uFF09\u7684\u6536\u8D39\u6807\u51C6\u7531Enjoy Game\u6839\u636E\u81EA\u8EAB\u8FD0\u8425\u7B56\u7565\u5236\u5B9A\uFF08\u5305\u62EC\u8D39\u7528\u8C03\u6574\uFF09\uFF0C\u5E76\u5728\u652F\u4ED8\u9875\u9762\u5411\u7528\u6237\u663E\u793A\uFF0C\u5B8C\u6210\u652F\u4ED8\u64CD\u4F5C\u5373\u89C6\u4E3A\u60A8\u77E5\u6089\u5E76\u540C\u610F\u8BE5\u6536\u8D39\u6807\u51C6\u53CA\u652F\u4ED8\u9875\u9762\u663E\u793A\u7684\u4E00\u5207\u5185\u5BB9\uFF1B</p>\n\n              <p>4.\u67D0\u4E9B\u5E94\u7528\u5185\u670D\u52A1\u4E3A\u7528\u6237\u63D0\u4F9B\u81EA\u52A8\u7EED\u8D39\u670D\u52A1\uFF08\u5982\u4E00\u4E9B\u6708\u5361\u8BA2\u9605\u529F\u80FD\uFF09\uFF0C\u5373\u7528\u6237\u6388\u6743Enjoy Game\u53EF\u5728\u7528\u6237\u670D\u52A1\u671F\u9650\u5373\u5C06\u8FC7\u671F\u65F6\uFF0C\u59D4\u6258\u652F\u4ED8\u6E20\u9053\u4ECE\u4E0E\u7528\u6237\u8D26\u53F7\u7ED1\u5B9A\u7684\u7528\u6237\u81EA\u6709\u5145\u503C\u8D26\u6237\u3001\u4E0E\u7528\u6237\u8D26\u53F7\u7ED1\u5B9A\u7684\u7B2C\u4E09\u65B9\u652F\u4ED8\u8D26\u6237\u3001\u94F6\u884C\u5361\u3001\u4E0E\u82F9\u679C\u5546\u5E97\u8D26\u6237\u7ED1\u5B9A\u7684\u652F\u4ED8\u8D26\u6237\u7B49\u8D26\u6237\uFF08\u4EE5\u4E0B\u7EDF\u79F0\u201C\u8D26\u6237\u201D\uFF09\u4F59\u989D\u4E2D\u4EE3\u6263\u4E0B\u4E00\u4E2A\u8BA1\u8D39\u5468\u671F\u7684\u8D39\u7528\u3002\u8BE5\u670D\u52A1\u5B9E\u73B0\u7684\u524D\u63D0\u662F\u60A8\u5DF2\u5C06\u60A8\u7684\u8D26\u53F7\u3001\u82F9\u679C\u5546\u5E97\u8D26\u6237\u4E0E\u4E0A\u8FF0\u8D26\u6237\u4E2D\u7684\u4E00\u79CD\u8FDB\u884C\u7ED1\u5B9A\uFF0C\u4E14\u53EF\u6210\u529F\u4ECE\u5176\u4E0A\u8FF0\u8D26\u6237\u4E2D\u8DB3\u989D\u6263\u6B3E\u3002\u8BA1\u8D39\u5468\u671F\u4F1A\u5728\u8D2D\u4E70\u9875\u9762\u5C55\u793A\uFF0C\u7528\u6237\u53EF\u81EA\u884C\u9009\u62E9\uFF1B</p>\n\n              <p>5.\u5728\u7528\u6237\u5F00\u901A\u81EA\u52A8\u7EED\u8D39\u670D\u52A1\u540E\uFF0C\u5982\u679CEnjoy Game\u5728\u4F1A\u5458\u670D\u52A1\u671F\u9650\u5373\u5C06\u8FC7\u671F\u524D\u901A\u8FC7\u60A8\u7684\u8D26\u6237\u6263\u6B3E\u5931\u8D25\u7684\uFF0C\u65E0\u8BBA\u662F\u56E0\u91D1\u989D\u4E0D\u8DB3\u6216\u5176\u4ED6\u539F\u56E0\uFF0CEnjoy Game\u6709\u6743\u5728\u4F1A\u5458\u670D\u52A1\u671F\u9650\u5230\u671F\u540E\u6682\u505C\u6216\u7EC8\u6B62\u7528\u6237\u5BF9\u670D\u52A1\u7684\u4F7F\u7528\u3002\u4F46\u7531\u4E8E\u81EA\u52A8\u7EED\u8D39\u670D\u52A1\u9700\u8981\u7528\u6237\u4E3B\u52A8\u64CD\u4F5C\u53D6\u6D88\uFF0C\u5982\u679C\u672A\u8FDB\u884C\u6B64\u7B49\u64CD\u4F5C\uFF0C\u5219\u5C06\u89C6\u4E3A\u60A8\u540C\u610FEnjoy Game\u53EF\u4F9D\u636E\u652F\u4ED8\u6E20\u9053\u7684\u6263\u6B3E\u89C4\u5219\u5728\u4F1A\u5458\u670D\u52A1\u671F\u9650\u5230\u671F\u540E\u7684\u4E00\u5B9A\u671F\u9650\u5185\u8FDB\u884C\u4E0D\u65F6\u7684\u6263\u6B3E\u5C1D\u8BD5\uFF08\u5373\u4F7F\u60A8\u8D26\u6237\u5185\u91D1\u989D\u4E0D\u8DB3\uFF09\u3002\u4E00\u65E6\u5728\u6B64\u671F\u9650\u5185Enjoy Game\u8DB3\u989D\u6536\u53D6\u4E86\u8D39\u7528\uFF0CEnjoy Game\u5C06\u6062\u590D\u60A8\u5BF9\u81EA\u52A8\u7EED\u8D39\u670D\u52A1\u548CVIP\u4F1A\u5458\u670D\u52A1\u7684\u4F7F\u7528\u6743\u9650\uFF1B</p>\n\n              <p>6.\u5173\u4E8EEnjoy Game\u7528\u6237\u5E7F\u544A\u6743\u76CA\u7684\u7279\u522B\u8BF4\u660E\uFF1A\u60A8\u5728\u4F7F\u7528Enjoy Game\u670D\u52A1\u7684\u8FC7\u7A0B\u4E2D\uFF0C\uFF08\u53EF\u80FD\uFF09\u63A5\u89E6\u5230\u4EE5\u5404\u79CD\u65B9\u5F0F\u6295\u653E\u7684\u5546\u4E1A\u6027\u5E7F\u544A\u6216\u5176\u4ED6\u7C7B\u578B\u7684\u5546\u4E1A\u4FE1\u606F\uFF0C\u5BF9\u6B64\u60A8\u7406\u89E3\u5E76\u4E88\u4EE5\u63A5\u53D7\uFF0C\u540C\u65F6Enjoy Game\u627F\u8BFA\u4F1A\u5C3D\u91CF\u964D\u4F4E\u5BF9\u60A8\u5E94\u7528\u4F53\u9A8C\u7684\u5F71\u54CD\u3002</p>\n\n              <p>7.\u5982\u60A8\u7684\u884C\u4E3A\u4F7FEnjoy Game/\u53CA\u5176\u5173\u8054\u516C\u53F8\u906D\u53D7\u4EFB\u4F55\u635F\u5931\u7684\uFF0C\u60A8\u5E94\u5F53\u627F\u62C5\u5168\u90E8\u635F\u5931\u8D54\u507F\u8D23\u4EFB\u5E76\u5728Enjoy Game\u8981\u6C42\u7684\u65F6\u9650\u5185\u5B8C\u6210\u8D39\u7528\u652F\u4ED8</p>\n\n              <p>8.\u5728\u53D1\u751F\u5982\u4E0B\u60C5\u51B5\u65F6\uFF0CEnjoy Game\u6709\u6743\u4E2D\u65AD\u6216\u7EC8\u6B62\u5411\u60A8\u63D0\u4F9B\u670D\u52A1\uFF1A</p>\n\n              <p class="p1">\uFF081\uFF09\u60A8\u4E3B\u52A8\u63D0\u51FA\u8981\u6C42\u7684\uFF1B</p>\n              <p class="p1">\uFF082\uFF09\u60A8\u5B58\u5728\u6216Enjoy Game\u7ECF\u72EC\u7ACB\u5224\u65AD\u540E\u8BA4\u4E3A\u60A8\u5B58\u5728\u4EFB\u4F55\u8FDD\u53CD\u6CD5\u5F8B\u6CD5\u89C4\u6216\u76D1\u7BA1\u653F\u7B56\u3001\u8FDD\u53CD\u672C\u534F\u8BAE\u6216\u6709\u635FEnjoy Game\u6216/\u53CA\u5176\u5173\u8054\u516C\u53F8\u7684\u58F0\u8A89\u3001\u5229\u76CA\u7684\u884C\u4E3A\u7684\uFF1B</p>\n              <p class="p1">\uFF083\uFF09Enjoy Game\u6839\u636E\u6CD5\u5F8B\u6CD5\u89C4\u3001\u76D1\u7BA1\u653F\u7B56\u7684\u89C4\u5B9A\u6216\u6709\u6743\u673A\u5173\u7684\u8981\u6C42\uFF1B</p>\n              <p class="p1">\uFF084\uFF09Enjoy Game\u4E3A\u7EF4\u62A4\u8D26\u53F7\u4E0E\u7CFB\u7EDF\u5B89\u5168\u7B49\u7D27\u6025\u60C5\u51B5\u4E4B\u9700\u8981\uFF1B</p>\n              <p class="p1">\uFF085\uFF09\u4E0D\u53EF\u6297\u529B\uFF08\u9274\u4E8E\u4E92\u8054\u7F51\u4E4B\u7279\u6B8A\u6027\u8D28\uFF0C\u4E0D\u53EF\u6297\u529B\u4EA6\u5305\u62EC\u9ED1\u5BA2\u653B\u51FB\u3001\u7535\u4FE1\u90E8\u95E8\u6280\u672F\u8C03\u6574\u5BFC\u81F4\u4E4B\u91CD\u5927\u5F71\u54CD\u3001\u56E0\u653F\u5E9C\u7BA1\u5236\u800C\u9020\u6210\u4E4B\u6682\u65F6\u5173\u95ED\u3001\u75C5\u6BD2\u4FB5\u88AD\u7B49\u5F71\u54CD\u4E92\u8054\u7F51\u6B63\u5E38\u8FD0\u884C\u4E4B\u60C5\u5F62\uFF09\uFF1B</p>\n              <p class="p1">\uFF086\uFF09\u5176\u4ED6Enjoy Game\u65E0\u6CD5\u6297\u62D2\u7684\u60C5\u51B5\u3002</p>\n\n              <p>9.\u5F53\u53D1\u751F\u524D\u8FF0\u7EC8\u6B62\u7684\u60C5\u51B5\u65F6\uFF0C\u60A8\u4E0EEnjoy Game\u5747\u8BA4\u53EF\u5982\u4E0B\u5904\u7406\u65B9\u5F0F\uFF1A</p>\n              <p class="p1">\uFF081\uFF09\u5DF2\u7ECF\u4EA7\u751F\u4F46\u672A\u4F7F\u7528\u7684\u4ED8\u8D39\u670D\u52A1\u81EA\u52A8\u6E05\u9664\u4E14\u4E0D\u6298\u73B0\uFF1B</p>\n              <p class="p1">\uFF082\uFF09\u5982\u60A8\u5728Enjoy Game\u5E73\u53F0\u5185\u6709\u6B63\u5728\u8FDB\u884C\u4E2D\u7684\u4EA4\u6613\uFF0CEnjoy Game\u5C4A\u65F6\u5C06\u89C6\u60C5\u51B5\u8FDB\u884C\u5408\u7406\u5904\u7406\uFF1B</p>\n              <p class="p1">\uFF083\uFF09\u9664\u6CD5\u5F8B\u6CD5\u89C4\u53E6\u6709\u89C4\u5B9A\u6216Enjoy Game\u53E6\u6709\u8BF4\u660E\u5916\uFF0CEnjoy Game\u5DF2\u6536\u53D6\u7684\u8D39\u7528\u4E0D\u4E88\u9000\u8FD8\uFF1B</p>\n              <p class="p1">\uFF084\uFF09\u5982\u56E0\u60A8\u8FDD\u53CD\u672C\u534F\u8BAE\u5BFC\u81F4\u7EC8\u6B62\u7684\uFF0CEnjoy Game\u6709\u6743\u89C6\u60C5\u51B5\u8981\u6C42\u60A8\u627F\u62C5\u76F8\u5E94\u7684\u8FDD\u7EA6\u8D23\u4EFB\uFF1B</p>\n              <p class="p1">\uFF085\uFF09\u9664\u6CD5\u5F8B\u6CD5\u89C4\u53E6\u6709\u89C4\u5B9A\u6216Enjoy Game\u53E6\u6709\u8BF4\u660E\u5916\uFF0CEnjoy Game\u65E0\u9700\u5411\u60A8\u548C\u7B2C\u4E09\u4EBA\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\u3002</p>\n\n              <p>10.\u60A8\u77E5\u6089\u5E76\u786E\u8BA4\uFF0C\u56E0\u6E38\u5BA2\u767B\u5165\u65B9\u5F0F\u4ED8\u8D39\u8D2D\u4E70\u670D\u52A1\uFF0C\u670D\u52A1\u5C06\u4F1A\u7ED1\u5B9A\u60A8\u8D2D\u4E70\u670D\u52A1\u65F6\u6240\u7528\u7684\u8BBE\u5907\uFF0C\u670D\u52A1\u4E5F\u5C06\u4EC5\u53EF\u5728\u7ED1\u5B9A\u8BBE\u5907\u4E0A\u4F7F\u7528\uFF0C\u5982\u60A8\u9700\u5728\u5176\u4ED6\u8BBE\u5907\u4E2D\u4F7F\u7528\uFF0C\u8BF7\u6309\u7167\u9875\u9762\u64CD\u4F5C\u6307\u5F15\u7ED1\u5B9A\u60A8\u7684EG\u6CE8\u518C\u8D26\u53F7</p>\n              <p class="p1">\uFF081\uFF09\u4ED8\u8D39\u670D\u52A1\u4E2D\u5305\u542BEnjoy Game\u89E3\u51B3\u6545\u969C\u3001\u670D\u52A1\u5668\u7EF4\u4FEE\u3001\u8C03\u6574\u3001\u5347\u7EA7\u7B49\u6240\u9700\u7528\u7684\u5408\u7406\u65F6\u95F4\uFF0C\u5BF9\u4E0A\u8FF0\u60C5\u51B5\u6240\u9700\u7528\u7684\u65F6\u95F4\u6216\u9020\u6210\u7684\u4EFB\u4F55\u635F\u5931\uFF08\u5982\u6709\uFF09\uFF0CEnjoy Game\u4E0D\u4E88\u4EFB\u4F55\u5F62\u5F0F\u7684\u8D54\u507F/\u8865\u507F\uFF0C\u4F46Enjoy Game\u4F1A\u5C3D\u53EF\u80FD\u5C06\u5F71\u54CD\u964D\u81F3\u6700\u4F4E\u3002</p>\n              <p class="p1">\uFF082\uFF09\u7528\u6237\u4ED8\u8D39\u540E\uFF0C\u53EF\u80FD\u4F1A\u56E0\u7528\u6237\u4F7F\u7528\u7684\u8F6F\u4EF6\u7248\u672C\u3001\u8BBE\u5907\u3001\u64CD\u4F5C\u7CFB\u7EDF\u7B49\u4E0D\u540C\u4EE5\u53CA\u5176\u4ED6\u7B2C\u4E09\u65B9\u539F\u56E0\u5BFC\u81F4\u5B9E\u9645\u53EF\u4F7F\u7528\u7684\u5177\u4F53\u6743\u76CA\u6216\u670D\u52A1\u5185\u5BB9\u6709\u5DEE\u522B\uFF0C\u7531\u6B64\u53EF\u80FD\u7ED9\u60A8\u5E26\u6765\u7684\u4E0D\u4FBF\uFF0C\u60A8\u8868\u793A\u7406\u89E3\u4E14\u4E0D\u4E88\u8FFD\u7A76\u6216\u8C41\u514DEnjoy Game\u7684\u76F8\u5173\u8D23\u4EFB\u3002Enjoy Game\u5EFA\u8BAE\u60A8\u53EF\u4EE5\u901A\u8FC7\u5347\u7EA7\u5E94\u7528\u7A0B\u5E8F\u6216\u64CD\u4F5C\u7CFB\u7EDF\u7248\u672C\u3001\u66F4\u6362\u4F7F\u7528\u8BBE\u5907\u7B49\u65B9\u5F0F\u6765\u5C1D\u8BD5\u89E3\u51B3\uFF0C\u6216\u8005\u76F4\u63A5\u901A\u8FC7\u672C\u534F\u8BAE\u63D0\u4F9B\u7684\u65B9\u5F0F\u4E0EEnjoy Game\u8054\u7CFB\u8FDB\u884C\u89E3\u51B3\u3002</p>\n              <p class="p1">\uFF083\uFF09\u7528\u6237\u8D26\u53F7\u4E0B\u7684\u6240\u6709\u884C\u4E3A\u89C6\u4E3A\u60A8\u672C\u4EBA\u7684\u884C\u4E3A\uFF1B\u800C\u4E14\u60A8\u5E94\u5BF9\u81EA\u8EAB\u5728\u83B7\u53D6\u548C\u4F7F\u7528\u670D\u52A1\u65F6\u7684\u4E00\u5207\u884C\u4E3A\uFF08\u65E0\u8BBA\u662F\u5426\u6545\u610F\uFF09\u8D1F\u5168\u90E8\u8D23\u4EFB\u3002Enjoy Game\u4EAB\u6709\u5BF9\u60A8\u5728\u83B7\u53D6\u548C\u4F7F\u7528\u670D\u52A1\u53CA\u5176\u76F8\u5173\u6D3B\u52A8\u8FC7\u7A0B\u4E2D\u7684\u76D1\u7763\u3001\u63D0\u793A\u7684\u6743\u5229\uFF0C\u5982\u60A8\u7684\u884C\u4E3A\u8FDD\u53CD\u6709\u5173\u6CD5\u5F8B\u6CD5\u89C4\u6216\u8FDD\u53CD\u672C\u534F\u8BAE\u7684\u7EA6\u5B9A\uFF0CEnjoy Game\u4EAB\u6709\u8981\u6C42\u60A8\u7EA0\u6B63\u53CA\u8FFD\u7A76\u60A8\u8D23\u4EFB\u7B49\u6743\u5229\u3002</p>\n              <p class="p1">\uFF084\uFF09\u60A8\u77E5\u6089\u5E76\u540C\u610F\uFF0C\u60A8\u5E94\u9075\u5FAAEnjoy Game\u5B98\u65B9\u6E20\u9053\u516C\u5E03\u7684\u6D41\u7A0B\u3001\u5E73\u53F0\u89C4\u8303\u7B49\u83B7\u53D6\u670D\u52A1\uFF0C\u4E0D\u5F97\u81EA\u884C\u6216\u534F\u52A9\u4ED6\u4EBA\u901A\u8FC7\u4EE5\u4E0B\u4EFB\u4E00\u65B9\u5F0F\u83B7\u53D6\u670D\u52A1\u3002\u5426\u5219\uFF0CEnjoy Game\u6709\u6743\u4E0D\u7ECF\u901A\u77E5\u62D2\u7EDD\u60A8\u7684\u7533\u8BF7\u6216\u64A4\u9500\u6D89\u53CA\u7684\u670D\u52A1\u8D44\u683C\u3001\u62D2\u7EDD\u6216\u7EC8\u6B62\u4E3A\u60A8\u63D0\u4F9B\u670D\u52A1\uFF0C\u5E76\u4E0D\u9000\u8FD8\u4ED8\u8D39\u4E14\u4E0D\u4E88\u652F\u4ED8\u4EFB\u4F55\u5F62\u5F0F\u7684\u4EFB\u4F55\u8D54\u507F/\u8865\u507F\uFF0C\u540C\u65F6Enjoy Game\u6709\u6743\u8FFD\u7A76\u60A8\u7684\u76F8\u5173\u6CD5\u5F8B\u8D23\u4EFB\uFF1A</p>\n              <p class="p1">\uFF085\uFF09\u672A\u7ECFEnjoy Game\u660E\u786E\u6388\u6743\uFF0C\u4EE5\u5546\u4E1A\u6027\u6216\u5176\u4ED6\u975E\u4E2A\u4EBA\u4F7F\u7528\u7B49\u76EE\u7684\u4E3A\u81EA\u5DF1\u6216\u4ED6\u4EBA\u83B7\u53D6\u3001\u4F7F\u7528Enjoy Game\u670D\u52A1\uFF1B</p>\n              <p class="p1">\uFF086\uFF09\u672A\u7ECFEnjoy Game\u660E\u786E\u6388\u6743\uFF0C\u901A\u8FC7\u673A\u5668\u4EBA\u8F6F\u4EF6\u3001\u8718\u86DB\u8F6F\u4EF6\u3001\u722C\u866B\u8F6F\u4EF6\u7B49\u4EFB\u4F55\u81EA\u52A8\u7A0B\u5E8F\u3001\u811A\u672C\u3001\u8F6F\u4EF6\u7B49\u65B9\u5F0F\u83B7\u53D6\u670D\u52A1\u3001\u5185\u5BB9\u3001\u6570\u636E\uFF1B</p>\n              <p class="p1">\uFF087\uFF09\u672A\u7ECFEnjoy Game\u660E\u786E\u6388\u6743\uFF0C\u901A\u8FC7\u6280\u672F\u624B\u6BB5\u5BF9\u670D\u52A1\u5185\u5BB9\u3001\u670D\u52A1\u671F\u9650\u3001\u6D88\u8D39\u91D1\u989D\u3001\u4EA4\u6613\u72B6\u6001\u7B49\u4FE1\u606F\u8FDB\u884C\u4FEE\u6539\uFF1B</p>\n              <p class="p1">\uFF088\uFF09\u5C06\u670D\u52A1\u901A\u8FC7\u975EEnjoy Game\u660E\u786E\u6388\u6743\u7684\u65B9\u5F0F\u5728Enjoy Game\u8D26\u53F7\u4E4B\u95F4\u8F6C\u79FB\uFF0C\u6216\u672A\u7ECFEnjoy Game\u660E\u786E\u6388\u6743\u800C\u8D60\u4E0E\u3001\u501F\u7528\u3001\u79DF\u7528\u3001\u9500\u552E\u3001\u8F6C\u8BA9\u670D\u52A1\u8D44\u683C\uFF1B</p>\n              <p class="p1">\uFF089\uFF09\u672A\u7ECFEnjoy Game\u660E\u786E\u6388\u6743\uFF0C\u5C06\u670D\u52A1\u5185\u5BB9\u5168\u90E8\u6216\u90E8\u5206\u8FDB\u884C\u590D\u5236\u3001\u4E0B\u8F7D\u3001\u4E0A\u4F20\u3001\u4FEE\u6539\u3001\u7F16\u76EE\u6392\u5E8F\u3001\u7FFB\u8BD1\u3001\u53D1\u884C\u3001\u5F00\u53D1\u3001\u8F6C\u8BA9\u3001\u9500\u552E\u3001\u5C55\u793A\u3001\u4F20\u64AD\u3001\u5408\u6210\u3001\u5D4C\u5957\u3001\u94FE\u63A5\u3001\u521B\u4F5C\u884D\u751F\u4F5C\u54C1\u3001\u8FDB\u884C\u5546\u4E1A\u5F00\u53D1\u6216\u63A8\u5E7F\u7B49\uFF1B</p>\n              <p class="p1">\uFF0810\uFF09\u5BF9Enjoy Game\u7528\u4E8E\u4FDD\u62A4\u7528\u6237\u670D\u52A1\u7684\u4EFB\u4F55\u5B89\u5168\u63AA\u65BD\u6280\u672F\u8FDB\u884C\u7834\u89E3\u3001\u66F4\u6539\u3001\u53CD\u64CD\u4F5C\u3001\u7BE1\u6539\u6216\u5176\u4ED6\u7834\u574F\uFF1B\u672A\u7ECFEnjoy Game\u4E8B\u5148\u4E66\u9762\u540C\u610F\u800C\u5220\u9664\u670D\u52A1\u5185\u5BB9\u4E0A\u7684\u4EFB\u4F55\u6240\u6709\u6743\u6216\u77E5\u8BC6\u4EA7\u6743\u58F0\u660E\u6216\u6807\u7B7E\uFF1B</p>\n              <p class="p1">\uFF0811\uFF09\u672A\u7ECFEnjoy Game\u660E\u786E\u6388\u6743\uFF0C\u91C7\u7528\u6536\u8D39\u6216\u514D\u8D39\u7684\u65B9\u5F0F\uFF0C\u5728\u4EFB\u4F55\u516C\u5F00\u573A\u5408\u5168\u90E8\u6216\u90E8\u5206\u5C55\u793A\u670D\u52A1\u5185\u5BB9\uFF08\u4F46\u5982\u60A8\u7684\u4E0A\u8FF0\u884C\u4E3A\u4E0D\u6784\u6210\u4FB5\u6743\u7684\u9664\u5916\uFF09\uFF1B</p>\n              <p class="p1">\uFF0812\uFF09\u901A\u8FC7\u4E0D\u6B63\u5F53\u624B\u6BB5\u6216\u4EE5\u8FDD\u53CD\u8BDA\u5B9E\u4FE1\u7528\u539F\u5219\u7684\u65B9\u5F0F\uFF08\u5982\u5229\u7528\u89C4\u5219\u6F0F\u6D1E\u3001\u5229\u7528\u7CFB\u7EDF\u6F0F\u6D1E\u3001\u6EE5\u7528\u4F1A\u5458\u8EAB\u4EFD\u3001\u9ED1\u8272\u4EA7\u4E1A\u3001\u6295\u673A\u7B49\u8FDD\u80CCEnjoy Game\u63D0\u4F9B\u670D\u52A1/\u4E3E\u529E\u6D3B\u52A8\u7684\u521D\u8877\u7684\u65B9\u5F0F\uFF09\uFF1B</p>\n              <p class="p1">\uFF0813\uFF09\u901A\u8FC7\u4FB5\u72AFEnjoy Game\u6216\u4ED6\u4EBA\u5408\u6CD5\u6743\u76CA\u7684\u65B9\u5F0F\uFF1B</p>\n              <p class="p1">\uFF0814\uFF09\u5176\u4ED6\u672A\u7ECFEnjoy Game\u660E\u793A\u6388\u6743\u8BB8\u53EF\u6216\u8FDD\u53CD\u672C\u534F\u8BAE\u3001\u6CD5\u5F8B\u6CD5\u89C4\u6216\u76D1\u7BA1\u653F\u7B56\u7684\u884C\u4E3A\u3002</p>\n\n              <p>11.\u60A8\u77E5\u6089\u5E76\u540C\u610F\uFF0C\u5982\u60A8\u5B58\u5728\u6216Enjoy Game\u7ECF\u72EC\u7ACB\u5224\u65AD\u540E\u8BA4\u4E3A\u60A8\u5B58\u5728\u4EFB\u4F55\u8FDD\u53CD\u6CD5\u5F8B\u6CD5\u89C4\u6216\u76D1\u7BA1\u653F\u7B56\u3001\u8FDD\u53CD\u672C\u534F\u8BAE\u6216\u6709\u635FEnjoy Game\u6216/\u53CA\u5176\u5173\u8054\u516C\u53F8\u7684\u58F0\u8A89\u3001\u5229\u76CA\u7684\u884C\u4E3A\u7684\uFF0CEnjoy Game\u6709\u6743\u72EC\u7ACB\u51B3\u5B9A\u91C7\u53D6\u4EE5\u4E0B\u4E00\u9879\u6216\u591A\u9879\u5904\u7406\u63AA\u65BD\uFF1A</p>\n              <p class="p1">\uFF081\uFF09\u5982\u672C\u534F\u8BAE\u5BF9\u6B64\u884C\u4E3A\u6709\u5355\u72EC\u6761\u6B3E\u7EA6\u5B9A\u5904\u7406\u65B9\u5F0F\u7684\uFF0C\u6309\u7167\u8BE5\u6761\u6B3E\u5904\u7406\uFF1B</p>\n              <p class="p1">\uFF082\uFF09\u65E0\u9700\u901A\u77E5\u60A8\u800C\u91C7\u53D6\u4E00\u79CD\u6216\u591A\u79CD\u63AA\u65BD\u5236\u6B62\u60A8\u7684\u884C\u4E3A\u53CA\u884C\u4E3A\u4EA7\u751F\u7684\u540E\u679C\uFF0C\u5982\u5220\u9664/\u5C4F\u853D\u76F8\u5173\u94FE\u63A5\u6216\u5185\u5BB9\u3001\u9650\u5236/\u53D6\u6D88\u60A8\u7684\u8D26\u53F7/\u8D26\u6237\u4F7F\u7528\u6743\u9650\u7B49\uFF1B</p>\n              <p class="p1">\uFF083\uFF09\u65E0\u9700\u901A\u77E5\u60A8\u800C\u4E2D\u65AD\u6216\u7EC8\u6B62\u90E8\u5206\u6216\u5168\u90E8\u670D\u52A1\uFF0C\u4E14\u60A8\u5DF2\u4EA4\u7EB3\u7684\u8D39\u7528\u5C06\u4E0D\u4E88\u9000\u8FD8\u4E14\u4E0D\u83B7\u5F97\u4EFB\u4F55\u5F62\u5F0F\u7684\u8865\u507F/\u8D54\u507F\uFF1B</p>\n              <p class="p1">\uFF084\uFF09\u5982\u60A8\u7684\u884C\u4E3A\u4F7FEnjoy Game\u6216/\u53CA\u5176\u5173\u8054\u516C\u53F8\u906D\u53D7\u4EFB\u4F55\u635F\u5931\u7684\uFF0C\u60A8\u5E94\u5F53\u627F\u62C5\u5168\u90E8\u635F\u5931\u8D54\u507F\u8D23\u4EFB\u5E76\u5728Enjoy Game\u8981\u6C42\u7684\u65F6\u9650\u5185\u5B8C\u6210\u8D39\u7528\u652F\u4ED8\u3002</p>\n\n              <h4 style="margin-top:21px">\u534F\u8BAE\u7684\u53D8\u66F4</h4>\n\n              <p class="p1">1. Enjoy Game\u6709\u6743\u53D8\u66F4\u672C\u534F\u8BAE\u5185\u5BB9\uFF0C\u5BF9\u6B64\uFF0CEnjoy Game\u5C06\u5728\u76F8\u5E94\u9875\u9762\u6216\u4EE5\u5176\u4ED6\u5408\u7406\u65B9\u5F0F\u8FDB\u884C\u901A\u77E5\u3002\u901A\u77E5\u4E00\u7ECF\u53D1\u9001\u5373\u89C6\u4E3A\u5DF2\u6210\u529F\u901A\u77E5\u60A8\u3002</p>\n              <p class="p1">2.\u5982\u534F\u8BAE\u53D1\u751F\u53D8\u66F4\uFF0C\u4F46\u60A8\u4E0D\u540C\u610F\u53D8\u66F4\u7684\u5185\u5BB9\u7684\uFF0C\u60A8\u6709\u6743\u9009\u62E9\u505C\u6B62\u4F7F\u7528Enjoy Game\u5E94\u7528\u548C\u670D\u52A1\u3002\u5982\u60A8\u5728\u53D8\u66F4\u540E\u7684\u534F\u8BAE\u751F\u6548\u540E\u4ECD\u7EE7\u7EED\u4F7F\u7528Enjoy Game\u5E94\u7528\u548C\u670D\u52A1\u7684\uFF0C\u5219\u89C6\u4E3A\u60A8\u5DF2\u7ECF\u540C\u610F\u53D8\u66F4\u7684\u5168\u90E8\u5185\u5BB9\u3002</p>',
	                'zh-TW': '<h3>\u9000\u6B3E\u534F\u8BAE</h3>\n\n              <h4>EG\u79EF\u5206\u7684\u4F7F\u7528\u89C4\u5B9A\uFF1A </h4>\n              <p>1.\u7528\u6237\u4F7F\u7528\u79EF\u5206\u53C2\u52A0\u62BD\u5956\u3001\u5151\u6362\u3001\u6362\u8D2D\u7684\uFF0CEnjoy Game\u5BF9\u4E8E\u6240\u6D88\u8017\u79EF\u5206\u4E0D\u63D0\u4F9B\u64CD\u4F5C\u4FEE\u6539\u3001\u9000\u8FD8\u79EF\u5206\u670D\u52A1\uFF1B</p>\n\n              <p>2.Enjoy Game\u6709\u6743\u5355\u65B9\u5BF9\u5176\u63D0\u4F9B\u7684\u79EF\u5206\u53CA\u79EF\u5206\u5546\u54C1\u3001\u4E88\u4EE5\u5B9A\u4EF7\uFF0C\u5E76\u6709\u6743\u6839\u636E\u81EA\u8EAB\u8FD0\u8425\u9700\u8981\u4E88\u4EE5\u53D8\u66F4\uFF0CEnjoy Game\u65E0\u9700\u5BF9\u6B64\u884C\u4E3A\u627F\u62C5\u6CD5\u5F8B\u8D23\u4EFB\uFF1B</p>\n\n              <p>3.\u79EF\u5206\u7684\u83B7\u5F97\u9014\u5F84\u3001\u65B9\u5F0F\u3001\u6570\u91CF\u3001\u4F7F\u7528\u65B9\u6CD5\u3001\u6709\u6548\u671F\u9650\u7B49\u6240\u6709\u5185\u5BB9\u4EE5Enjoy Game\u5E73\u53F0\u516C\u5E03\u3001\u5B9E\u9645\u5C55\u793A\u6216Enjoy Game\u8BF4\u660E\u4E3A\u51C6\uFF1B</p>\n\n              <p>4.\u79EF\u5206\u65E0\u6CD5\u5151\u6362\u6210\u73B0\u91D1\u3002</p>\n\n              <div class="space"></div>\n\n              <h4>EG\u79EF\u5206\u5546\u54C1\u5546\u54C1\u7684\u7BA1\u7406\u89C4\u5B9A\uFF1A</h4>\n              <p>1.\u5982\u65E0\u7279\u6B8A\u8BF4\u660E\uFF0C\u7528\u6237\u4F7F\u7528\u79EF\u5206\u670D\u52A1\u83B7\u5F97\u7684\u4E2D\u5956\u5956\u54C1\u3001\u5151\u6362\u793C\u7269\u3001\u6362\u8D2D\u7269\u54C1\uFF0C\u5747\u4E3A\u865A\u62DF\u4EA7\u54C1\u800C\u975E\u5B9E\u7269\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u79EF\u5206\u5546\u54C1\u201D\uFF09\uFF0C\u5177\u4F53\u4F7F\u7528\u65B9\u6CD5\u3001\u671F\u9650\u3001\u8303\u56F4\u4EE5\u76F8\u5173\u79EF\u5206\u5546\u54C1\u5728Enjoy Game\u9875\u9762\u9644\u5E26\u7684\u8BF4\u660E\u4E3A\u51C6\uFF1B</p>\n\n              <p>2.\u79EF\u5206\u5546\u54C1\u4F1A\u56E0\u7528\u6237\u8981\u6C42\u3001Enjoy Game\u81EA\u8EAB\u7BA1\u5236\u3001\u5E02\u573A\u63A5\u53D7\u7A0B\u5EA6\u7B49\u56E0\u7D20\u968F\u65F6\u8C03\u6574\uFF0C\u5177\u4F53\u4FE1\u606F\u8BF7\u4EE5Enjoy Game\u5151\u62BD\u5956\u3001\u5151\u6362\u3001\u6362\u8D2D\u9875\u9762\u4E3A\u51C6\uFF1B</p>\n\n              <p>3.\u79EF\u5206\u670D\u52A1\u662FEnjoy Game\u7ED9\u4E88\u7528\u6237\u7684\u514D\u8D39\u56DE\u9988\uFF0C\u5355\u7EAF\u7684\u62BD\u5956\u5956\u54C1\u3001\u5151\u6362\u793C\u7269\u670D\u52A1\u5747\u4E0D\u63D0\u4F9B\u53D1\u7968\u3002\u5BF9\u4E8E\u201C\u79EF\u5206\u52A0\u73B0\u91D1\u201D\u65B9\u5F0F\u6362\u8D2D\u7684\u793C\u7269\uFF0CEnjoy Game\u4EC5\u5BF9\u73B0\u91D1\u90E8\u5206\u63D0\u4F9B\u53D1\u7968\u670D\u52A1\uFF0C\u8BF7\u6362\u8D2D\u7528\u6237\u63D0\u4F9B\u51C6\u786E\u7684\u53D1\u7968\u4FE1\u606F\u53CA\u63A5\u6536\u5730\u5740\uFF0C\u6240\u9700\u90AE\u8D39\u7531\u6362\u8D2D\u7528\u6237\u81EA\u884C\u627F\u62C5\uFF0CEnjoy Game\u4F9D\u6362\u8D2D\u7528\u6237\u63D0\u4F9B\u7684\u63A5\u6536\u4FE1\u606F\u53D1\u51FA\u53D1\u7968\u5373\u89C6\u4E3AEnjoy Game\u5DF2\u59A5\u5584\u5C65\u884C\u63D0\u4F9B\u53D1\u7968\u670D\u52A1\uFF1B</p>\n\n              <p>4.\u57FA\u4E8E\u865A\u62DF\u5546\u54C1\u7684\u6027\u8D28\u548C\u7279\u5F81\uFF0CEnjoy Game\u4E0D\u63D0\u4F9B\u79EF\u5206\u865A\u62DF\u5546\u54C1\u7684\u9000\u8D27\u3001\u6362\u8D27\u670D\u52A1\u3002\u5BF9\u4E8E\u79EF\u5206\u5B9E\u4F53\u5546\u54C1\u548C\u793E\u533A\u5E01\u5B9E\u4F53\u5546\u54C1\uFF0C\u56E0\u6362\u8D2D\u7528\u6237\u539F\u56E0\u9020\u6210\u5546\u54C1\u51FA\u73B0\u7455\u75B5\u3001\u635F\u574F\u7684\uFF0CEnjoy Game\u4E0D\u4E88\u8D1F\u8D23\uFF1B</p>\n\n              <p>5.\u9664\u975E\u53D6\u5F97Enjoy Game\u7684\u4E66\u9762\u6388\u6743\uFF0C\u7528\u6237\u4E0D\u5F97\u5C06\u79EF\u5206\u670D\u52A1\u7528\u4E8E\u5546\u4E1A\u9886\u57DF\uFF0C\u5982\u4E70\u5356\u3001\u7F6E\u6362\u3001\u62B5\u62BC\u7B49\u3002\u4EFB\u4F55\u7528\u6237\u5747\u5E94\u901A\u8FC7\u6B63\u89C4\u6E20\u9053\u53D6\u5F97\u79EF\u5206\u670D\u52A1\uFF0C\u4E00\u5207\u901A\u8FC7\u975E\u5B98\u65B9\u516C\u5E03\u6E20\u9053\u53D6\u5F97\u7684\u79EF\u5206\u53CA\u5176\u884D\u751F\u670D\u52A1\u5747\u4E0D\u5BF9Enjoy Game\u53D1\u751F\u6CD5\u5F8B\u6548\u529B\uFF0CEnjoy Game\u6709\u6743\u5355\u65B9\u6536\u56DE\u76F8\u5173\u79EF\u5206\u5E76\u7EC8\u6B62\u76F8\u5E94\u670D\u52A1\uFF0C\u4E25\u91CD\u8005Enjoy Game\u6709\u6743\u5BF9\u8BE5\u7528\u6237\u505A\u5C01\u53F7\u5904\u7406\uFF1B</p>\n\n              <p>6.\u5982\u65E0\u7279\u6B8A\u7EA6\u5B9A\uFF0C\u7528\u6237\u901A\u8FC7\u6B63\u89C4\u6E20\u9053\u83B7\u5F97\u7684\u79EF\u5206\u5747\u4E0D\u4EE5\u4EFB\u4F55\u73B0\u91D1\u65B9\u5F0F\u9000\u8FD8\uFF0C\u4EC5\u80FD\u901A\u8FC7\u4EAB\u7528\u79EF\u5206\u670D\u52A1\u8FDB\u884C\u7B49\u503C\u6D88\u8017\u3002\u7528\u6237\u6D88\u8017\u5176\u6240\u83B7\u5F97\u7684\u5168\u90E8\u79EF\u5206\uFF0C\u4E14\u4E0D\u5C06\u7EE7\u7EED\u4F7F\u7528\u79EF\u5206\u670D\u52A1\u7684\uFF0C\u5219\u670D\u52A1\u7EC8\u6B62\uFF1B</p>\n\n              <div class="space"></div>\n\n              <h4>Enjoy Game\u5E73\u53F0\u53CA\u65D7\u4E0B\u5E94\u7528\u7684\u4F7F\u7528\u89C4\u5B9A\uFF1A</h4>\n              <p>1.Enjoy Game\u4F5C\u4E3A\u624B\u673A\u6E38\u620F\u4E3A\u4E3B\u7684\u5E94\u7528\u5E73\u53F0\uFF0C\u63D0\u4F9B\u7528\u6237\u641C\u5BFB\u3001\u514D\u8D39\u6216\u6536\u8D39\u4F7F\u7528\u65D7\u4E0B\u5E94\u7528\u7684\u670D\u52A1\u3002Enjoy Game\u4F5C\u4E3A\u670D\u52A1\u63D0\u4F9B\u65B9\uFF0C\u7528\u6237\u5728\u6B64\u540C\u610F\u514D\u9664\u5728\u4F7F\u7528Enjoy Game\u65D7\u4E0B\u5E94\u7528\u65F6\u906D\u53D7\u7684\u4E00\u5207\u76F4\u63A5\u6216\u95F4\u63A5\u635F\u5BB3\u7684\u6CD5\u5F8B\u8D54\u507F\u8D23\u4EFB\uFF1B</p>\n\n              <p>2.Enjoy Game\u5728\u63D0\u4F9B\u5E94\u7528\u670D\u52A1\u65F6\uFF0C\u53EF\u80FD\u4F1A\u5BF9\u90E8\u5206\u5E94\u7528\u5185\u5BB9\u5411\u7528\u6237\u6536\u53D6\u4E00\u5B9A\u7684\u8D39\u7528\uFF0C\u7528\u6237\u53EF\u81EA\u7531\u9009\u62E9\u662F\u5426\u4ED8\u8D39\uFF0C\u5177\u4F53\u8D39\u7528\u652F\u4ED8\u65B9\u5F0F\u5305\u62EC\u4F46\u4E0D\u9650\u4E8EGoogle Play\u7535\u5B50\u94B1\u5305\u3001Itunes \u5145\u503C\u3001EG\u70B9\u6570\u5145\u503C\u7B49\u771F\u5B9E\u8D27\u5E01\u6216\u5176\u4ED6\u865A\u62DF\u8D27\u5E01\u3002\u5728\u6B64\u60C5\u51B5\u4E0B\uFF0CEnjoy Game\u4F1A\u5728\u76F8\u5173\u9875\u9762\u4E0A\u505A\u660E\u786E\u7684\u63D0\u793A\u3002\u5982\u7528\u6237\u4E0D\u540C\u610F\u652F\u4ED8\u8BE5\u7B14\u8D39\u7528\uFF0C\u5219\u4E0D\u80FD\u4F7F\u7528\u76F8\u5173\u7684\u6536\u8D39\u5E94\u7528\u5185\u5BB9\u670D\u52A1\uFF1B</p>\n\n              <p>3.\u5BF9\u4E8EEnjoy Game\u63D0\u4F9B\u7ED9\u7528\u6237\u7684\u5E94\u7528\u670D\u52A1\uFF0CEnjoy Game\u6709\u6743\u51B3\u5B9A\u6240\u63D0\u4F9B\u7684\u670D\u52A1\u7684\u8D44\u8D39\u6807\u51C6\u548C\u6536\u8D39\u65B9\u5F0F\uFF0C\u7528\u6237\u7406\u89E3\u5E76\u540C\u610F\uFF0CEnjoy Game\u53EF\u80FD\u4F1A\u5C31\u4E0D\u540C\u7684\u670D\u52A1\u5236\u5B9A\u4E0D\u540C\u7684\u8D44\u8D39\u6807\u51C6\u548C\u6536\u8D39\u65B9\u5F0F\uFF0C\u4E5F\u53EF\u80FD\u6309\u7167\u6240\u63D0\u4F9B\u670D\u52A1\u7684\u4E0D\u540C\u9636\u6BB5\u786E\u5B9A\u4E0D\u540C\u7684\u8D44\u8D39\u6807\u51C6\u548C\u6536\u8D39\u65B9\u5F0F\u3002Enjoy Game\u4F1A\u5C06\u6709\u5173\u670D\u52A1\u7684\u8D44\u8D39\u6807\u51C6\u3001\u6536\u8D39\u65B9\u5F0F\u3001\u8D2D\u4E70\u65B9\u5F0F\u6216\u6709\u5173\u8D44\u8D39\u653F\u7B56\u7684\u5176\u4ED6\u4FE1\u606F\u516C\u5F00\u5C55\u793A\uFF1B</p>\n\n              <p>4.Enjoy Game\u63D0\u4F9B\u7684\u5E94\u7528\u53CA\u670D\u52A1\u6240\u6709\u6743\u6216\u5176\u4ED6\u6743\u5229\u5747\u4E3AEnjoy Game\u6216\u5176\u6743\u5229\u4EBA\u6240\u6709\uFF0C\u53D7\u56FD\u9645\u6CD5\u5F8B\u4FDD\u62A4\u3002\u7528\u6237\u9664\u975E\u4E8B\u5148\u83B7\u5F97Enjoy Game\u6216\u5176\u4ED6\u76F8\u5173\u6743\u5229\u4EBA\u7684\u4E66\u9762\u5408\u6CD5\u6388\u6743\uFF0C\u7528\u6237\u4E0D\u5F97\u64C5\u81EA\u7ECF\u8425\u548C\u5185\u5BB9Enjoy Game\u63D0\u4F9B\u7684\u5E94\u7528\u53CA\u670D\u52A1\u6709\u5173\u7684\u6D3E\u751F\u4EA7\u54C1\u6216\u884D\u751F\u54C1\u3002</p>\n\n              <div class="space"></div>\n\n              <h4>\u50A8\u503C\u670D\u52A1\uFF08\u542B\u81EA\u52A8\u7EED\u8D39\u670D\u52A1\uFF09\u7684\u4F7F\u7528\u89C4\u5B9A\uFF1A</h4>\n              <p>1.Enjoy Game\u7684\u50A8\u503C\u529F\u80FD\u4E3A\u4E0D\u540C\u7C7B\u578B\u7684\u7528\u6237\u63D0\u4F9B\u4E86\u4E30\u5BCC\u7684\u5E94\u7528\u53CA\u670D\u52A1\uFF0C\u5177\u4F53\u4EE5\u5E94\u7528\u6216\u5E73\u53F0\u8BF4\u660E\u6216Enjoy Game\u5B9E\u9645\u63D0\u4F9B\u4E3A\u51C6\uFF1B</p>\n\n              <p>2.\u7528\u6237\u4E86\u89E3\u5E76\u540C\u610F\uFF0CEnjoy Game\u7684\u50A8\u503C\u529F\u80FD\u63D0\u4F9B\u7F51\u7EDC\u5546\u54C1\u548C\u865A\u62DF\u5546\u54C1\uFF0C\u91C7\u7528\u5148\u6536\u8D39\u540E\u670D\u52A1\u7684\u65B9\u5F0F\uFF0C\u6536\u8D39\u6309\u7167\u7528\u6237\u6240\u8D2D\u4E70\u7684\u7F51\u7EDC\u5546\u54C1\u4EF7\u683C\uFF0C\u4ED8\u8D39\u540E\u4E0D\u53EF\u8F6C\u8BA9\u6216\u9000\u6B3E\uFF08\u5982\u56E0Enjoy Game\u63D0\u4F9B\u7684\u5546\u54C1\u5B58\u5728\u91CD\u5927\u7455\u75B5\u5BFC\u81F4\u60A8\u5B8C\u5168\u65E0\u6CD5\u4F7F\u7528\u7B49\u9664\u5916\uFF09\uFF1B</p>\n\n              <p>3. Enjoy Game\u7684\u90E8\u5206\u5E94\u7528\u5185\u5BB9\u4E3A\u6536\u8D39\u670D\u52A1\uFF0C\u4F7F\u7528\u8BE5\u670D\u52A1\u524D\u9700\u8981\u652F\u4ED8\u76F8\u5E94\u7684\u670D\u52A1\u8D39\u7528\uFF0C\u60A8\u53EF\u901A\u8FC7Enjoy Game\u5B9E\u9645\u63D0\u4F9B\u7684\u4ED8\u8D39\u65B9\u5F0F\u5B8C\u6210\u652F\u4ED8\uFF0C\u5982\u94F6\u884C\u5361\u652F\u4ED8\u3001\u7B2C\u4E09\u65B9\u652F\u4ED8\u7B49\u3002\u9664\u6B64\u4E4B\u5916\uFF0C\u60A8\u4E5F\u53EF\u4EE5\u901A\u8FC7\u5176\u4ED6Enjoy Game\u8BA4\u53EF\u7684\u9014\u5F84\u8FDB\u884C\u4ED8\u8D39\u3002\u6536\u8D39\u670D\u52A1\uFF08\u5305\u62EC\u81EA\u52A8\u7EED\u8D39\uFF09\u7684\u6536\u8D39\u6807\u51C6\u7531Enjoy Game\u6839\u636E\u81EA\u8EAB\u8FD0\u8425\u7B56\u7565\u5236\u5B9A\uFF08\u5305\u62EC\u8D39\u7528\u8C03\u6574\uFF09\uFF0C\u5E76\u5728\u652F\u4ED8\u9875\u9762\u5411\u7528\u6237\u663E\u793A\uFF0C\u5B8C\u6210\u652F\u4ED8\u64CD\u4F5C\u5373\u89C6\u4E3A\u60A8\u77E5\u6089\u5E76\u540C\u610F\u8BE5\u6536\u8D39\u6807\u51C6\u53CA\u652F\u4ED8\u9875\u9762\u663E\u793A\u7684\u4E00\u5207\u5185\u5BB9\uFF1B</p>\n\n              <p>4.\u67D0\u4E9B\u5E94\u7528\u5185\u670D\u52A1\u4E3A\u7528\u6237\u63D0\u4F9B\u81EA\u52A8\u7EED\u8D39\u670D\u52A1\uFF08\u5982\u4E00\u4E9B\u6708\u5361\u8BA2\u9605\u529F\u80FD\uFF09\uFF0C\u5373\u7528\u6237\u6388\u6743Enjoy Game\u53EF\u5728\u7528\u6237\u670D\u52A1\u671F\u9650\u5373\u5C06\u8FC7\u671F\u65F6\uFF0C\u59D4\u6258\u652F\u4ED8\u6E20\u9053\u4ECE\u4E0E\u7528\u6237\u8D26\u53F7\u7ED1\u5B9A\u7684\u7528\u6237\u81EA\u6709\u5145\u503C\u8D26\u6237\u3001\u4E0E\u7528\u6237\u8D26\u53F7\u7ED1\u5B9A\u7684\u7B2C\u4E09\u65B9\u652F\u4ED8\u8D26\u6237\u3001\u94F6\u884C\u5361\u3001\u4E0E\u82F9\u679C\u5546\u5E97\u8D26\u6237\u7ED1\u5B9A\u7684\u652F\u4ED8\u8D26\u6237\u7B49\u8D26\u6237\uFF08\u4EE5\u4E0B\u7EDF\u79F0\u201C\u8D26\u6237\u201D\uFF09\u4F59\u989D\u4E2D\u4EE3\u6263\u4E0B\u4E00\u4E2A\u8BA1\u8D39\u5468\u671F\u7684\u8D39\u7528\u3002\u8BE5\u670D\u52A1\u5B9E\u73B0\u7684\u524D\u63D0\u662F\u60A8\u5DF2\u5C06\u60A8\u7684\u8D26\u53F7\u3001\u82F9\u679C\u5546\u5E97\u8D26\u6237\u4E0E\u4E0A\u8FF0\u8D26\u6237\u4E2D\u7684\u4E00\u79CD\u8FDB\u884C\u7ED1\u5B9A\uFF0C\u4E14\u53EF\u6210\u529F\u4ECE\u5176\u4E0A\u8FF0\u8D26\u6237\u4E2D\u8DB3\u989D\u6263\u6B3E\u3002\u8BA1\u8D39\u5468\u671F\u4F1A\u5728\u8D2D\u4E70\u9875\u9762\u5C55\u793A\uFF0C\u7528\u6237\u53EF\u81EA\u884C\u9009\u62E9\uFF1B</p>\n\n              <p>5.\u5728\u7528\u6237\u5F00\u901A\u81EA\u52A8\u7EED\u8D39\u670D\u52A1\u540E\uFF0C\u5982\u679CEnjoy Game\u5728\u4F1A\u5458\u670D\u52A1\u671F\u9650\u5373\u5C06\u8FC7\u671F\u524D\u901A\u8FC7\u60A8\u7684\u8D26\u6237\u6263\u6B3E\u5931\u8D25\u7684\uFF0C\u65E0\u8BBA\u662F\u56E0\u91D1\u989D\u4E0D\u8DB3\u6216\u5176\u4ED6\u539F\u56E0\uFF0CEnjoy Game\u6709\u6743\u5728\u4F1A\u5458\u670D\u52A1\u671F\u9650\u5230\u671F\u540E\u6682\u505C\u6216\u7EC8\u6B62\u7528\u6237\u5BF9\u670D\u52A1\u7684\u4F7F\u7528\u3002\u4F46\u7531\u4E8E\u81EA\u52A8\u7EED\u8D39\u670D\u52A1\u9700\u8981\u7528\u6237\u4E3B\u52A8\u64CD\u4F5C\u53D6\u6D88\uFF0C\u5982\u679C\u672A\u8FDB\u884C\u6B64\u7B49\u64CD\u4F5C\uFF0C\u5219\u5C06\u89C6\u4E3A\u60A8\u540C\u610FEnjoy Game\u53EF\u4F9D\u636E\u652F\u4ED8\u6E20\u9053\u7684\u6263\u6B3E\u89C4\u5219\u5728\u4F1A\u5458\u670D\u52A1\u671F\u9650\u5230\u671F\u540E\u7684\u4E00\u5B9A\u671F\u9650\u5185\u8FDB\u884C\u4E0D\u65F6\u7684\u6263\u6B3E\u5C1D\u8BD5\uFF08\u5373\u4F7F\u60A8\u8D26\u6237\u5185\u91D1\u989D\u4E0D\u8DB3\uFF09\u3002\u4E00\u65E6\u5728\u6B64\u671F\u9650\u5185Enjoy Game\u8DB3\u989D\u6536\u53D6\u4E86\u8D39\u7528\uFF0CEnjoy Game\u5C06\u6062\u590D\u60A8\u5BF9\u81EA\u52A8\u7EED\u8D39\u670D\u52A1\u548CVIP\u4F1A\u5458\u670D\u52A1\u7684\u4F7F\u7528\u6743\u9650\uFF1B</p>\n\n              <p>6.\u5173\u4E8EEnjoy Game\u7528\u6237\u5E7F\u544A\u6743\u76CA\u7684\u7279\u522B\u8BF4\u660E\uFF1A\u60A8\u5728\u4F7F\u7528Enjoy Game\u670D\u52A1\u7684\u8FC7\u7A0B\u4E2D\uFF0C\uFF08\u53EF\u80FD\uFF09\u63A5\u89E6\u5230\u4EE5\u5404\u79CD\u65B9\u5F0F\u6295\u653E\u7684\u5546\u4E1A\u6027\u5E7F\u544A\u6216\u5176\u4ED6\u7C7B\u578B\u7684\u5546\u4E1A\u4FE1\u606F\uFF0C\u5BF9\u6B64\u60A8\u7406\u89E3\u5E76\u4E88\u4EE5\u63A5\u53D7\uFF0C\u540C\u65F6Enjoy Game\u627F\u8BFA\u4F1A\u5C3D\u91CF\u964D\u4F4E\u5BF9\u60A8\u5E94\u7528\u4F53\u9A8C\u7684\u5F71\u54CD\u3002</p>\n\n              <p>7.\u5982\u60A8\u7684\u884C\u4E3A\u4F7FEnjoy Game/\u53CA\u5176\u5173\u8054\u516C\u53F8\u906D\u53D7\u4EFB\u4F55\u635F\u5931\u7684\uFF0C\u60A8\u5E94\u5F53\u627F\u62C5\u5168\u90E8\u635F\u5931\u8D54\u507F\u8D23\u4EFB\u5E76\u5728Enjoy Game\u8981\u6C42\u7684\u65F6\u9650\u5185\u5B8C\u6210\u8D39\u7528\u652F\u4ED8</p>\n\n              <p>8.\u5728\u53D1\u751F\u5982\u4E0B\u60C5\u51B5\u65F6\uFF0CEnjoy Game\u6709\u6743\u4E2D\u65AD\u6216\u7EC8\u6B62\u5411\u60A8\u63D0\u4F9B\u670D\u52A1\uFF1A</p>\n\n              <p class="p1">\uFF081\uFF09\u60A8\u4E3B\u52A8\u63D0\u51FA\u8981\u6C42\u7684\uFF1B</p>\n              <p class="p1">\uFF082\uFF09\u60A8\u5B58\u5728\u6216Enjoy Game\u7ECF\u72EC\u7ACB\u5224\u65AD\u540E\u8BA4\u4E3A\u60A8\u5B58\u5728\u4EFB\u4F55\u8FDD\u53CD\u6CD5\u5F8B\u6CD5\u89C4\u6216\u76D1\u7BA1\u653F\u7B56\u3001\u8FDD\u53CD\u672C\u534F\u8BAE\u6216\u6709\u635FEnjoy Game\u6216/\u53CA\u5176\u5173\u8054\u516C\u53F8\u7684\u58F0\u8A89\u3001\u5229\u76CA\u7684\u884C\u4E3A\u7684\uFF1B</p>\n              <p class="p1">\uFF083\uFF09Enjoy Game\u6839\u636E\u6CD5\u5F8B\u6CD5\u89C4\u3001\u76D1\u7BA1\u653F\u7B56\u7684\u89C4\u5B9A\u6216\u6709\u6743\u673A\u5173\u7684\u8981\u6C42\uFF1B</p>\n              <p class="p1">\uFF084\uFF09Enjoy Game\u4E3A\u7EF4\u62A4\u8D26\u53F7\u4E0E\u7CFB\u7EDF\u5B89\u5168\u7B49\u7D27\u6025\u60C5\u51B5\u4E4B\u9700\u8981\uFF1B</p>\n              <p class="p1">\uFF085\uFF09\u4E0D\u53EF\u6297\u529B\uFF08\u9274\u4E8E\u4E92\u8054\u7F51\u4E4B\u7279\u6B8A\u6027\u8D28\uFF0C\u4E0D\u53EF\u6297\u529B\u4EA6\u5305\u62EC\u9ED1\u5BA2\u653B\u51FB\u3001\u7535\u4FE1\u90E8\u95E8\u6280\u672F\u8C03\u6574\u5BFC\u81F4\u4E4B\u91CD\u5927\u5F71\u54CD\u3001\u56E0\u653F\u5E9C\u7BA1\u5236\u800C\u9020\u6210\u4E4B\u6682\u65F6\u5173\u95ED\u3001\u75C5\u6BD2\u4FB5\u88AD\u7B49\u5F71\u54CD\u4E92\u8054\u7F51\u6B63\u5E38\u8FD0\u884C\u4E4B\u60C5\u5F62\uFF09\uFF1B</p>\n              <p class="p1">\uFF086\uFF09\u5176\u4ED6Enjoy Game\u65E0\u6CD5\u6297\u62D2\u7684\u60C5\u51B5\u3002</p>\n\n              <p>9.\u5F53\u53D1\u751F\u524D\u8FF0\u7EC8\u6B62\u7684\u60C5\u51B5\u65F6\uFF0C\u60A8\u4E0EEnjoy Game\u5747\u8BA4\u53EF\u5982\u4E0B\u5904\u7406\u65B9\u5F0F\uFF1A</p>\n              <p class="p1">\uFF081\uFF09\u5DF2\u7ECF\u4EA7\u751F\u4F46\u672A\u4F7F\u7528\u7684\u4ED8\u8D39\u670D\u52A1\u81EA\u52A8\u6E05\u9664\u4E14\u4E0D\u6298\u73B0\uFF1B</p>\n              <p class="p1">\uFF082\uFF09\u5982\u60A8\u5728Enjoy Game\u5E73\u53F0\u5185\u6709\u6B63\u5728\u8FDB\u884C\u4E2D\u7684\u4EA4\u6613\uFF0CEnjoy Game\u5C4A\u65F6\u5C06\u89C6\u60C5\u51B5\u8FDB\u884C\u5408\u7406\u5904\u7406\uFF1B</p>\n              <p class="p1">\uFF083\uFF09\u9664\u6CD5\u5F8B\u6CD5\u89C4\u53E6\u6709\u89C4\u5B9A\u6216Enjoy Game\u53E6\u6709\u8BF4\u660E\u5916\uFF0CEnjoy Game\u5DF2\u6536\u53D6\u7684\u8D39\u7528\u4E0D\u4E88\u9000\u8FD8\uFF1B</p>\n              <p class="p1">\uFF084\uFF09\u5982\u56E0\u60A8\u8FDD\u53CD\u672C\u534F\u8BAE\u5BFC\u81F4\u7EC8\u6B62\u7684\uFF0CEnjoy Game\u6709\u6743\u89C6\u60C5\u51B5\u8981\u6C42\u60A8\u627F\u62C5\u76F8\u5E94\u7684\u8FDD\u7EA6\u8D23\u4EFB\uFF1B</p>\n              <p class="p1">\uFF085\uFF09\u9664\u6CD5\u5F8B\u6CD5\u89C4\u53E6\u6709\u89C4\u5B9A\u6216Enjoy Game\u53E6\u6709\u8BF4\u660E\u5916\uFF0CEnjoy Game\u65E0\u9700\u5411\u60A8\u548C\u7B2C\u4E09\u4EBA\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\u3002</p>\n\n              <p>10.\u60A8\u77E5\u6089\u5E76\u786E\u8BA4\uFF0C\u56E0\u6E38\u5BA2\u767B\u5165\u65B9\u5F0F\u4ED8\u8D39\u8D2D\u4E70\u670D\u52A1\uFF0C\u670D\u52A1\u5C06\u4F1A\u7ED1\u5B9A\u60A8\u8D2D\u4E70\u670D\u52A1\u65F6\u6240\u7528\u7684\u8BBE\u5907\uFF0C\u670D\u52A1\u4E5F\u5C06\u4EC5\u53EF\u5728\u7ED1\u5B9A\u8BBE\u5907\u4E0A\u4F7F\u7528\uFF0C\u5982\u60A8\u9700\u5728\u5176\u4ED6\u8BBE\u5907\u4E2D\u4F7F\u7528\uFF0C\u8BF7\u6309\u7167\u9875\u9762\u64CD\u4F5C\u6307\u5F15\u7ED1\u5B9A\u60A8\u7684EG\u6CE8\u518C\u8D26\u53F7</p>\n              <p class="p1">\uFF081\uFF09\u4ED8\u8D39\u670D\u52A1\u4E2D\u5305\u542BEnjoy Game\u89E3\u51B3\u6545\u969C\u3001\u670D\u52A1\u5668\u7EF4\u4FEE\u3001\u8C03\u6574\u3001\u5347\u7EA7\u7B49\u6240\u9700\u7528\u7684\u5408\u7406\u65F6\u95F4\uFF0C\u5BF9\u4E0A\u8FF0\u60C5\u51B5\u6240\u9700\u7528\u7684\u65F6\u95F4\u6216\u9020\u6210\u7684\u4EFB\u4F55\u635F\u5931\uFF08\u5982\u6709\uFF09\uFF0CEnjoy Game\u4E0D\u4E88\u4EFB\u4F55\u5F62\u5F0F\u7684\u8D54\u507F/\u8865\u507F\uFF0C\u4F46Enjoy Game\u4F1A\u5C3D\u53EF\u80FD\u5C06\u5F71\u54CD\u964D\u81F3\u6700\u4F4E\u3002</p>\n              <p class="p1">\uFF082\uFF09\u7528\u6237\u4ED8\u8D39\u540E\uFF0C\u53EF\u80FD\u4F1A\u56E0\u7528\u6237\u4F7F\u7528\u7684\u8F6F\u4EF6\u7248\u672C\u3001\u8BBE\u5907\u3001\u64CD\u4F5C\u7CFB\u7EDF\u7B49\u4E0D\u540C\u4EE5\u53CA\u5176\u4ED6\u7B2C\u4E09\u65B9\u539F\u56E0\u5BFC\u81F4\u5B9E\u9645\u53EF\u4F7F\u7528\u7684\u5177\u4F53\u6743\u76CA\u6216\u670D\u52A1\u5185\u5BB9\u6709\u5DEE\u522B\uFF0C\u7531\u6B64\u53EF\u80FD\u7ED9\u60A8\u5E26\u6765\u7684\u4E0D\u4FBF\uFF0C\u60A8\u8868\u793A\u7406\u89E3\u4E14\u4E0D\u4E88\u8FFD\u7A76\u6216\u8C41\u514DEnjoy Game\u7684\u76F8\u5173\u8D23\u4EFB\u3002Enjoy Game\u5EFA\u8BAE\u60A8\u53EF\u4EE5\u901A\u8FC7\u5347\u7EA7\u5E94\u7528\u7A0B\u5E8F\u6216\u64CD\u4F5C\u7CFB\u7EDF\u7248\u672C\u3001\u66F4\u6362\u4F7F\u7528\u8BBE\u5907\u7B49\u65B9\u5F0F\u6765\u5C1D\u8BD5\u89E3\u51B3\uFF0C\u6216\u8005\u76F4\u63A5\u901A\u8FC7\u672C\u534F\u8BAE\u63D0\u4F9B\u7684\u65B9\u5F0F\u4E0EEnjoy Game\u8054\u7CFB\u8FDB\u884C\u89E3\u51B3\u3002</p>\n              <p class="p1">\uFF083\uFF09\u7528\u6237\u8D26\u53F7\u4E0B\u7684\u6240\u6709\u884C\u4E3A\u89C6\u4E3A\u60A8\u672C\u4EBA\u7684\u884C\u4E3A\uFF1B\u800C\u4E14\u60A8\u5E94\u5BF9\u81EA\u8EAB\u5728\u83B7\u53D6\u548C\u4F7F\u7528\u670D\u52A1\u65F6\u7684\u4E00\u5207\u884C\u4E3A\uFF08\u65E0\u8BBA\u662F\u5426\u6545\u610F\uFF09\u8D1F\u5168\u90E8\u8D23\u4EFB\u3002Enjoy Game\u4EAB\u6709\u5BF9\u60A8\u5728\u83B7\u53D6\u548C\u4F7F\u7528\u670D\u52A1\u53CA\u5176\u76F8\u5173\u6D3B\u52A8\u8FC7\u7A0B\u4E2D\u7684\u76D1\u7763\u3001\u63D0\u793A\u7684\u6743\u5229\uFF0C\u5982\u60A8\u7684\u884C\u4E3A\u8FDD\u53CD\u6709\u5173\u6CD5\u5F8B\u6CD5\u89C4\u6216\u8FDD\u53CD\u672C\u534F\u8BAE\u7684\u7EA6\u5B9A\uFF0CEnjoy Game\u4EAB\u6709\u8981\u6C42\u60A8\u7EA0\u6B63\u53CA\u8FFD\u7A76\u60A8\u8D23\u4EFB\u7B49\u6743\u5229\u3002</p>\n              <p class="p1">\uFF084\uFF09\u60A8\u77E5\u6089\u5E76\u540C\u610F\uFF0C\u60A8\u5E94\u9075\u5FAAEnjoy Game\u5B98\u65B9\u6E20\u9053\u516C\u5E03\u7684\u6D41\u7A0B\u3001\u5E73\u53F0\u89C4\u8303\u7B49\u83B7\u53D6\u670D\u52A1\uFF0C\u4E0D\u5F97\u81EA\u884C\u6216\u534F\u52A9\u4ED6\u4EBA\u901A\u8FC7\u4EE5\u4E0B\u4EFB\u4E00\u65B9\u5F0F\u83B7\u53D6\u670D\u52A1\u3002\u5426\u5219\uFF0CEnjoy Game\u6709\u6743\u4E0D\u7ECF\u901A\u77E5\u62D2\u7EDD\u60A8\u7684\u7533\u8BF7\u6216\u64A4\u9500\u6D89\u53CA\u7684\u670D\u52A1\u8D44\u683C\u3001\u62D2\u7EDD\u6216\u7EC8\u6B62\u4E3A\u60A8\u63D0\u4F9B\u670D\u52A1\uFF0C\u5E76\u4E0D\u9000\u8FD8\u4ED8\u8D39\u4E14\u4E0D\u4E88\u652F\u4ED8\u4EFB\u4F55\u5F62\u5F0F\u7684\u4EFB\u4F55\u8D54\u507F/\u8865\u507F\uFF0C\u540C\u65F6Enjoy Game\u6709\u6743\u8FFD\u7A76\u60A8\u7684\u76F8\u5173\u6CD5\u5F8B\u8D23\u4EFB\uFF1A</p>\n              <p class="p1">\uFF085\uFF09\u672A\u7ECFEnjoy Game\u660E\u786E\u6388\u6743\uFF0C\u4EE5\u5546\u4E1A\u6027\u6216\u5176\u4ED6\u975E\u4E2A\u4EBA\u4F7F\u7528\u7B49\u76EE\u7684\u4E3A\u81EA\u5DF1\u6216\u4ED6\u4EBA\u83B7\u53D6\u3001\u4F7F\u7528Enjoy Game\u670D\u52A1\uFF1B</p>\n              <p class="p1">\uFF086\uFF09\u672A\u7ECFEnjoy Game\u660E\u786E\u6388\u6743\uFF0C\u901A\u8FC7\u673A\u5668\u4EBA\u8F6F\u4EF6\u3001\u8718\u86DB\u8F6F\u4EF6\u3001\u722C\u866B\u8F6F\u4EF6\u7B49\u4EFB\u4F55\u81EA\u52A8\u7A0B\u5E8F\u3001\u811A\u672C\u3001\u8F6F\u4EF6\u7B49\u65B9\u5F0F\u83B7\u53D6\u670D\u52A1\u3001\u5185\u5BB9\u3001\u6570\u636E\uFF1B</p>\n              <p class="p1">\uFF087\uFF09\u672A\u7ECFEnjoy Game\u660E\u786E\u6388\u6743\uFF0C\u901A\u8FC7\u6280\u672F\u624B\u6BB5\u5BF9\u670D\u52A1\u5185\u5BB9\u3001\u670D\u52A1\u671F\u9650\u3001\u6D88\u8D39\u91D1\u989D\u3001\u4EA4\u6613\u72B6\u6001\u7B49\u4FE1\u606F\u8FDB\u884C\u4FEE\u6539\uFF1B</p>\n              <p class="p1">\uFF088\uFF09\u5C06\u670D\u52A1\u901A\u8FC7\u975EEnjoy Game\u660E\u786E\u6388\u6743\u7684\u65B9\u5F0F\u5728Enjoy Game\u8D26\u53F7\u4E4B\u95F4\u8F6C\u79FB\uFF0C\u6216\u672A\u7ECFEnjoy Game\u660E\u786E\u6388\u6743\u800C\u8D60\u4E0E\u3001\u501F\u7528\u3001\u79DF\u7528\u3001\u9500\u552E\u3001\u8F6C\u8BA9\u670D\u52A1\u8D44\u683C\uFF1B</p>\n              <p class="p1">\uFF089\uFF09\u672A\u7ECFEnjoy Game\u660E\u786E\u6388\u6743\uFF0C\u5C06\u670D\u52A1\u5185\u5BB9\u5168\u90E8\u6216\u90E8\u5206\u8FDB\u884C\u590D\u5236\u3001\u4E0B\u8F7D\u3001\u4E0A\u4F20\u3001\u4FEE\u6539\u3001\u7F16\u76EE\u6392\u5E8F\u3001\u7FFB\u8BD1\u3001\u53D1\u884C\u3001\u5F00\u53D1\u3001\u8F6C\u8BA9\u3001\u9500\u552E\u3001\u5C55\u793A\u3001\u4F20\u64AD\u3001\u5408\u6210\u3001\u5D4C\u5957\u3001\u94FE\u63A5\u3001\u521B\u4F5C\u884D\u751F\u4F5C\u54C1\u3001\u8FDB\u884C\u5546\u4E1A\u5F00\u53D1\u6216\u63A8\u5E7F\u7B49\uFF1B</p>\n              <p class="p1">\uFF0810\uFF09\u5BF9Enjoy Game\u7528\u4E8E\u4FDD\u62A4\u7528\u6237\u670D\u52A1\u7684\u4EFB\u4F55\u5B89\u5168\u63AA\u65BD\u6280\u672F\u8FDB\u884C\u7834\u89E3\u3001\u66F4\u6539\u3001\u53CD\u64CD\u4F5C\u3001\u7BE1\u6539\u6216\u5176\u4ED6\u7834\u574F\uFF1B\u672A\u7ECFEnjoy Game\u4E8B\u5148\u4E66\u9762\u540C\u610F\u800C\u5220\u9664\u670D\u52A1\u5185\u5BB9\u4E0A\u7684\u4EFB\u4F55\u6240\u6709\u6743\u6216\u77E5\u8BC6\u4EA7\u6743\u58F0\u660E\u6216\u6807\u7B7E\uFF1B</p>\n              <p class="p1">\uFF0811\uFF09\u672A\u7ECFEnjoy Game\u660E\u786E\u6388\u6743\uFF0C\u91C7\u7528\u6536\u8D39\u6216\u514D\u8D39\u7684\u65B9\u5F0F\uFF0C\u5728\u4EFB\u4F55\u516C\u5F00\u573A\u5408\u5168\u90E8\u6216\u90E8\u5206\u5C55\u793A\u670D\u52A1\u5185\u5BB9\uFF08\u4F46\u5982\u60A8\u7684\u4E0A\u8FF0\u884C\u4E3A\u4E0D\u6784\u6210\u4FB5\u6743\u7684\u9664\u5916\uFF09\uFF1B</p>\n              <p class="p1">\uFF0812\uFF09\u901A\u8FC7\u4E0D\u6B63\u5F53\u624B\u6BB5\u6216\u4EE5\u8FDD\u53CD\u8BDA\u5B9E\u4FE1\u7528\u539F\u5219\u7684\u65B9\u5F0F\uFF08\u5982\u5229\u7528\u89C4\u5219\u6F0F\u6D1E\u3001\u5229\u7528\u7CFB\u7EDF\u6F0F\u6D1E\u3001\u6EE5\u7528\u4F1A\u5458\u8EAB\u4EFD\u3001\u9ED1\u8272\u4EA7\u4E1A\u3001\u6295\u673A\u7B49\u8FDD\u80CCEnjoy Game\u63D0\u4F9B\u670D\u52A1/\u4E3E\u529E\u6D3B\u52A8\u7684\u521D\u8877\u7684\u65B9\u5F0F\uFF09\uFF1B</p>\n              <p class="p1">\uFF0813\uFF09\u901A\u8FC7\u4FB5\u72AFEnjoy Game\u6216\u4ED6\u4EBA\u5408\u6CD5\u6743\u76CA\u7684\u65B9\u5F0F\uFF1B</p>\n              <p class="p1">\uFF0814\uFF09\u5176\u4ED6\u672A\u7ECFEnjoy Game\u660E\u793A\u6388\u6743\u8BB8\u53EF\u6216\u8FDD\u53CD\u672C\u534F\u8BAE\u3001\u6CD5\u5F8B\u6CD5\u89C4\u6216\u76D1\u7BA1\u653F\u7B56\u7684\u884C\u4E3A\u3002</p>\n\n              <p>11.\u60A8\u77E5\u6089\u5E76\u540C\u610F\uFF0C\u5982\u60A8\u5B58\u5728\u6216Enjoy Game\u7ECF\u72EC\u7ACB\u5224\u65AD\u540E\u8BA4\u4E3A\u60A8\u5B58\u5728\u4EFB\u4F55\u8FDD\u53CD\u6CD5\u5F8B\u6CD5\u89C4\u6216\u76D1\u7BA1\u653F\u7B56\u3001\u8FDD\u53CD\u672C\u534F\u8BAE\u6216\u6709\u635FEnjoy Game\u6216/\u53CA\u5176\u5173\u8054\u516C\u53F8\u7684\u58F0\u8A89\u3001\u5229\u76CA\u7684\u884C\u4E3A\u7684\uFF0CEnjoy Game\u6709\u6743\u72EC\u7ACB\u51B3\u5B9A\u91C7\u53D6\u4EE5\u4E0B\u4E00\u9879\u6216\u591A\u9879\u5904\u7406\u63AA\u65BD\uFF1A</p>\n              <p class="p1">\uFF081\uFF09\u5982\u672C\u534F\u8BAE\u5BF9\u6B64\u884C\u4E3A\u6709\u5355\u72EC\u6761\u6B3E\u7EA6\u5B9A\u5904\u7406\u65B9\u5F0F\u7684\uFF0C\u6309\u7167\u8BE5\u6761\u6B3E\u5904\u7406\uFF1B</p>\n              <p class="p1">\uFF082\uFF09\u65E0\u9700\u901A\u77E5\u60A8\u800C\u91C7\u53D6\u4E00\u79CD\u6216\u591A\u79CD\u63AA\u65BD\u5236\u6B62\u60A8\u7684\u884C\u4E3A\u53CA\u884C\u4E3A\u4EA7\u751F\u7684\u540E\u679C\uFF0C\u5982\u5220\u9664/\u5C4F\u853D\u76F8\u5173\u94FE\u63A5\u6216\u5185\u5BB9\u3001\u9650\u5236/\u53D6\u6D88\u60A8\u7684\u8D26\u53F7/\u8D26\u6237\u4F7F\u7528\u6743\u9650\u7B49\uFF1B</p>\n              <p class="p1">\uFF083\uFF09\u65E0\u9700\u901A\u77E5\u60A8\u800C\u4E2D\u65AD\u6216\u7EC8\u6B62\u90E8\u5206\u6216\u5168\u90E8\u670D\u52A1\uFF0C\u4E14\u60A8\u5DF2\u4EA4\u7EB3\u7684\u8D39\u7528\u5C06\u4E0D\u4E88\u9000\u8FD8\u4E14\u4E0D\u83B7\u5F97\u4EFB\u4F55\u5F62\u5F0F\u7684\u8865\u507F/\u8D54\u507F\uFF1B</p>\n              <p class="p1">\uFF084\uFF09\u5982\u60A8\u7684\u884C\u4E3A\u4F7FEnjoy Game\u6216/\u53CA\u5176\u5173\u8054\u516C\u53F8\u906D\u53D7\u4EFB\u4F55\u635F\u5931\u7684\uFF0C\u60A8\u5E94\u5F53\u627F\u62C5\u5168\u90E8\u635F\u5931\u8D54\u507F\u8D23\u4EFB\u5E76\u5728Enjoy Game\u8981\u6C42\u7684\u65F6\u9650\u5185\u5B8C\u6210\u8D39\u7528\u652F\u4ED8\u3002</p>\n\n              <h4 style="margin-top:21px">\u534F\u8BAE\u7684\u53D8\u66F4</h4>\n\n              <p class="p1">1. Enjoy Game\u6709\u6743\u53D8\u66F4\u672C\u534F\u8BAE\u5185\u5BB9\uFF0C\u5BF9\u6B64\uFF0CEnjoy Game\u5C06\u5728\u76F8\u5E94\u9875\u9762\u6216\u4EE5\u5176\u4ED6\u5408\u7406\u65B9\u5F0F\u8FDB\u884C\u901A\u77E5\u3002\u901A\u77E5\u4E00\u7ECF\u53D1\u9001\u5373\u89C6\u4E3A\u5DF2\u6210\u529F\u901A\u77E5\u60A8\u3002</p>\n              <p class="p1">2.\u5982\u534F\u8BAE\u53D1\u751F\u53D8\u66F4\uFF0C\u4F46\u60A8\u4E0D\u540C\u610F\u53D8\u66F4\u7684\u5185\u5BB9\u7684\uFF0C\u60A8\u6709\u6743\u9009\u62E9\u505C\u6B62\u4F7F\u7528Enjoy Game\u5E94\u7528\u548C\u670D\u52A1\u3002\u5982\u60A8\u5728\u53D8\u66F4\u540E\u7684\u534F\u8BAE\u751F\u6548\u540E\u4ECD\u7EE7\u7EED\u4F7F\u7528Enjoy Game\u5E94\u7528\u548C\u670D\u52A1\u7684\uFF0C\u5219\u89C6\u4E3A\u60A8\u5DF2\u7ECF\u540C\u610F\u53D8\u66F4\u7684\u5168\u90E8\u5185\u5BB9\u3002</p>',
	                'en-US': '<h3>Refund Agreement</h3>\n\n              <h4>Terms of Use of EG Points: </h4>\n              <p>1. If users use the Points for lucky draws, exchanges or trade-ins, Enjoy Game will not provide operation modification or point refund services for the already consumed Points;</p>\n\n              <p>2.Enjoy Game has the right to unilaterally price the Points and Point commodities it provides, and has the right to make changes it deems fit to its operations without incurring any legal liabilities;</p>\n\n              <p>3. The publications, presentations and instructions on Enjoy Game Platform shall be the only interpretation of the Points regarding the sources, acquiring methods and quantity of Points users obtain, as well as their usages, validity, etc.;</p>\n\n              <p>4. The Points cannot be exchanged into cash.</p>\n\n              <div class="space"></div>\n\n              <h4>Management Regulations of EG Point Commodities:</h4>\n              <p>1. Unless otherwise specified, the rewards in lucky draws, exchanged gifts and trade-in commodities obtained by users using the Points are all virtual products instead of physical products (hereinafter referred to as \'Point Commodities\'). The specific usages, validity and scope of relevant Point Commodities shall conform to the instructions attached on the Enjoy Game pages;</p>\n\n              <p>2.The Point Commodities may be adjusted at any time due to users\u2019 requirements, Enjoy Game\'s self-regulations, market acceptance and other factors. The details are subject to Enjoy Game\u2019s pages on lucky draws, exchanges and trade-ins;</p>\n\n              <p>3. The Point service is a free bonus Enjoy Game offers to its users and no invoices will be issued for pure lucky draws and exchanged gifts. For gifts exchanged with \u201CPoints + cash\u201D, Enjoy Game will only issue invoice for the cash part, and the users are required to provide accurate invoice information and receiving address and pay the shipping fee. Enjoy Game will be deemed to have properly fulfilled its invoice service once it delivers invoice to the address provided by the users;</p>\n\n              <p>4. Due to the natures and characteristics of virtual commodities, Enjoy Game will not provide return or exchange for Point-related virtual commodities. In regard to Point-related physical commodities and Community Token-related physical commodities, Enjoy Game will not be responsible for flaws or damages caused by users;</p>\n\n              <p>5. Users are not allowed to use the Point service for any commercial purpose, such as sales, replacements or mortgages without obtaining Enjoy Game\u2019s written authorization. All users must obtain the Point service via proper channels. All Points and its derivative services obtained from unofficial channels will not be binding upon Enjoy Game, which has the right to unilaterally take back these Points and terminate related services. Enjoy Game has the right to ban the accounts in serious violation of its rules;</p>\n\n              <p>6. Unless otherwise specified, Points obtained by users via proper channels will not be refunded in any form of cash, and the users can only enjoy equivalent services with the Points. The services will be terminated after the users use up all Points and choose not to use the Point service any longer;</p>\n\n              <div class="space"></div>\n\n              <h4>Terms of Use of Enjoy Game Platform and its Subordinate Applications:</h4>\n              <p>1. Enjoy Game, as an application platform which publishes mainly mobile games, provides users with search services, and free or paid services of using its subordinate applications. Enjoy Game is a service provider, and its users hereby agree to exempt it from all direct and indirect legal liabilities for damages suffered when using Enjoy Game\u2019s subordinate applications;</p>\n\n              <p>2. Enjoy Game may charge its users when providing certain application contents, and the users can choose whether to pay for the service or not. The specific channels of payment include but not limited to Google Play E-wallet, Itunes top-up, EG Point top-up and other real currency or virtual currency. Under such circumstances, Enjoy Game will make explicit prompts on relevant pages. A user will not be able to use paid services if he/she chooses not to make the payment;</p>\n\n              <p>3. Enjoy Game has the right to determine the charging standards and methods for its application services, and the users understand and agree that Enjoy Game may set different charging standards and methods for different services, or different phases of services. Enjoy Game will publish the charging standards, charging methods, purchase methods and other charge policies related to the services;</p>\n\n              <p>4. The ownership or other rights to the applications and services provided by Enjoy Game belong to Enjoy Game and its right holders, and are protected by international laws. The users are not allowed to operate derivative products of Enjoy Game\u2019s applications and services without written and legal authorization from Enjoy Game or other right holders.</p>\n\n              <div class="space"></div>\n\n              <h4>Terms of Use of Top-Up Services (including automatic renewal service):</h4>\n              <p>1. Top-up services of Enjoy Game offer abundant applications and services to various users. The details are subject to instructions on the application or platform or actual services provided by Enjoy Game;</p>\n\n              <p>2. The users understand and agree that the top-up function of Enjoy Game offers internet commodities and virtual commodities by charging first. The charges depend on the price of internet commodities purchased by the users and they cannot be transferred or refunded after payment (except for circumstances in which commodities provided by Enjoy Game bear major defects and cannot be used at all);</p>\n\n              <p>3. Certain application contents offered by Enjoy Game are paid service and the users are required to make corresponding payment with bank card payment, third party payment or other payment methods Enjoy Game provides prior to using such services. In addition, you may also make payment via other channels recognized by Enjoy Game. The charging standard of paid services (including automatic renewal) will be determined by Enjoy Game based on its own operational strategies and displayed on the payment page. By completing the payment operation, you understand and agree to such charging standard and all contents displayed on the payment page;</p>\n\n              <p>4. Certain applications offer automatic renewal service for users (such as monthly card subscription function), i.e. users authorize Enjoy Game to entrust the payment channel to withhold charges for the next billing cycle from the balance in users\' account such as users\u2019 own top-up account, third party payment account or bank card bound to user account, or payment account bound to Apple Store account (hereinafter referred to as \u201CAccount\u201D) when the user service is expiring. You must bind your account or Apple Store account with one of the above accounts, and make sure full deduction can be made to realize this function. The billing cycle will be displayed on the purchase page and the users can choose by themselves;</p>\n\n              <p>5. After you activate the automatic renewal service, if Enjoy Game fails to deduct money from your account before the membership service expires due to insufficient balance or other reasons, Enjoy Game has the right to suspend or terminate the services when the membership service expires. The automatic renewal service can only be cancelled by users; if you fail to make such an operation, you are deemed to agree with Enjoy Game\u2019s deduction attempts within a certain period after the membership service expires based on the deduction rules of the payment channel (even if the balance in your account is insufficient). Enjoy Game will resume your use of the automatic renewal service and VIP membership service once it receives the charges in full within the prescribed period;</p>\n\n              <p>6. Special instruction on advertisement rights of Enjoy Game users: You may encounter commercial ads or other types of business information delivered in various forms during your use of Enjoy Game\u2019s services; you hereby understand and agree to such deliveries and Enjoy Game promises to lower the influence of such information on your application experience as much as possible.</p>\n\n              <p>7. You shall bear all liabilities for damages and make payment within the time prescribed by Enjoy Game if your actions resulted in any loss to Enjoy Game and its related companies.</p>\n\n              <p>8. Enjoy Game has the right to suspend or terminate its services for you if any of the following circumstances occurs:</p>\n\n              <p class="p1">(1) You make a request of suspension or termination of services;</p>\n              <p class="p1">(2) You have performed or, upon independent judgment by Enjoy Game, you are deemed to have performed any behaviors in violation of laws or regulations, regulatory policies or this Agreement, or behaviors that harmed the reputation and interests of Enjoy Game and/or its related companies;</p>\n              <p class="p1">(3) Such suspension or termination of services is required by laws and regulations, regulatory policies or competent authorities;</p>\n              <p class="p1">(4) Such suspension or termination of services is needed during emergencies, including Enjoy Game\u2019s efforts for maintenance of accounts and system security;</p>\n              <p class="p1">(5) Force majeure (in view of the special nature of Internet, forces majeures include hacker attack, major impacts due to technical adjustment of telecommunication department, temporary shutdown due to government regulation and virus attack which may interrupt the normal operation of Internet);</p>\n              <p class="p1">(6) Other situations beyond the control of Enjoy Game.</p>\n\n              <p>9. Both you and Enjoy Game agree to the following treatments when any of the above circumstances occurs:</p>\n              <p class="p1">(1) Already generated and unused paid services will be automatically cleared without being exchanged into cash;</p>\n              <p class="p1">(2) Enjoy Game will reasonably handle your ongoing transactions on Enjoy Game platform as the case may be;</p>\n              <p class="p1">(3) Unless otherwise indicated in laws or regulations, or specified by Enjoy Game, charges paid to Enjoy Game will not be refunded;</p>\n              <p class="p1">(4) Enjoy Game has the right to hold you accountable for corresponding liabilities for breach of agreement if this Agreement is terminated due to your violation;</p>\n              <p class="p1">(5) Unless otherwise indicated in laws or regulations, or specified by Enjoy Game, Enjoy Game assumes no responsibility for you or any other third party.</p>\n\n              <p>10. You acknowledge and confirm that the service you paid for as a Visitor will be bound to the device you used paying for the service, and can only be used on the bound device. Please bind your EG account following the operation guidance on the page if you wish to use the service on other devices.</p>\n              <p class="p1">(1) Paid services include reasonable time required for Enjoy Game to troubleshoot, repair the servers and make adjustments or upgrades. Enjoy Game will make compensation/remedy in any form for time required in the above situations or any loss so resulted (if any), but Enjoy Game will try to minimize the impacts.</p>\n              <p class="p1">(2) You hereby understand and exempt Enjoy Game from relevant liabilities if inconveniences arise due to differences in specific rights and services you receive because of differences in software versions, devices, operation systems or other third party reasons after payment. Enjoy Game suggests you solve this problem by upgrading the application program or operation system, changing your device, or contacting Enjoy Game directly through the contact information provided in this Agreement.</p>\n              <p class="p1">(3) All actions under your user account are deemed to be your own actions and you shall take full responsibility for all actions (whether they are intentional or non-intentional) when obtaining and using the services. Enjoy Game has the right to supervise and remind you during your acquiring and using of the services and other related activities. Enjoy Game has the right to rectify your actions in violation of laws and regulations or this Agreement, and hold you accountable for related liabilities.</p>\n              <p class="p1">(4) You acknowledge and agree to obtain services by following the flows and platform rules officially published by Enjoy Game, and not obtain or assist others to obtain the services using any of the following methods. Otherwise, Enjoy Game has the right to decline your application, revoke related service qualifications, refuse to provide you services or terminate such services without notifying you, nor making compensation/remedy in any form. Enjoy Game also has the right to hold you accountable for related legal liabilities:</p>\n              <p class="p1">(5) Obtain or use or assist others to obtain or use Enjoy Game services for commercial or any other non-personal purposes without explicit authorization from Enjoy Game;</p>\n              <p class="p1">(6) Obtain services, contents or data through any automatic programs, scripts or software including robot software, spider software and crawler software without explicit authorization from Enjoy Game;</p>\n              <p class="p1">(7) Alter the service content, service period, sum of consumption, transaction status and other information using technical means without specific authorization from Enjoy Game;</p>\n              <p class="p1">(8) Transfer the services among Enjoy Game accounts via unauthorized methods of Enjoy Game, or grant, borrow, rent, sell or transfer the service qualification without explicit authorization from Enjoy Game;</p>\n              <p class="p1">(9) Reproduce, download, upload, alter, catalogue, sort out, translate, publish, develop, transfer, sell, present, transmit, synthesize, nest or link part or all of the service contents, or create derivative works from these contents for commercial development or promotion without explicit authorization from Enjoy Game;</p>\n              <p class="p1">(10) Crack, alter, anti-operate, tamper or damage any security measures adopted by Enjoy Game for the protection of its user services, or delete any declaration or label of ownership or intellectual property rights attached on Enjoy Game\u2019s service contents without prior written consent from Enjoy Game;</p>\n              <p class="p1">(11) Display part or all of the service contents in any public places for free or not without explicit authorization from Enjoy Game (except for cases in which your above behaviors do not constitute infringement);</p>\n              <p class="p1">(12) Use improper means or means in violation of the principle of honesty and credibility (such as means against the original purpose of Enjoy Game providing services/organizing activities, including utilizing loopholes in rules or system, misuse of membership, black industry or speculation);</p>\n              <p class="p1">(13) Use means in violation of legal rights of Enjoy Game or any other person;</p>\n              <p class="p1">(14) Other actions without Enjoy Game\u2019s explicit authorization or in violation of this Agreement, laws and regulations or regulatory policies.</p>\n\n              <p>11. You acknowledge and agree that Enjoy Game has the right to take one or more of the following measures at its sole discretion if you performed or, upon independent judgment by Enjoy Game, you are deemed to have performed any behaviors in violation of laws or regulations, regulatory policies or this Agreement, or behaviors that harmed the reputation and interests of Enjoy Game and/or its related companies:</p>\n              <p class="p1">(1) If this Agreement contains a separate clause regarding treatment of such behaviors, such clause shall apply;</p>\n              <p class="p1">(2) One or more measures will be adopted to restrain the consequences of your actions and behaviors without notifying you, such as deleting/blocking related links or contents, or restricting/cancelling your account/rights of using your account;</p>\n              <p class="p1">(3) Suspend or terminate part or all services without notifying you, and the charges you paid will not be refunded or compensated/remedied in any form;</p>\n              <p class="p1">(4) You shall bear all liabilities for damages and make payment within the time prescribed by Enjoy Game if your actions resulted in any loss to Enjoy Game and/or its related companies.</p>\n\n              <h4 style="margin-top:21px">Change in Agreement</h4>\n\n              <p class="p1">1. Enjoy Game has the right to change contents in this Agreement and will notify the users on relevant pages or in other reasonable manners. You are deemed to be notified once the notice is sent.</p>\n              <p class="p1">2. You have the right to terminate your use of Enjoy Game\'s applications and its services if changes are made to this Agreement yet you don\'t agree with such changes. However, you\'ll be deemed as fully agree with all changed contents should you keep using Enjoy Game\'s applications and services after the changed agreement takes effect.</p>',
	                'th-TH': '<h3>Refund Agreement</h3>\n\n              <h4>Terms of Use of EG Points: </h4>\n              <p>1. If users use the Points for lucky draws, exchanges or trade-ins, Enjoy Game will not provide operation modification or point refund services for the already consumed Points;</p>\n\n              <p>2.Enjoy Game has the right to unilaterally price the Points and Point commodities it provides, and has the right to make changes it deems fit to its operations without incurring any legal liabilities;</p>\n\n              <p>3. The publications, presentations and instructions on Enjoy Game Platform shall be the only interpretation of the Points regarding the sources, acquiring methods and quantity of Points users obtain, as well as their usages, validity, etc.;</p>\n\n              <p>4. The Points cannot be exchanged into cash.</p>\n\n              <div class="space"></div>\n\n              <h4>Management Regulations of EG Point Commodities:</h4>\n              <p>1. Unless otherwise specified, the rewards in lucky draws, exchanged gifts and trade-in commodities obtained by users using the Points are all virtual products instead of physical products (hereinafter referred to as \'Point Commodities\'). The specific usages, validity and scope of relevant Point Commodities shall conform to the instructions attached on the Enjoy Game pages;</p>\n\n              <p>2.The Point Commodities may be adjusted at any time due to users\u2019 requirements, Enjoy Game\'s self-regulations, market acceptance and other factors. The details are subject to Enjoy Game\u2019s pages on lucky draws, exchanges and trade-ins;</p>\n\n              <p>3. The Point service is a free bonus Enjoy Game offers to its users and no invoices will be issued for pure lucky draws and exchanged gifts. For gifts exchanged with \u201CPoints + cash\u201D, Enjoy Game will only issue invoice for the cash part, and the users are required to provide accurate invoice information and receiving address and pay the shipping fee. Enjoy Game will be deemed to have properly fulfilled its invoice service once it delivers invoice to the address provided by the users;</p>\n\n              <p>4. Due to the natures and characteristics of virtual commodities, Enjoy Game will not provide return or exchange for Point-related virtual commodities. In regard to Point-related physical commodities and Community Token-related physical commodities, Enjoy Game will not be responsible for flaws or damages caused by users;</p>\n\n              <p>5. Users are not allowed to use the Point service for any commercial purpose, such as sales, replacements or mortgages without obtaining Enjoy Game\u2019s written authorization. All users must obtain the Point service via proper channels. All Points and its derivative services obtained from unofficial channels will not be binding upon Enjoy Game, which has the right to unilaterally take back these Points and terminate related services. Enjoy Game has the right to ban the accounts in serious violation of its rules;</p>\n\n              <p>6. Unless otherwise specified, Points obtained by users via proper channels will not be refunded in any form of cash, and the users can only enjoy equivalent services with the Points. The services will be terminated after the users use up all Points and choose not to use the Point service any longer;</p>\n\n              <div class="space"></div>\n\n              <h4>Terms of Use of Enjoy Game Platform and its Subordinate Applications:</h4>\n              <p>1. Enjoy Game, as an application platform which publishes mainly mobile games, provides users with search services, and free or paid services of using its subordinate applications. Enjoy Game is a service provider, and its users hereby agree to exempt it from all direct and indirect legal liabilities for damages suffered when using Enjoy Game\u2019s subordinate applications;</p>\n\n              <p>2. Enjoy Game may charge its users when providing certain application contents, and the users can choose whether to pay for the service or not. The specific channels of payment include but not limited to Google Play E-wallet, Itunes top-up, EG Point top-up and other real currency or virtual currency. Under such circumstances, Enjoy Game will make explicit prompts on relevant pages. A user will not be able to use paid services if he/she chooses not to make the payment;</p>\n\n              <p>3. Enjoy Game has the right to determine the charging standards and methods for its application services, and the users understand and agree that Enjoy Game may set different charging standards and methods for different services, or different phases of services. Enjoy Game will publish the charging standards, charging methods, purchase methods and other charge policies related to the services;</p>\n\n              <p>4. The ownership or other rights to the applications and services provided by Enjoy Game belong to Enjoy Game and its right holders, and are protected by international laws. The users are not allowed to operate derivative products of Enjoy Game\u2019s applications and services without written and legal authorization from Enjoy Game or other right holders.</p>\n\n              <div class="space"></div>\n\n              <h4>Terms of Use of Top-Up Services (including automatic renewal service):</h4>\n              <p>1. Top-up services of Enjoy Game offer abundant applications and services to various users. The details are subject to instructions on the application or platform or actual services provided by Enjoy Game;</p>\n\n              <p>2. The users understand and agree that the top-up function of Enjoy Game offers internet commodities and virtual commodities by charging first. The charges depend on the price of internet commodities purchased by the users and they cannot be transferred or refunded after payment (except for circumstances in which commodities provided by Enjoy Game bear major defects and cannot be used at all);</p>\n\n              <p>3. Certain application contents offered by Enjoy Game are paid service and the users are required to make corresponding payment with bank card payment, third party payment or other payment methods Enjoy Game provides prior to using such services. In addition, you may also make payment via other channels recognized by Enjoy Game. The charging standard of paid services (including automatic renewal) will be determined by Enjoy Game based on its own operational strategies and displayed on the payment page. By completing the payment operation, you understand and agree to such charging standard and all contents displayed on the payment page;</p>\n\n              <p>4. Certain applications offer automatic renewal service for users (such as monthly card subscription function), i.e. users authorize Enjoy Game to entrust the payment channel to withhold charges for the next billing cycle from the balance in users\' account such as users\u2019 own top-up account, third party payment account or bank card bound to user account, or payment account bound to Apple Store account (hereinafter referred to as \u201CAccount\u201D) when the user service is expiring. You must bind your account or Apple Store account with one of the above accounts, and make sure full deduction can be made to realize this function. The billing cycle will be displayed on the purchase page and the users can choose by themselves;</p>\n\n              <p>5. After you activate the automatic renewal service, if Enjoy Game fails to deduct money from your account before the membership service expires due to insufficient balance or other reasons, Enjoy Game has the right to suspend or terminate the services when the membership service expires. The automatic renewal service can only be cancelled by users; if you fail to make such an operation, you are deemed to agree with Enjoy Game\u2019s deduction attempts within a certain period after the membership service expires based on the deduction rules of the payment channel (even if the balance in your account is insufficient). Enjoy Game will resume your use of the automatic renewal service and VIP membership service once it receives the charges in full within the prescribed period;</p>\n\n              <p>6. Special instruction on advertisement rights of Enjoy Game users: You may encounter commercial ads or other types of business information delivered in various forms during your use of Enjoy Game\u2019s services; you hereby understand and agree to such deliveries and Enjoy Game promises to lower the influence of such information on your application experience as much as possible.</p>\n\n              <p>7. You shall bear all liabilities for damages and make payment within the time prescribed by Enjoy Game if your actions resulted in any loss to Enjoy Game and its related companies.</p>\n\n              <p>8. Enjoy Game has the right to suspend or terminate its services for you if any of the following circumstances occurs:</p>\n\n              <p class="p1">(1) You make a request of suspension or termination of services;</p>\n              <p class="p1">(2) You have performed or, upon independent judgment by Enjoy Game, you are deemed to have performed any behaviors in violation of laws or regulations, regulatory policies or this Agreement, or behaviors that harmed the reputation and interests of Enjoy Game and/or its related companies;</p>\n              <p class="p1">(3) Such suspension or termination of services is required by laws and regulations, regulatory policies or competent authorities;</p>\n              <p class="p1">(4) Such suspension or termination of services is needed during emergencies, including Enjoy Game\u2019s efforts for maintenance of accounts and system security;</p>\n              <p class="p1">(5) Force majeure (in view of the special nature of Internet, forces majeures include hacker attack, major impacts due to technical adjustment of telecommunication department, temporary shutdown due to government regulation and virus attack which may interrupt the normal operation of Internet);</p>\n              <p class="p1">(6) Other situations beyond the control of Enjoy Game.</p>\n\n              <p>9. Both you and Enjoy Game agree to the following treatments when any of the above circumstances occurs:</p>\n              <p class="p1">(1) Already generated and unused paid services will be automatically cleared without being exchanged into cash;</p>\n              <p class="p1">(2) Enjoy Game will reasonably handle your ongoing transactions on Enjoy Game platform as the case may be;</p>\n              <p class="p1">(3) Unless otherwise indicated in laws or regulations, or specified by Enjoy Game, charges paid to Enjoy Game will not be refunded;</p>\n              <p class="p1">(4) Enjoy Game has the right to hold you accountable for corresponding liabilities for breach of agreement if this Agreement is terminated due to your violation;</p>\n              <p class="p1">(5) Unless otherwise indicated in laws or regulations, or specified by Enjoy Game, Enjoy Game assumes no responsibility for you or any other third party.</p>\n\n              <p>10. You acknowledge and confirm that the service you paid for as a Visitor will be bound to the device you used paying for the service, and can only be used on the bound device. Please bind your EG account following the operation guidance on the page if you wish to use the service on other devices.</p>\n              <p class="p1">(1) Paid services include reasonable time required for Enjoy Game to troubleshoot, repair the servers and make adjustments or upgrades. Enjoy Game will make compensation/remedy in any form for time required in the above situations or any loss so resulted (if any), but Enjoy Game will try to minimize the impacts.</p>\n              <p class="p1">(2) You hereby understand and exempt Enjoy Game from relevant liabilities if inconveniences arise due to differences in specific rights and services you receive because of differences in software versions, devices, operation systems or other third party reasons after payment. Enjoy Game suggests you solve this problem by upgrading the application program or operation system, changing your device, or contacting Enjoy Game directly through the contact information provided in this Agreement.</p>\n              <p class="p1">(3) All actions under your user account are deemed to be your own actions and you shall take full responsibility for all actions (whether they are intentional or non-intentional) when obtaining and using the services. Enjoy Game has the right to supervise and remind you during your acquiring and using of the services and other related activities. Enjoy Game has the right to rectify your actions in violation of laws and regulations or this Agreement, and hold you accountable for related liabilities.</p>\n              <p class="p1">(4) You acknowledge and agree to obtain services by following the flows and platform rules officially published by Enjoy Game, and not obtain or assist others to obtain the services using any of the following methods. Otherwise, Enjoy Game has the right to decline your application, revoke related service qualifications, refuse to provide you services or terminate such services without notifying you, nor making compensation/remedy in any form. Enjoy Game also has the right to hold you accountable for related legal liabilities:</p>\n              <p class="p1">(5) Obtain or use or assist others to obtain or use Enjoy Game services for commercial or any other non-personal purposes without explicit authorization from Enjoy Game;</p>\n              <p class="p1">(6) Obtain services, contents or data through any automatic programs, scripts or software including robot software, spider software and crawler software without explicit authorization from Enjoy Game;</p>\n              <p class="p1">(7) Alter the service content, service period, sum of consumption, transaction status and other information using technical means without specific authorization from Enjoy Game;</p>\n              <p class="p1">(8) Transfer the services among Enjoy Game accounts via unauthorized methods of Enjoy Game, or grant, borrow, rent, sell or transfer the service qualification without explicit authorization from Enjoy Game;</p>\n              <p class="p1">(9) Reproduce, download, upload, alter, catalogue, sort out, translate, publish, develop, transfer, sell, present, transmit, synthesize, nest or link part or all of the service contents, or create derivative works from these contents for commercial development or promotion without explicit authorization from Enjoy Game;</p>\n              <p class="p1">(10) Crack, alter, anti-operate, tamper or damage any security measures adopted by Enjoy Game for the protection of its user services, or delete any declaration or label of ownership or intellectual property rights attached on Enjoy Game\u2019s service contents without prior written consent from Enjoy Game;</p>\n              <p class="p1">(11) Display part or all of the service contents in any public places for free or not without explicit authorization from Enjoy Game (except for cases in which your above behaviors do not constitute infringement);</p>\n              <p class="p1">(12) Use improper means or means in violation of the principle of honesty and credibility (such as means against the original purpose of Enjoy Game providing services/organizing activities, including utilizing loopholes in rules or system, misuse of membership, black industry or speculation);</p>\n              <p class="p1">(13) Use means in violation of legal rights of Enjoy Game or any other person;</p>\n              <p class="p1">(14) Other actions without Enjoy Game\u2019s explicit authorization or in violation of this Agreement, laws and regulations or regulatory policies.</p>\n\n              <p>11. You acknowledge and agree that Enjoy Game has the right to take one or more of the following measures at its sole discretion if you performed or, upon independent judgment by Enjoy Game, you are deemed to have performed any behaviors in violation of laws or regulations, regulatory policies or this Agreement, or behaviors that harmed the reputation and interests of Enjoy Game and/or its related companies:</p>\n              <p class="p1">(1) If this Agreement contains a separate clause regarding treatment of such behaviors, such clause shall apply;</p>\n              <p class="p1">(2) One or more measures will be adopted to restrain the consequences of your actions and behaviors without notifying you, such as deleting/blocking related links or contents, or restricting/cancelling your account/rights of using your account;</p>\n              <p class="p1">(3) Suspend or terminate part or all services without notifying you, and the charges you paid will not be refunded or compensated/remedied in any form;</p>\n              <p class="p1">(4) You shall bear all liabilities for damages and make payment within the time prescribed by Enjoy Game if your actions resulted in any loss to Enjoy Game and/or its related companies.</p>\n\n              <h4 style="margin-top:21px">Change in Agreement</h4>\n\n              <p class="p1">1. Enjoy Game has the right to change contents in this Agreement and will notify the users on relevant pages or in other reasonable manners. You are deemed to be notified once the notice is sent.</p>\n              <p class="p1">2. You have the right to terminate your use of Enjoy Game\'s applications and its services if changes are made to this Agreement yet you don\'t agree with such changes. However, you\'ll be deemed as fully agree with all changed contents should you keep using Enjoy Game\'s applications and services after the changed agreement takes effect.</p>',
	                'vi-VN': '<h3>Refund Agreement</h3>\n\n              <h4>Terms of Use of EG Points: </h4>\n              <p>1. If users use the Points for lucky draws, exchanges or trade-ins, Enjoy Game will not provide operation modification or point refund services for the already consumed Points;</p>\n\n              <p>2.Enjoy Game has the right to unilaterally price the Points and Point commodities it provides, and has the right to make changes it deems fit to its operations without incurring any legal liabilities;</p>\n\n              <p>3. The publications, presentations and instructions on Enjoy Game Platform shall be the only interpretation of the Points regarding the sources, acquiring methods and quantity of Points users obtain, as well as their usages, validity, etc.;</p>\n\n              <p>4. The Points cannot be exchanged into cash.</p>\n\n              <div class="space"></div>\n\n              <h4>Management Regulations of EG Point Commodities:</h4>\n              <p>1. Unless otherwise specified, the rewards in lucky draws, exchanged gifts and trade-in commodities obtained by users using the Points are all virtual products instead of physical products (hereinafter referred to as \'Point Commodities\'). The specific usages, validity and scope of relevant Point Commodities shall conform to the instructions attached on the Enjoy Game pages;</p>\n\n              <p>2.The Point Commodities may be adjusted at any time due to users\u2019 requirements, Enjoy Game\'s self-regulations, market acceptance and other factors. The details are subject to Enjoy Game\u2019s pages on lucky draws, exchanges and trade-ins;</p>\n\n              <p>3. The Point service is a free bonus Enjoy Game offers to its users and no invoices will be issued for pure lucky draws and exchanged gifts. For gifts exchanged with \u201CPoints + cash\u201D, Enjoy Game will only issue invoice for the cash part, and the users are required to provide accurate invoice information and receiving address and pay the shipping fee. Enjoy Game will be deemed to have properly fulfilled its invoice service once it delivers invoice to the address provided by the users;</p>\n\n              <p>4. Due to the natures and characteristics of virtual commodities, Enjoy Game will not provide return or exchange for Point-related virtual commodities. In regard to Point-related physical commodities and Community Token-related physical commodities, Enjoy Game will not be responsible for flaws or damages caused by users;</p>\n\n              <p>5. Users are not allowed to use the Point service for any commercial purpose, such as sales, replacements or mortgages without obtaining Enjoy Game\u2019s written authorization. All users must obtain the Point service via proper channels. All Points and its derivative services obtained from unofficial channels will not be binding upon Enjoy Game, which has the right to unilaterally take back these Points and terminate related services. Enjoy Game has the right to ban the accounts in serious violation of its rules;</p>\n\n              <p>6. Unless otherwise specified, Points obtained by users via proper channels will not be refunded in any form of cash, and the users can only enjoy equivalent services with the Points. The services will be terminated after the users use up all Points and choose not to use the Point service any longer;</p>\n\n              <div class="space"></div>\n\n              <h4>Terms of Use of Enjoy Game Platform and its Subordinate Applications:</h4>\n              <p>1. Enjoy Game, as an application platform which publishes mainly mobile games, provides users with search services, and free or paid services of using its subordinate applications. Enjoy Game is a service provider, and its users hereby agree to exempt it from all direct and indirect legal liabilities for damages suffered when using Enjoy Game\u2019s subordinate applications;</p>\n\n              <p>2. Enjoy Game may charge its users when providing certain application contents, and the users can choose whether to pay for the service or not. The specific channels of payment include but not limited to Google Play E-wallet, Itunes top-up, EG Point top-up and other real currency or virtual currency. Under such circumstances, Enjoy Game will make explicit prompts on relevant pages. A user will not be able to use paid services if he/she chooses not to make the payment;</p>\n\n              <p>3. Enjoy Game has the right to determine the charging standards and methods for its application services, and the users understand and agree that Enjoy Game may set different charging standards and methods for different services, or different phases of services. Enjoy Game will publish the charging standards, charging methods, purchase methods and other charge policies related to the services;</p>\n\n              <p>4. The ownership or other rights to the applications and services provided by Enjoy Game belong to Enjoy Game and its right holders, and are protected by international laws. The users are not allowed to operate derivative products of Enjoy Game\u2019s applications and services without written and legal authorization from Enjoy Game or other right holders.</p>\n\n              <div class="space"></div>\n\n              <h4>Terms of Use of Top-Up Services (including automatic renewal service):</h4>\n              <p>1. Top-up services of Enjoy Game offer abundant applications and services to various users. The details are subject to instructions on the application or platform or actual services provided by Enjoy Game;</p>\n\n              <p>2. The users understand and agree that the top-up function of Enjoy Game offers internet commodities and virtual commodities by charging first. The charges depend on the price of internet commodities purchased by the users and they cannot be transferred or refunded after payment (except for circumstances in which commodities provided by Enjoy Game bear major defects and cannot be used at all);</p>\n\n              <p>3. Certain application contents offered by Enjoy Game are paid service and the users are required to make corresponding payment with bank card payment, third party payment or other payment methods Enjoy Game provides prior to using such services. In addition, you may also make payment via other channels recognized by Enjoy Game. The charging standard of paid services (including automatic renewal) will be determined by Enjoy Game based on its own operational strategies and displayed on the payment page. By completing the payment operation, you understand and agree to such charging standard and all contents displayed on the payment page;</p>\n\n              <p>4. Certain applications offer automatic renewal service for users (such as monthly card subscription function), i.e. users authorize Enjoy Game to entrust the payment channel to withhold charges for the next billing cycle from the balance in users\' account such as users\u2019 own top-up account, third party payment account or bank card bound to user account, or payment account bound to Apple Store account (hereinafter referred to as \u201CAccount\u201D) when the user service is expiring. You must bind your account or Apple Store account with one of the above accounts, and make sure full deduction can be made to realize this function. The billing cycle will be displayed on the purchase page and the users can choose by themselves;</p>\n\n              <p>5. After you activate the automatic renewal service, if Enjoy Game fails to deduct money from your account before the membership service expires due to insufficient balance or other reasons, Enjoy Game has the right to suspend or terminate the services when the membership service expires. The automatic renewal service can only be cancelled by users; if you fail to make such an operation, you are deemed to agree with Enjoy Game\u2019s deduction attempts within a certain period after the membership service expires based on the deduction rules of the payment channel (even if the balance in your account is insufficient). Enjoy Game will resume your use of the automatic renewal service and VIP membership service once it receives the charges in full within the prescribed period;</p>\n\n              <p>6. Special instruction on advertisement rights of Enjoy Game users: You may encounter commercial ads or other types of business information delivered in various forms during your use of Enjoy Game\u2019s services; you hereby understand and agree to such deliveries and Enjoy Game promises to lower the influence of such information on your application experience as much as possible.</p>\n\n              <p>7. You shall bear all liabilities for damages and make payment within the time prescribed by Enjoy Game if your actions resulted in any loss to Enjoy Game and its related companies.</p>\n\n              <p>8. Enjoy Game has the right to suspend or terminate its services for you if any of the following circumstances occurs:</p>\n\n              <p class="p1">(1) You make a request of suspension or termination of services;</p>\n              <p class="p1">(2) You have performed or, upon independent judgment by Enjoy Game, you are deemed to have performed any behaviors in violation of laws or regulations, regulatory policies or this Agreement, or behaviors that harmed the reputation and interests of Enjoy Game and/or its related companies;</p>\n              <p class="p1">(3) Such suspension or termination of services is required by laws and regulations, regulatory policies or competent authorities;</p>\n              <p class="p1">(4) Such suspension or termination of services is needed during emergencies, including Enjoy Game\u2019s efforts for maintenance of accounts and system security;</p>\n              <p class="p1">(5) Force majeure (in view of the special nature of Internet, forces majeures include hacker attack, major impacts due to technical adjustment of telecommunication department, temporary shutdown due to government regulation and virus attack which may interrupt the normal operation of Internet);</p>\n              <p class="p1">(6) Other situations beyond the control of Enjoy Game.</p>\n\n              <p>9. Both you and Enjoy Game agree to the following treatments when any of the above circumstances occurs:</p>\n              <p class="p1">(1) Already generated and unused paid services will be automatically cleared without being exchanged into cash;</p>\n              <p class="p1">(2) Enjoy Game will reasonably handle your ongoing transactions on Enjoy Game platform as the case may be;</p>\n              <p class="p1">(3) Unless otherwise indicated in laws or regulations, or specified by Enjoy Game, charges paid to Enjoy Game will not be refunded;</p>\n              <p class="p1">(4) Enjoy Game has the right to hold you accountable for corresponding liabilities for breach of agreement if this Agreement is terminated due to your violation;</p>\n              <p class="p1">(5) Unless otherwise indicated in laws or regulations, or specified by Enjoy Game, Enjoy Game assumes no responsibility for you or any other third party.</p>\n\n              <p>10. You acknowledge and confirm that the service you paid for as a Visitor will be bound to the device you used paying for the service, and can only be used on the bound device. Please bind your EG account following the operation guidance on the page if you wish to use the service on other devices.</p>\n              <p class="p1">(1) Paid services include reasonable time required for Enjoy Game to troubleshoot, repair the servers and make adjustments or upgrades. Enjoy Game will make compensation/remedy in any form for time required in the above situations or any loss so resulted (if any), but Enjoy Game will try to minimize the impacts.</p>\n              <p class="p1">(2) You hereby understand and exempt Enjoy Game from relevant liabilities if inconveniences arise due to differences in specific rights and services you receive because of differences in software versions, devices, operation systems or other third party reasons after payment. Enjoy Game suggests you solve this problem by upgrading the application program or operation system, changing your device, or contacting Enjoy Game directly through the contact information provided in this Agreement.</p>\n              <p class="p1">(3) All actions under your user account are deemed to be your own actions and you shall take full responsibility for all actions (whether they are intentional or non-intentional) when obtaining and using the services. Enjoy Game has the right to supervise and remind you during your acquiring and using of the services and other related activities. Enjoy Game has the right to rectify your actions in violation of laws and regulations or this Agreement, and hold you accountable for related liabilities.</p>\n              <p class="p1">(4) You acknowledge and agree to obtain services by following the flows and platform rules officially published by Enjoy Game, and not obtain or assist others to obtain the services using any of the following methods. Otherwise, Enjoy Game has the right to decline your application, revoke related service qualifications, refuse to provide you services or terminate such services without notifying you, nor making compensation/remedy in any form. Enjoy Game also has the right to hold you accountable for related legal liabilities:</p>\n              <p class="p1">(5) Obtain or use or assist others to obtain or use Enjoy Game services for commercial or any other non-personal purposes without explicit authorization from Enjoy Game;</p>\n              <p class="p1">(6) Obtain services, contents or data through any automatic programs, scripts or software including robot software, spider software and crawler software without explicit authorization from Enjoy Game;</p>\n              <p class="p1">(7) Alter the service content, service period, sum of consumption, transaction status and other information using technical means without specific authorization from Enjoy Game;</p>\n              <p class="p1">(8) Transfer the services among Enjoy Game accounts via unauthorized methods of Enjoy Game, or grant, borrow, rent, sell or transfer the service qualification without explicit authorization from Enjoy Game;</p>\n              <p class="p1">(9) Reproduce, download, upload, alter, catalogue, sort out, translate, publish, develop, transfer, sell, present, transmit, synthesize, nest or link part or all of the service contents, or create derivative works from these contents for commercial development or promotion without explicit authorization from Enjoy Game;</p>\n              <p class="p1">(10) Crack, alter, anti-operate, tamper or damage any security measures adopted by Enjoy Game for the protection of its user services, or delete any declaration or label of ownership or intellectual property rights attached on Enjoy Game\u2019s service contents without prior written consent from Enjoy Game;</p>\n              <p class="p1">(11) Display part or all of the service contents in any public places for free or not without explicit authorization from Enjoy Game (except for cases in which your above behaviors do not constitute infringement);</p>\n              <p class="p1">(12) Use improper means or means in violation of the principle of honesty and credibility (such as means against the original purpose of Enjoy Game providing services/organizing activities, including utilizing loopholes in rules or system, misuse of membership, black industry or speculation);</p>\n              <p class="p1">(13) Use means in violation of legal rights of Enjoy Game or any other person;</p>\n              <p class="p1">(14) Other actions without Enjoy Game\u2019s explicit authorization or in violation of this Agreement, laws and regulations or regulatory policies.</p>\n\n              <p>11. You acknowledge and agree that Enjoy Game has the right to take one or more of the following measures at its sole discretion if you performed or, upon independent judgment by Enjoy Game, you are deemed to have performed any behaviors in violation of laws or regulations, regulatory policies or this Agreement, or behaviors that harmed the reputation and interests of Enjoy Game and/or its related companies:</p>\n              <p class="p1">(1) If this Agreement contains a separate clause regarding treatment of such behaviors, such clause shall apply;</p>\n              <p class="p1">(2) One or more measures will be adopted to restrain the consequences of your actions and behaviors without notifying you, such as deleting/blocking related links or contents, or restricting/cancelling your account/rights of using your account;</p>\n              <p class="p1">(3) Suspend or terminate part or all services without notifying you, and the charges you paid will not be refunded or compensated/remedied in any form;</p>\n              <p class="p1">(4) You shall bear all liabilities for damages and make payment within the time prescribed by Enjoy Game if your actions resulted in any loss to Enjoy Game and/or its related companies.</p>\n\n              <h4 style="margin-top:21px">Change in Agreement</h4>\n\n              <p class="p1">1. Enjoy Game has the right to change contents in this Agreement and will notify the users on relevant pages or in other reasonable manners. You are deemed to be notified once the notice is sent.</p>\n              <p class="p1">2. You have the right to terminate your use of Enjoy Game\'s applications and its services if changes are made to this Agreement yet you don\'t agree with such changes. However, you\'ll be deemed as fully agree with all changed contents should you keep using Enjoy Game\'s applications and services after the changed agreement takes effect.</p>'
	        }
	};

/***/ }),

/***/ 189:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    pleaseLogin: {
	        'zh-CN': '您好，请登录',
	        'zh-TW': '您好，請登錄',
	        'en-US': 'Login',
	        'th-TH': 'ล็อกอิน',
	        'vi-VN': 'Hãy đăng nhập'
	    },
	    register: {
	        'zh-CN': '注册账号',
	        'zh-TW': '註冊帳號',
	        'en-US': 'Register',
	        'th-TH': 'การลงทะเบียน',
	        'vi-VN': 'Đăng ký'
	    },
	    userRegister: {
	        'zh-CN': '注册',
	        'zh-TW': '註冊',
	        'en-US': 'Register',
	        'th-TH': 'ลงทะเบียนทันที',
	        'vi-VN': 'Đăng ký'
	    },
	    login: {
	        'zh-CN': '登录',
	        'zh-TW': '登錄',
	        'en-US': 'Sign in',
	        'th-TH': 'ล็อกอินบัญชี',
	        'vi-VN': 'Đăng nhập'
	    },
	    loginEgAccount: {
	        'zh-CN': '登录账号',
	        'zh-TW': '登錄賬號',
	        'en-US': 'Sign in',
	        'th-TH': 'ล็อกอินบัญชี',
	        'vi-VN': 'Đăng nhập'
	    },
	    rememberAccount: {
	        'zh-CN': '记住账号',
	        'zh-TW': '記住賬號',
	        'en-US': 'Remember me',
	        'th-TH': 'จำบัญชี',
	        'vi-VN': 'Ghi nhớ tài khoản'
	    },
	    captchaCodeError: {
	        'zh-CN': '验证码错误',
	        'zh-TW': '驗證碼錯誤',
	        'en-US': 'Captcha error',
	        'th-TH': 'รหัสยืนยันผิด',
	        'vi-VN': 'Lỗi mã xác nhận'
	    },
	    inputAccount: {
	        'zh-CN': '请输入账号',
	        'zh-TW': '請輸入賬號',
	        'en-US': 'Please enter account',
	        'th-TH': 'โปรดกรอกบัญชี',
	        'vi-VN': 'Nhập Tài Khoản'
	    },
	    inputPassword: {
	        'zh-CN': '请输入密码',
	        'zh-TW': '請輸入密碼',
	        'en-US': 'Please enter password',
	        'th-TH': 'โปรดกรอกรหัส',
	        'vi-VN': 'Nhập mật khẩu'
	    },
	    inputCaptcha: {
	        'zh-CN': '请输入验证码',
	        'zh-TW': '請輸入驗證碼',
	        'en-US': 'Please enter captcha',
	        'th-TH': 'โปรดกรอกรหัสยืนยัน',
	        'vi-VN': 'Nhận mã xác nhận'
	    },
	    logout: {
	        'zh-CN': '退出',
	        'zh-TW': '退出',
	        'en-US': 'Logout',
	        'th-TH': 'ออก',
	        'vi-VN': 'Đăng xuất'
	    },
	    egPoint: {
	        'zh-CN': 'EG点',
	        'zh-TW': 'EG點',
	        'en-US': 'EG Points',
	        'th-TH': 'แต้มEG',
	        'vi-VN': 'Điểm EG'
	    },
	    rewardEgPoint: {
	        'zh-CN': '奖励EG点',
	        'zh-TW': '奖励EG點',
	        'en-US': 'Reward EG Points',
	        'th-TH': 'แต้มEG',
	        'vi-VN': 'Điểm EG'
	    },
	    buyGoods: {
	        'zh-CN': '购买商品',
	        'zh-TW': '購買商品',
	        'en-US': 'Purchase',
	        'th-TH': 'ซื้อสินค้า',
	        'vi-VN': 'Mua hàng'
	    },
	    egRecharge: {
	        'zh-CN': 'EG点充值',
	        'zh-TW': 'EG點充值',
	        'en-US': 'EG Recharge',
	        'th-TH': 'แต้มEGเติมเงิน',
	        'vi-VN': 'Nạp điểm EG'
	    },
	    consumeRecords: {
	        'zh-CN': '商品交易记录',
	        'zh-TW': '商品交易記錄',
	        'en-US': 'Transaction Records',
	        'th-TH': 'บันทึกการซื้อของ',
	        'vi-VN': 'Lịch sử mua hàng'
	    },
	    rechargeRecords: {
	        'zh-CN': 'EG点充值记录',
	        'zh-TW': 'EG點充值記錄',
	        'en-US': 'Recharge Records',
	        'th-TH': 'บันทึกเติมแต้มEG',
	        'vi-VN': 'Kỷ lục Recharge điểm EG'
	    },
	    noGames: {
	        'zh-CN': '暂无可用的游戏',
	        'zh-TW': '暫無可用的遊戲',
	        'en-US': 'No games available',
	        'th-TH': 'ยังไม่มีเกมเล่นได้',
	        'vi-VN': 'không có trò chơi'
	    },
	    noGoods: {
	        'zh-CN': '该游戏暂无商品',
	        'zh-TW': '該遊戲暫無商品',
	        'en-US': 'No goods available',
	        'th-TH': 'เกมนี้ยังไม่มีสินค้า',
	        'vi-VN': 'Không có hàng'
	    },
	    statusAll: {
	        'zh-CN': '所有订单',
	        'zh-TW': '所有訂單',
	        'en-US': 'All',
	        'th-TH': 'ใบสั่งทั้งหมด',
	        'vi-VN': 'Tất cả đơn hàng'
	    },
	    statusPending: {
	        'zh-CN': '支付中',
	        'zh-TW': '支付中',
	        'en-US': 'Pending',
	        'th-TH': 'ชำระอยู่',
	        'vi-VN': 'Đang thanh toán'
	    },
	    statusSuccess: {
	        'zh-CN': '已完成',
	        'zh-TW': '已完成',
	        'en-US': 'Success',
	        'th-TH': 'สำเร็จแล้ว',
	        'vi-VN': 'Đã hoàn thành'
	    },
	    statusFail: {
	        'zh-CN': '已失败',
	        'zh-TW': '已失敗',
	        'en-US': 'Failed',
	        'th-TH': 'ล้มเหลว',
	        'vi-VN': 'Thất bại'
	    },
	    orderDate: {
	        'zh-CN': '订单时间',
	        'zh-TW': '訂單時間',
	        'en-US': 'Order Date',
	        'th-TH': 'เวลาใบสั่ง',
	        'vi-VN': 'Ngày đặt hàng'
	    },
	    search: {
	        'zh-CN': '查询',
	        'zh-TW': '查詢',
	        'en-US': 'Search',
	        'th-TH': 'ตรวจ',
	        'vi-VN': 'Kiểm tra'
	    },
	    selectDateRange: {
	        'zh-CN': '选择日期范围',
	        'zh-TW': '選擇日期範圍',
	        'en-US': 'Select Date Range',
	        'th-TH': 'เลือกขอบเขตเวลา',
	        'vi-VN': 'Chọn phạm vi ngày'
	    },
	    selectChannel: {
	        'zh-CN': '请选择支付方式',
	        'zh-TW': '請選擇支付方式',
	        'en-US': 'Select payment method',
	        'th-TH': 'เลือกวิธีชำระ',
	        'vi-VN': 'Hãy chọn phương thức thanh toán'
	    },
	    selectChannelNew: {
	        'zh-CN': 'LunaM預註冊點卡兌換',
	        'zh-TW': 'LunaM預註冊點卡兌換',
	        'en-US': 'LunaM pre-registration point card exchange',
	        'th-TH': 'LunaM pre-registration point card exchange',
	        'vi-VN': 'Trao đổi thẻ đăng ký trước LunaM'
	    },
	    purchase: {
	        'zh-CN': '购买',
	        'zh-TW': '購買',
	        'en-US': 'Purchase',
	        'th-TH': 'ซื้อ',
	        'vi-VN': 'Mua'
	    },
	    changeCaptcha: {
	        'zh-CN': '看不清，换一张',
	        'zh-TW': '看不清，換一張',
	        'en-US': 'Unclear? Another one',
	        'th-TH': 'เห็นไม่ชัด เปลี่ยนอื่น',
	        'vi-VN': 'Nhìn không rõ, thay đổi một'
	    },
	    recordDate: {
	        'zh-CN': '交易时间',
	        'zh-TW': '交易時間',
	        'en-US': 'Exchange Date',
	        'th-TH': 'เวลาซื้อขาย',
	        'vi-VN': 'Thời gian đặt hàng'
	    },
	    appName: {
	        'zh-CN': '应用名称',
	        'zh-TW': '應用名稱',
	        'en-US': 'App Name',
	        'th-TH': 'ชื่อApp',
	        'vi-VN': 'Tên ứng dùng'
	    },
	    goodsName: {
	        'zh-CN': '商品名称',
	        'zh-TW': '商品名稱',
	        'en-US': 'Goods Name',
	        'th-TH': 'ชื่อสินค้า',
	        'vi-VN': 'Tên hàng'
	    },
	    goodsPrice: {
	        'zh-CN': '商品价格',
	        'zh-TW': '商品價格',
	        'en-US': 'Goods Price',
	        'th-TH': 'ราคาสินค้า',
	        'vi-VN': 'Giá hàng'
	    },
	    orderId: {
	        'zh-CN': '订单号',
	        'zh-TW': '訂單號',
	        'en-US': 'Order ID',
	        'th-TH': 'IDใบสั่ง',
	        'vi-VN': 'Số đơn hàng'
	    },
	    orderStatus: {
	        'zh-CN': '订单状态',
	        'zh-TW': '訂單狀態',
	        'en-US': 'Order Status',
	        'th-TH': 'สภาพใบสั่ง',
	        'vi-VN': ' Trạng thái đơn hàng'
	    },
	    rechargeChannel: {
	        'zh-CN': '充值渠道',
	        'zh-TW': '儲值渠道',
	        'en-US': 'Pay Channel',
	        'th-TH': 'ช่องทางเติมเงิน',
	        'vi-VN': 'Kênh nạp thẻ'
	    },
	    rechargeAmount: {
	        'zh-CN': '充值金额',
	        'zh-TW': '儲值金額',
	        'en-US': 'Amount',
	        'th-TH': 'จำนวนเติมเงิน',
	        'vi-VN': 'Mệnh giá nạp'
	    },
	    confirmOrder: {
	        'zh-CN': '订单确认',
	        'zh-TW': '訂單確認',
	        'en-US': 'Confirm Order',
	        'th-TH': 'ยืนยันใบสั่ง',
	        'vi-VN': 'Xác nhận'
	    },
	    gameArea: {
	        'zh-CN': '游戏大区',
	        'zh-TW': '遊戲大廳',
	        'en-US': 'Game Area',
	        'th-TH': 'เขต',
	        'vi-VN': 'Khu vực game'
	    },
	    gameServer: {
	        'zh-CN': '游戏区服',
	        'zh-TW': '遊戲區服',
	        'en-US': 'Game Server',
	        'th-TH': 'โซน',
	        'vi-VN': 'Máy chủ'
	    },
	    roleName: {
	        'zh-CN': '角色名称',
	        'zh-TW': '角色名稱',
	        'en-US': 'Character Name',
	        'th-TH': 'ชื่อตัวละคร',
	        'vi-VN': 'Tên nhân vật'
	    },
	    loginPassword: {
	        'zh-CN': '登录密码',
	        'zh-TW': '登錄密碼',
	        'en-US': 'Login Password',
	        'th-TH': 'รหัสล็อกอิน',
	        'vi-VN': 'Mật khẩu'
	    },
	    confirmBuy: {
	        'zh-CN': '确定购买',
	        'zh-TW': '確定購買',
	        'en-US': 'Confirm',
	        'th-TH': 'ยืนยันซื้อ',
	        'vi-VN': 'xác nhận'
	    },
	    cancelBuy: {
	        'zh-CN': '取消购买',
	        'zh-TW': '取消購買',
	        'en-US': 'Cancel',
	        'th-TH': 'ยกเลิก',
	        'vi-VN': 'Hủy'
	    },
	    areaAsia: {
	        'zh-CN': '亚太',
	        'zh-TW': '亞太',
	        'en-US': 'Asia Oceania',
	        'th-TH': 'เอเชียแปซิฟิก',
	        'vi-VN': 'Đông Nam Á'
	    },
	    areaAmerica: {
	        'zh-CN': '北美/南美',
	        'zh-TW': '北美/南美',
	        'en-US': 'North America/South America',
	        'th-TH': 'อเมริกาเหนือ/อเมริกาใต้',
	        'vi-VN': 'Bắc/Nam Mỹ'
	    },
	    areaEurope: {
	        'zh-CN': '欧洲/非洲',
	        'zh-TW': '歐洲/非洲',
	        'en-US': 'Europe/Africa',
	        'th-TH': 'ยุโรป/แอฟริกา',
	        'vi-VN': 'Châu Âu/ Châu Phi'
	    },
	    selectGameServer: {
	        'zh-CN': '请选择游戏区服',
	        'zh-TW': '請選擇遊戲區服',
	        'en-US': 'Select game server',
	        'th-TH': 'กรุณาเลือกโซน',
	        'vi-VN': 'Chọn Khu vực'
	    },
	    use: {
	        'zh-CN': '用',
	        'zh-TW': '用',
	        'en-US': 'Use ',
	        'th-TH': 'ใช้',
	        'vi-VN': 'Sử dùng'
	    },
	    buyEgPoint: {
	        'zh-CN': '购买EG点',
	        'zh-TW': '購買EG點',
	        'en-US': ' Buy EG Points',
	        'th-TH': 'ซื้อแต้มEG',
	        'vi-VN': 'Mua điểm EG'
	    },
	    cardNo: {
	        'zh-CN': '卡号',
	        'zh-TW': '卡號',
	        'en-US': 'Card',
	        'th-TH': 'การ์ด',
	        'vi-VN': 'Số thẻ'
	    },
	    serialNo: {
	        'zh-CN': '序列号',
	        'zh-TW': '序列號',
	        'en-US': 'Serial',
	        'th-TH': 'ซีเรียล',
	        'vi-VN': 'Số xê ri'
	    },
	    cardNotEmpty: {
	        'zh-CN': '卡号不能为空',
	        'zh-TW': '卡號不能為空',
	        'en-US': 'Card is needed',
	        'th-TH': 'การ์ดเป็นช่องว่างไม่ได้',
	        'vi-VN': 'Số thể không được để trống'
	    },
	    serialNotEmpty: {
	        'zh-CN': '序列号不能为空',
	        'zh-TW': '序列號不能為空',
	        'en-US': 'Serial is needed',
	        'th-TH': 'ซีเรียลเป็นช่องว่างไม่ได้',
	        'vi-VN': 'Số xê ri không được để trống'
	    },
	    selectCurrency: {
	        'zh-CN': '请选择币种',
	        'zh-TW': '請選擇幣種',
	        'en-US': 'Select currency',
	        'th-TH': 'โปรดเลือกสกุลเงิน',
	        'vi-VN': 'Chọn loại tiền tệ'
	    },
	    rechargeSuccess: {
	        'zh-CN': '充值成功',
	        'zh-TW': '儲值成功',
	        'en-US': 'Recharge Success',
	        'th-TH': 'เติมเงินสำเร็จ',
	        'vi-VN': 'Thanh toán thành công'
	    },
	    rechargeSuccessAmount: {
	        'zh-CN': '成功充值',
	        'zh-TW': '成功儲值',
	        'en-US': 'Recharge Success：',
	        'th-TH': 'สำเร็จเติมเงิน',
	        'vi-VN': 'Thanh toán thành công'
	    },
	    rechargeFinish: {
	        'zh-CN': '充值完成',
	        'zh-TW': '儲值完成',
	        'en-US': 'Recharge Finish',
	        'th-TH': 'เติมเงินเสร็จแล้ว',
	        'vi-VN': 'Hoàn thành'
	    },
	    rechargeFinishCheckLater: {
	        'zh-CN': '充值完成，请稍后查询充值结果',
	        'zh-TW': '儲值完成，請稍後查詢儲值結果',
	        'en-US': 'Recharge finish, check recharge result later',
	        'th-TH': 'เติมเงินเสร็จแล้ว โปรดตรวจผลทีหลัง',
	        'vi-VN': 'Bạn đã thanh toán thành công,vui lòng một lát nữa kiểm tra kết quả nạp tiền.'
	    },
	    rechargeCancel: {
	        'zh-CN': '充值取消',
	        'zh-TW': '儲值取消',
	        'en-US': 'Recharge Cancel',
	        'th-TH': 'ยกเลิกเติมเงิน',
	        'vi-VN': 'Hủy thanh toán '
	    },
	    rechargeCancelQuestAgain: {
	        'zh-CN': '充值取消，如需充值请再次发起请求',
	        'zh-TW': '儲值取消，如需儲值請再次發起請求',
	        'en-US': 'Recharge canceled, try again',
	        'th-TH': 'ยกเลิกเติมเงิน ถ้าอยากเติมเงินกรุณาลองใหม่',
	        'vi-VN': 'thanh toán bị hủy. Nếu bạn cần nạp vui lòng thử lại.'
	    },
	    rechargeFail: {
	        'zh-CN': '充值失败',
	        'zh-TW': '儲值失敗',
	        'en-US': 'Recharge Fail',
	        'th-TH': 'เติมเงินล้มเหลว',
	        'vi-VN': 'thanh toán thất bại'
	    },
	    rechargeFailErrCode: {
	        'zh-CN': '充值失败，错误码为：',
	        'zh-TW': '儲值失敗，錯誤碼為：',
	        'en-US': 'Recharge fail, error code: ',
	        'th-TH': 'เติมเงินล้มเหลว codeคือ:',
	        'vi-VN': 'thanh toán thất bại,Mã lỗi là:'
	    },
	    createOrderFail: {
	        'zh-CN': '创建订单失败',
	        'zh-TW': '創建訂單失敗',
	        'en-US': 'Create Order Fail',
	        'th-TH': 'สร้างใบสั่งล้มเหลว',
	        'vi-VN': 'Tạo đơn hàng thất bại'
	    },
	    createOrderFailTryAgain: {
	        'zh-CN': '订单创建失败，请稍后再试',
	        'zh-TW': '創建訂單失敗，請稍後再試',
	        'en-US': 'Create order fail, try again later',
	        'th-TH': 'สร้างใบสั่งล้มเหลว กรุณาลองใหม่ทีหลัง',
	        'vi-VN': 'Tạo đơn hàng thất bại, hãy thử lại'
	    },
	    systemError: {
	        'zh-CN': '系统错误',
	        'zh-TW': '系統錯誤',
	        'en-US': 'System Error',
	        'th-TH': 'ระบบผิดพลาด',
	        'vi-VN': 'Lỗi hệ thống'
	    },
	    systemErrorTryLater: {
	        'zh-CN': '系统错误，请稍后再试',
	        'zh-TW': '系統錯誤，請稍後再試',
	        'en-US': 'System error, try again later',
	        'th-TH': 'ระบบผิดพลาด กรุณาลองใหม่ทีหลัง',
	        'vi-VN': 'Lỗi hệ thống, hãy thử lại'
	    },
	    confirm: {
	        'zh-CN': '确定',
	        'zh-TW': '確定',
	        'en-US': 'Confirm',
	        'th-TH': 'ยืนยัน',
	        'vi-VN': 'Xác nhận'
	    },
	    noRoleInServer: {
	        'zh-CN': '您在该服务器上无角色',
	        'zh-TW': '您在該服務器上無角色',
	        'en-US': 'No character in the server',
	        'th-TH': 'โซนนี้ไม่มีตัวละคร',
	        'vi-VN': 'Không có vai trò'
	    },
	    getRoleFail: {
	        'zh-CN': '获取角色信息失败',
	        'zh-TW': '獲取角色信息失敗',
	        'en-US': 'Get character fail',
	        'th-TH': 'ได้ข้อมูลตัวละครล้มเหลว',
	        'vi-VN': 'Không thể lấy thông tin vai trò'
	    },
	    noRoleMsg: {
	        'zh-CN': '无角色',
	        'zh-TW': '无角色',
	        'en-US': 'no role',
	        'th-TH': 'ไม่มีบทบาท',
	        'vi-VN': 'Không có vai trò'
	    },
	    getServerFail: {
	        'zh-CN': '获取服务器列表失败',
	        'zh-TW': '獲取服務器列表失敗',
	        'en-US': 'Get server list fail',
	        'th-TH': 'ได้รายการโซนล้มเหลว',
	        'vi-VN': 'Không thể lấy danh sách máy chủ'
	    },
	    pleaseInputPassword: {
	        'zh-CN': '请填写密码',
	        'zh-TW': '請填寫密碼',
	        'en-US': 'Please enter password',
	        'th-TH': 'โปรดกรอกรหัส',
	        'vi-VN': 'Nhập mật khẩu'
	    },
	    createGoodsOrderFail: {
	        'zh-CN': '创建订单失败！',
	        'zh-TW': '創建訂單失敗！',
	        'en-US': 'Create order fail',
	        'th-TH': 'สร้างใบสั่งล้มเหลว',
	        'vi-VN': 'Tạo đơn hàng thất bại'
	    },
	    buyGoodsSuccess: {
	        'zh-CN': '购买成功！',
	        'zh-TW': '購買成功！',
	        'en-US': 'Buy goods success',
	        'th-TH': 'ซื้อสำเร็จ',
	        'vi-VN': 'Thanh toán thành công'
	    },
	    buyGoodsFail: {
	        'zh-CN': '购买失败',
	        'zh-TW': '購買失敗',
	        'en-US': 'Buy goods fail',
	        'th-TH': 'ซื้อล้มเหลว',
	        'vi-VN': 'Thanh toán thất bại'
	    },
	    buyGoodsFailErrorCode: {
	        'zh-CN': '购买失败，错误码为：',
	        'zh-TW': '購買失敗，錯誤碼為：',
	        'en-US': 'Buy goods fail, error code: ',
	        'th-TH': 'ซื้อล้มเหลว codeคือ:',
	        'vi-VN': 'thanh toán thất bại,Mã lỗi là:'
	    },
	    networkError: {
	        'zh-CN': '网络错误，请稍后再试',
	        'zh-TW': '網絡錯誤，請稍後再試',
	        'en-US': 'Network error, try again later',
	        'th-TH': 'เคลือข่ายล้มเหลว กรุณาลองใหม่ทีหลัง',
	        'vi-VN': 'Bạn bị mất kết nối, hãy thử lại'
	    },
	    nextPage: {
	        'zh-CN': '下一页',
	        'zh-TW': '下一頁',
	        'en-US': 'Next',
	        'th-TH': 'หน้าถัดไป',
	        'vi-VN': 'Tiếp theo'
	    },
	    previewPage: {
	        'zh-CN': '上一页',
	        'zh-TW': '上一頁',
	        'en-US': 'Preview',
	        'th-TH': 'หน้าก่อนหน้า',
	        'vi-VN': 'Trang trước'
	    },
	    lastWeek: {
	        'zh-CN': '最近一周',
	        'zh-TW': '最近一周',
	        'en-US': 'Last week',
	        'th-TH': 'สัปดาห์ที่แล้ว',
	        'vi-VN': 'Tuần trước'
	    },
	    lastMonth: {
	        'zh-CN': '最近一个月',
	        'zh-TW': '最近一個月',
	        'en-US': 'Last month',
	        'th-TH': 'เดือนที่แล้ว',
	        'vi-VN': 'Tháng trước'
	    },
	    lastThreeMonth: {
	        'zh-CN': '最近三个月',
	        'zh-TW': '最近三個月',
	        'en-US': 'Last 3 months',
	        'th-TH': '3เดือนที่แล้ว',
	        'vi-VN': '3 tháng qua'
	    },
	    noRecords: {
	        'zh-CN': '无记录',
	        'zh-TW': '無記錄',
	        'en-US': 'No Records',
	        'th-TH': 'ไม่มีบันทึก',
	        'vi-VN': 'Không có hồ sơ'
	    },
	    downloadGame: {
	        'zh-CN': '下载游戏',
	        'zh-TW': '下載遊戲',
	        'en-US': 'Download Game',
	        'th-TH': 'ดาวโหลดเกม',
	        'vi-VN': 'Cài đặt'
	    },
	    passwordError: {
	        'zh-CN': '密码错误',
	        'zh-TW': '密碼錯誤',
	        'en-US': 'Password error',
	        'th-TH': 'Password error',
	        'vi-VN': 'Sai mật khẩu'
	    },
	    userNotExits: {
	        'zh-CN': '用户名不存在',
	        'zh-TW': '用戶名不存在',
	        'en-US': 'User not exists',
	        'th-TH': 'User not exists',
	        'vi-VN': 'Tên đăng nhập không tồn tại'
	    },
	    egPointNotEnough: {
	        'zh-CN': 'EG点数不足',
	        'zh-TW': 'EG點數不足',
	        'en-US': 'EG point not enough',
	        'th-TH': 'EG point not enough',
	        'vi-VN': 'Điểm EG không đủ'
	    },
	    isBlocked: {
	        'zh-CN': '此账号已被封禁，如需解禁请联系客服',
	        'zh-TW': '此賬號已被封禁，如需解禁請聯繫客服',
	        'en-US': 'This account is blocked, please contact CS',
	        'th-TH': 'บัญชีของคุณห้ามใช้แล้ว กรุณาติดต่อฝ่ายบริการลูกค้า',
	        'vi-VN': 'Tài khoản của bạn đã bị cấm. Nếu bạn cần gỡ bỏ lệnh cấm, vui lòng liên hệ với CSKH.'
	    },
	    payNow: {
	        'zh-CN': '前往支付渠道',
	        'zh-TW': '前往支付渠道',
	        'en-US': 'Pay now',
	        'th-TH': 'ไปสู่ช่องทางชำระ',
	        'vi-VN': 'Chuyển đến kênh thanh toán '
	    },
	    userIsExist: {
	        'zh-CN': '该用户名已存在',
	        'zh-TW': '該用戶名已存在',
	        'en-US': 'User name is already exist',
	        'th-TH': 'ชื่อผู้ใช้นี้มีอยู่แล้ว',
	        'vi-VN': 'Tên đăng nhập đã tồn tại'
	    },
	    service: {
	        'zh-CN': '服务条款',
	        'zh-TW': '服務條款',
	        'en-US': 'Service Policy',
	        'th-TH': 'รายาการบริการ',
	        'vi-VN': 'Điều khoản phục vụ'
	    },
	    notValid: {
	        'zh-CN': '请输入有效的账号和密码',
	        'zh-TW': '請輸入有效的賬號和密碼',
	        'en-US': 'Please enter valid account and password',
	        'th-TH': 'กรุณากรอกบัญชีและรหัสถูกต้อง',
	        'vi-VN': 'Hãy nhập tài khoản và mật khẩu chính xác'
	    },
	    selectService: {
	        'zh-CN': '请阅读并同意服务条款',
	        'zh-TW': '請閱讀並同意服務條款',
	        'en-US': 'Read and accept service policy',
	        'th-TH': 'กรุณาอ่านและยืนยันรายาการบริการ',
	        'vi-VN': ' Hãy đọc và đồng ý với điều khoản'
	    },
	    codeError: {
	        'zh-CN': '验证码超时',
	        'zh-TW': '驗證碼超時',
	        'en-US': 'Verification Code Timeout',
	        'th-TH': 'รหัสยืนยันหมดอายุ',
	        'vi-VN': 'Quá thời gian nhận mã xác nhận'
	    }
	};

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Home = function Home(resolve) {
	    return __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(347)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var About = function About(resolve) {
	    return __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(344)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Game = function Game(resolve) {
	    return __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(346)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Business = function Business(resolve) {
	    return __webpack_require__.e/* require */(9, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(345)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var News = function News(resolve) {
	    return __webpack_require__.e/* require */(8, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(348)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Store = function Store(resolve) {
	    return __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(352)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Consume = function Consume(resolve) {
	    return __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(365)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Recharge = function Recharge(resolve) {
	    return __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(367)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Records = function Records(resolve) {
	    return __webpack_require__.e/* require */(10, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(368)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var NewsDetail = function NewsDetail(resolve) {
	    return __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(349)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Result = function Result(resolve) {
	    return __webpack_require__.e/* require */(12, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(351)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Notice = function Notice(resolve) {
	    return __webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(350)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Refund = function Refund(resolve) {
	    return __webpack_require__.e/* require */(11, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(361)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	exports.default = [{
	    path: '/',
	    redirect: '/home'
	}, {
	    path: '/result',
	    meta: { auth: false },
	    component: Result
	}, {
	    path: '/home',
	    meta: { auth: false },
	    component: Home
	}, {
	    path: '/about',
	    meta: { auth: false },
	    component: About
	}, {
	    path: '/game',
	    meta: { auth: false },
	    component: Game
	}, {
	    path: '/business',
	    meta: { auth: false },
	    component: Business
	}, {
	    path: '/news',
	    meta: { auth: false },
	    component: News
	}, {
	    path: '/news/:id',
	    meta: { auth: false },
	    component: NewsDetail
	}, {
	    path: '/store',
	    component: Store,
	    children: [{
	        path: '',
	        redirect: 'recharge'
	    }, {
	        path: 'consume',
	        meta: { auth: false },
	        component: Consume
	    }, {
	        path: 'recharge',
	        meta: { auth: false },
	        component: Recharge,
	        name: 'recharge'
	    }, {
	        path: 'records/:type',
	        meta: { auth: true },
	        component: Records
	    }, {
	        path: '*',
	        redirect: 'consume'
	    }]
	}, {
	    path: '/notice/',
	    component: Notice,
	    children: [{
	        path: '',
	        redirect: 'refund'
	    }, {
	        path: 'refund',
	        meta: { auth: false },
	        component: Refund
	    }, {
	        path: '*',
	        redirect: 'refund'
	    }]
	}, {
	    path: '*',
	    redirect: 'home'
	}];

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(116);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _mutations = __webpack_require__(195);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _user = __webpack_require__(194);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _records = __webpack_require__(193);
	
	var _records2 = _interopRequireDefault(_records);
	
	var _consume = __webpack_require__(192);
	
	var _consume2 = _interopRequireDefault(_consume);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	    state: {
	        rechargeChannels: [],
	        showLoginPopup: false,
	        showRegisterPopup: false,
	        loginPath: '',
	        totalEg: '...',
	        totalRewardEg: '...'
	    },
	    mutations: _mutations2.default,
	    modules: {
	        user: _user2.default,
	        records: _records2.default,
	        consume: _consume2.default
	    }
	});

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(35);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(52);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations, _actions;
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _mutationTypes = __webpack_require__(16);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _consume = __webpack_require__(169);
	
	var _consume2 = _interopRequireDefault(_consume);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    state: {
	        appList: [],
	        goodsList: {},
	        playedGames: [],
	        serverList: {}
	    },
	    getters: {
	        areaList: function areaList() {
	            return {
	                1: _vue2.default.t('areaAsia'),
	                2: _vue2.default.t('areaAmerica'),
	                3: _vue2.default.t('areaEurope')
	            };
	        },
	        playedGamesList: function playedGamesList(state) {
	            var games = [];
	            state.playedGames.forEach(function (game) {
	                games.push(parseInt(game.id));
	            });
	            return games;
	        }
	    },
	    mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SET_APP_LIST, function (state, appList) {
	        state.appList = appList;
	    }), (0, _defineProperty3.default)(_mutations, types.SET_GOODS_LIST, function (state, goods) {
	        if (goods.appId !== 0) {
	            state.goodsList[goods.appId] = goods.goodsList;
	        }
	    }), (0, _defineProperty3.default)(_mutations, types.SET_USER_PLAYED_GAME, function (state, playedGames) {
	        state.playedGames = playedGames;
	    }), (0, _defineProperty3.default)(_mutations, types.SET_SERVER_LIST, function (state, server) {
	        if (!state.serverList[server.appId]) {
	            state.serverList[server.appId] = {};
	        }
	        state.serverList[server.appId][server.areaId] = server.serverList;
	    }), _mutations),
	    actions: (_actions = {}, (0, _defineProperty3.default)(_actions, types.GET_APP_LIST, function (_ref) {
	        var commit = _ref.commit;
	
	        return new _promise2.default(function (resolve, reject) {
	            _consume2.default.getAppList(function (appList) {
	                commit(types.SET_APP_LIST, appList);
	                resolve();
	            }, function (errorCode) {
	                reject(errorCode);
	            });
	        });
	    }), (0, _defineProperty3.default)(_actions, types.GET_GOODS_LIST, function (_ref2, appId) {
	        var commit = _ref2.commit;
	
	        return new _promise2.default(function (resolve, reject) {
	            _consume2.default.getGoodsList(appId, function (goods) {
	                commit(types.SET_GOODS_LIST, goods);
	                resolve(goods.goodsList);
	            }, function (errorCode) {
	                reject(errorCode);
	            });
	        });
	    }), (0, _defineProperty3.default)(_actions, types.GET_USER_PLAYED_GAME, function (_ref3, params) {
	        var commit = _ref3.commit;
	
	        return new _promise2.default(function (resolve, reject) {
	            _consume2.default.getPlayedGames(params, function (playedGames) {
	                commit(types.SET_USER_PLAYED_GAME, playedGames);
	                resolve();
	            }, function (errorCode) {
	                reject(errorCode);
	            });
	        });
	    }), (0, _defineProperty3.default)(_actions, types.GET_SERVER_LIST, function (_ref4, params) {
	        var commit = _ref4.commit;
	
	        return new _promise2.default(function (resolve, reject) {
	            _consume2.default.getServerList(params, function (serverList) {
	                var server = {
	                    appId: params.appId,
	                    areaId: params.areaId,
	                    serverList: serverList
	                };
	                commit(types.SET_SERVER_LIST, server);
	                resolve(serverList);
	            }, function (errorCode) {
	                reject(errorCode);
	            });
	        });
	    }), (0, _defineProperty3.default)(_actions, types.GET_ROLE_INFO, function (_ref5, params) {
	        var commit = _ref5.commit;
	
	        return new _promise2.default(function (resolve, reject) {
	            _consume2.default.getRoleInfo(params, function (roleInfo) {
	                resolve(roleInfo);
	            }, function (errorCode) {
	                reject(errorCode);
	            });
	        });
	    }), (0, _defineProperty3.default)(_actions, types.EG_BUY_GOODS, function (_ref6, params) {
	        var commit = _ref6.commit;
	
	        return new _promise2.default(function (resolve, reject) {
	            _consume2.default.egBuyGoods(params, function (apiResult) {
	                resolve(apiResult);
	            }, function (errorCode) {
	                reject(errorCode);
	            });
	        });
	    }), _actions)
	};

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(35);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(52);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutationTypes = __webpack_require__(16);
	
	var _records = __webpack_require__(170);
	
	var _records2 = _interopRequireDefault(_records);
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatDate(timestamp) {
	    if (!timestamp) return "";
	    timestamp = parseInt(timestamp);
	    var date = new Date(timestamp);
	    var year = date.getFullYear();
	    var month = date.getMonth() + 1;
	    var day = date.getDate();
	    var hour = date.getHours();
	    var minutes = date.getMinutes();
	    var seconds = date.getSeconds();
	    return year + '/' + formatNum(month) + '/' + formatNum(day) + ' ' + formatNum(hour) + ':' + formatNum(minutes) + ':' + formatNum(seconds);
	}
	
	function formatNum(num) {
	    var newNum = num + "";
	    if (newNum.length == 1) {
	        return "0" + newNum;
	    }
	    return newNum;
	}
	
	function getChannelName(channelId) {
	    var name = {
	        10001: 'Fortumo',
	        10002: 'Fortumo',
	        10003: 'Mol',
	        10004: 'Mol',
	        10005: 'BluePay',
	        10006: 'BluePay',
	        10007: 'Gash',
	        10008: '1Pay',
	        10009: 'VNPT',
	        10010: 'Mimopay',
	        10011: 'Mimopay',
	        10012: 'Codapay',
	        10013: 'Upay',
	        10014: 'MyCard',
	        10015: 'MyCard',
	        10016: 'PayPal',
	        10017: 'UniPin',
	        10018: 'UniPin',
	        10019: 'Paymentwall',
	        10020: '支付宝',
	        10022: '天天賺'
	    };
	    return name[parseInt(channelId)];
	}
	
	function getStatusName(statusCode) {
	    var status = statusCode + '';
	    var statusName = {
	        '0': _vue2.default.t('statusPending'),
	        '50': _vue2.default.t('statusPending'),
	        '100': _vue2.default.t('statusSuccess'),
	        '-50': _vue2.default.t('statusFail')
	    };
	    return statusName[status];
	}
	
	function formatRecords(recordsType, recordsData) {
	    if (recordsData.length == 0) {
	        return [];
	    }
	    var result = [];
	    for (var i = 0; i < recordsData.length; i++) {
	        var record = recordsData[i];
	        var newRecord = {};
	        newRecord.orderDate = formatDate(record.createDate);
	        if (recordsType == 'consume') {
	            newRecord.appName = record.appName;
	            newRecord.goodsName = record.goodsName;
	            newRecord.goodsPrice = record.currency + ' ' + record.totalMoney;
	        } else {
	            newRecord.channelName = getChannelName(record.payPlatformId);
	            newRecord.rechargeAmount = record.currency + ' ' + record.totalMoney;
	            newRecord.egPoint = record.egPoint;
	        }
	        newRecord.orderId = record.id;
	        newRecord.orderStatus = getStatusName(record.status);
	        result[i] = newRecord;
	    }
	    return result;
	}
	
	exports.default = {
	    state: {
	        consumeRecords: [],
	        rechargeRecords: []
	    },
	    getters: {
	        consumeRecordsList: function consumeRecordsList(state) {
	            var list = state.consumeRecords;
	            if (list.length === 0) {
	                return [];
	            }
	            return formatRecords('consume', list);
	        },
	        rechargeRecordsList: function rechargeRecordsList(state) {
	            var list = state.rechargeRecords;
	            if (list.length === 0) {
	                return [];
	            }
	            return formatRecords('recharge', list);
	        }
	    },
	    mutations: (0, _defineProperty3.default)({}, _mutationTypes.SET_RECORDS, function (state, records) {
	        if (records.recordsType === 'consume') {
	            state.consumeRecords = records.data;
	        } else {
	            state.rechargeRecords = records.data;
	        }
	    }),
	    actions: (0, _defineProperty3.default)({}, _mutationTypes.GET_RECORDS, function (_ref, params) {
	        var commit = _ref.commit;
	
	        return new _promise2.default(function (resolve, reject) {
	            _records2.default.getRecords(params, function (records) {
	                commit(_mutationTypes.SET_RECORDS, records);
	                resolve();
	            }, function (errorCode) {
	                reject(errorCode);
	            });
	        });
	    })
	};

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(35);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(52);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _keys = __webpack_require__(30);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(51);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(84);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _mutations, _actions;
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _mutationTypes = __webpack_require__(16);
	
	var _user = __webpack_require__(82);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    state: JSON.parse(sessionStorage.getItem('user')) || {},
	    mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.USER_LOGIN, function (state, user) {
	        sessionStorage.setItem('user', (0, _stringify2.default)(user));
	        (0, _assign2.default)(state, user);
	    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.USER_LOGOUT, function (state) {
	        sessionStorage.removeItem('user');
	        (0, _keys2.default)(state).forEach(function (k) {
	            return _vue2.default.delete(state, k);
	        });
	    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.USER_REGISTER, function (state, user) {
	        sessionStorage.setItem('user', (0, _stringify2.default)(user));
	        (0, _assign2.default)(state, user);
	    }), _mutations),
	    actions: (_actions = {}, (0, _defineProperty3.default)(_actions, _mutationTypes.USER_LOGIN, function (_ref, user) {
	        var commit = _ref.commit;
	
	        return new _promise2.default(function (resolve, reject) {
	            _user2.default.login(user, function (userInfo) {
	                commit(_mutationTypes.USER_LOGIN, userInfo);
	                resolve();
	            }, function (errorCode) {
	                reject(errorCode);
	            });
	        });
	    }), (0, _defineProperty3.default)(_actions, _mutationTypes.USER_REGISTER, function (_ref2, user) {
	        var commit = _ref2.commit;
	
	        return new _promise2.default(function (resolve, reject) {
	            _user2.default.register(user, function (userInfo) {
	                commit(_mutationTypes.USER_REGISTER, userInfo);
	                resolve();
	            }, function (errorCode) {
	                reject(errorCode);
	            });
	        });
	    }), (0, _defineProperty3.default)(_actions, _mutationTypes.USER_LOGOUT, function (_ref3) {
	        var commit = _ref3.commit;
	
	        commit(_mutationTypes.USER_LOGOUT);
	    }), _actions)
	};

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _user = __webpack_require__(82);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    storeRechargeChannels: function storeRechargeChannels(state, channels) {
	        state.rechargeChannels = channels;
	    },
	    controlLoginPopup: function controlLoginPopup(state, status) {
	        state.showLoginPopup = status;
	    },
	    controlRegisterPopup: function controlRegisterPopup(state, status) {
	        state.showRegisterPopup = status;
	    },
	    setLoginPath: function setLoginPath(state, path) {
	        state.loginPath = path;
	    },
	    getTotalEg: function getTotalEg(state) {
	        var uid = state.user.uid;
	        _user2.default.getEg(uid, function (res) {
	            state.totalEg = res.egPoint;
	            state.totalRewardEg = res.rewardEgPoint;
	        });
	    }
	};

/***/ }),

/***/ 290:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 291:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 296:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 303:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 306:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 339:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/mengguo_logo.ba3deeb.png";

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(306)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(139),
	  /* template */
	  __webpack_require__(384),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(296)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(374),
	  /* scopeId */
	  "data-v-23c248ac",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(303)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(154),
	  /* template */
	  __webpack_require__(381),
	  /* scopeId */
	  "data-v-44f4ac9e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 374:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', [_c('div', {
	    staticClass: "footer-logo-wrapper"
	  }, [_c('span', {
	    staticClass: "footer-left-logo-mengguo"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "footer-left-logo"
	  })])])
	}]}

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "header-nav"
	  }, [_c('router-link', {
	    staticClass: "nav-item",
	    attrs: {
	      "to": "/home",
	      "onclick": "gaStat('导航', '首页')"
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('home')) + "\n        ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "nav-item",
	    attrs: {
	      "to": "/about",
	      "onclick": "gaStat('导航', '关于我们')"
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('about')) + "\n        ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "nav-item",
	    attrs: {
	      "to": "/game",
	      "onclick": "gaStat('导航', '游戏中心')"
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('center')) + "\n        ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "nav-item",
	    attrs: {
	      "to": "/business",
	      "onclick": "gaStat('导航', '商务合作')"
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('business')) + "\n        ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "nav-item",
	    attrs: {
	      "to": "/news",
	      "onclick": "gaStat('导航', '新闻资讯')"
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('news')) + "\n        ")])], 1), _vm._v(" "), (_vm.global.isTest) ? _c('button', {
	    staticClass: "btn",
	    staticStyle: {
	      "min-width": "80px"
	    },
	    on: {
	      "click": _vm.clearCache
	    }
	  }, [_vm._v("清除缓存")]) : _vm._e(), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.value4),
	      expression: "value4"
	    }],
	    domProps: {
	      "value": (_vm.value4)
	    },
	    on: {
	      "change": _vm.changeLang,
	      "input": function($event) {
	        _vm.value4 = $event
	      }
	    }
	  }, _vm._l((_vm.options), function(item) {
	    return _c('el-option', {
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    }, [_vm._v(_vm._s(item.label))])
	  }))], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "header-logo"
	  }, [_c('div', {
	    staticClass: "eg-logo",
	    staticStyle: {
	      "text-decoration": "none",
	      "min-width": "460px"
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "margin": "0 10px 0 0"
	    },
	    attrs: {
	      "src": __webpack_require__(340),
	      "width": "185"
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(339)
	    }
	  })])])
	}]}

/***/ }),

/***/ 384:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('view-header'), _vm._v(" "), _c('div', {
	    staticClass: "page-wrapper",
	    attrs: {
	      "id": "page-wrapper"
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('view-footer')], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 403:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.3a6b8d6ece176cc65ab9.js